(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78bf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78bf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a9AlG", function(module, exports) {

var $4udDG = parcelRequire("4udDG");

var $2b6Uo = parcelRequire("2b6Uo");






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("3eBkK")), (parcelRequire("6LC1i")), (parcelRequire("9pNai")), (parcelRequire("cd3AS")), (parcelRequire("7FjWB")), (parcelRequire("7j8im")));
    else {
        // browser global
        var _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != 'undefined' ? window : undefined, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    var getComputedStyle = window1.getComputedStyle, console = window1.console;
    var jQuery = window1.jQuery;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Flickity intances
    var instances = {};
    function Flickity(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error("Bad element for Flickity: ".concat(queryElement || element));
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = (0, $4udDG._)({}, this.constructor.defaults);
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    var proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        var _this_options = this.options, resize = _this_options.resize, watchCSS = _this_options.watchCSS, rightToLeft = _this_options.rightToLeft;
        // add id for Flickity.data
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
        this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(var eventName in this.options.on){
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(var method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        var _this_slider;
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements(this.element.children);
        (_this_slider = this.slider).append.apply(_this_slider, (0, $2b6Uo._)(cellElems));
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        var slider = document.createElement('div');
        slider.className = 'flickity-slider';
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        var cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map(function(cellElem) {
            return new Cell(cellElem);
        });
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        var _this = this;
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach(function(cell) {
            cell.x = cellX;
            _this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            _this.maxCellHeight = Math.max(cell.size.outerHeight, _this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        var sideOffset = this.options.rightToLeft ? -1 : 1;
        var renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        var positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = "translateX( ".concat(positionValue, " )");
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach(function(cell) {
            return cell.getSize();
        });
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        var _this = this;
        this.slides = [];
        if (!this.cells.length) return;
        var _this1 = this, beginMargin = _this1.beginMargin, endMargin = _this1.endMargin;
        var slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function(cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, _this.cellAlign);
                _this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if (!groupCells) return function() {
            return false;
        };
        if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt(groupCells, 10);
            return function(i) {
                return i % number !== 0;
            };
        }
        // default, group by width of slide
        var percent = 1;
        // parse '75%
        var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        var groupWidth = (this.size.innerWidth + 1) * percent;
        return function(i, slideWidth) {
            return slideWidth <= groupWidth;
        };
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        var _this_options = this.options, cellAlign = _this_options.cellAlign, rightToLeft = _this_options.rightToLeft;
        var shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = "".concat(height, "px");
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        var beforeGapX = this.cursorPosition;
        var lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        var afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        var wrapAround = this.options.wrapAround;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== 'fill') return true;
        // check that slides can fit
        var gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // check that content width - shifting cell is bigger than viewport width
            for(var _iterator = this.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cell = _step.value;
                if (cell.size.outerWidth > gapWidth) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while(gapX > 0){
            var cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        var _this = this;
        var isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        var contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach(function(slide) {
            slide.target = contentWidth * _this.cellAlign;
        });
        else {
            // contain to bounds
            var beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach(function(slide) {
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            var $event = type;
            if (event) {
                // create jQuery event
                var jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    var unidraggerEvents = [
        'dragStart',
        'dragMove',
        'dragEnd',
        'pointerDown',
        'pointerMove',
        'pointerEnd',
        'staticClick'
    ];
    var _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === 'staticClick') {
            // add cellElem and cellIndex args to staticClick
            var clickedCell = this.getParentCell(args[0].target);
            var cellElem = clickedCell && clickedCell.element;
            var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        var isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
        var event = args.shift(0);
        var jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        var _this = this, selectedIndex = _this.selectedIndex, slideableWidth = _this.slideableWidth, length = _this.slides.length;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            var wrapIndex = utils.modulo(index, length);
            // go to shortest
            var delta = Math.abs(wrapIndex - selectedIndex);
            var backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            var forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        var slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            var cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        var index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        var cell = this.queryCell(value);
        if (!cell) return;
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        var cellSlide = this.slides.find(function(slide) {
            return slide.cells.includes(cell);
        });
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // loop through cells to get the one that matches
            for(var _iterator = this.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cell = _step.value;
                if (cell.element === elem) return cell;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        var _this = this;
        elems = utils.makeArray(elems);
        return elems.map(function(elem) {
            return _this.getCell(elem);
        }).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        var cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        var closest = elem.closest('.flickity-slider > *');
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        var cellElems = [];
        for(var i = index - adjCount; i <= index + adjCount; i++){
            var slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        var isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        var afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes('flickity')) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        var activeElement = document.activeElement;
        var handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        var isFocused = this.focusableElems.some(function(elem) {
            return activeElement === elem;
        });
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function ArrowLeft() {
            this.uiChange();
            var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this[leftMethod]();
        },
        ArrowRight: function ArrowRight() {
            this.uiChange();
            var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        var // move child elements back into element
        _this_element;
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function(cell) {
            return cell.destroy();
        });
        this.viewport.remove();
        (_this_element = this.element).append.apply(_this_element, (0, $2b6Uo._)(this.slider.children));
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, 'flickity');
    var jQueryBridget = window1.jQueryBridget;
    if (jQuery && jQueryBridget) jQueryBridget('flickity', Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("4udDG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $34448b2f636abc71$export$71511d61b312f219; });

var $9HFeY = parcelRequire("9HFeY");
function $34448b2f636abc71$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9HFeY._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("9HFeY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $71081ebd7d211bed$export$71511d61b312f219; });
function $71081ebd7d211bed$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("2b6Uo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1961f7bca441a4c6$export$71511d61b312f219; });

var $jWe67 = parcelRequire("jWe67");

var $f2mBX = parcelRequire("f2mBX");

var $2g5td = parcelRequire("2g5td");

var $ghR52 = parcelRequire("ghR52");
function $1961f7bca441a4c6$export$71511d61b312f219(arr) {
    return (0, $jWe67._)(arr) || (0, $f2mBX._)(arr) || (0, $ghR52._)(arr) || (0, $2g5td._)();
}

});
parcelRegister("jWe67", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e83e5e97102e2c54$export$71511d61b312f219; });

var $2bDqK = parcelRequire("2bDqK");
function $e83e5e97102e2c54$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2bDqK._)(arr);
}

});
parcelRegister("2bDqK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $197b31e54e99ed29$export$71511d61b312f219; });
function $197b31e54e99ed29$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("f2mBX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af28950850a78917$export$71511d61b312f219; });
function $af28950850a78917$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("2g5td", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1a5151a9158d4e3a$export$71511d61b312f219; });
function $1a5151a9158d4e3a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ghR52", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bdb768849265fd3d$export$71511d61b312f219; });

var $2bDqK = parcelRequire("2bDqK");
function $bdb768849265fd3d$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2bDqK._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2bDqK._)(o, minLen);
}

});


parcelRegister("3eBkK", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var listener = _step.value;
                var isOnce = onceListeners && onceListeners[listener];
                if (isOnce) {
                    // remove listener
                    // remove before trigger to prevent recursion
                    this.off(eventName, listener);
                    // unset once flag
                    delete onceListeners[listener];
                }
                // trigger listener
                listener.apply(this, args);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("6LC1i", function(module, exports) {

var $22yUM = parcelRequire("22yUM");
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach(function(measurement) {
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        var isElement = elem && (typeof elem === "undefined" ? "undefined" : (0, $22yUM._)(elem)) == 'object' && elem.nodeType;
        if (!isElement) return;
        var style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        measurements.forEach(function(measurement) {
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});
parcelRegister("22yUM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17c6da0aa640e82f$export$71511d61b312f219; });
function $17c6da0aa640e82f$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("9pNai", function(module, exports) {

var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");
/**
 * BUG: Zeile 20 this wurde mit global überschrieben. siehe: https://github.com/metafizzy/fizzy-ui-utils/issues/15
 *
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(global1);
    else // browser global
    global1.fizzyUIUtils = factory(global1);
/// UO CHANGED LINE replaced this with global
// }( this, function factory( global ) {
})($parcel$global, function factory(global1) {
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = (typeof obj === "undefined" ? "undefined" : (0, $22yUM._)(obj)) == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return (0, $2b6Uo._)(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter(function(elem) {
            return elem instanceof HTMLElement;
        }).reduce(function(ffElems, elem) {
            var _ffElems;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = (_ffElems = ffElems).concat.apply(_ffElems, (0, $2b6Uo._)(childElems));
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            var _this = this;
            clearTimeout(this[timeoutName]);
            var args = arguments;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener('DOMContentLoaded', onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    var console = global1.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll("[".concat(dataAttr, "]"));
            var jQuery = global1.jQuery;
            (0, $2b6Uo._)(dataAttrElems).forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error("Error parsing ".concat(dataAttr, " on ").concat(elem.className, ": ").concat(error));
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("cd3AS", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("6LC1i")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(getSize) {
    var cellClassName = 'flickity-cell';
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    var proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("7FjWB", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != 'undefined' ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    var proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach(function(cell) {
            return cell.select();
        });
    };
    proto.unselect = function() {
        this.cells.forEach(function(cell) {
            return cell.unselect();
        });
    };
    proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    return Slide;
});

});

parcelRegister("7j8im", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("9pNai")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    var proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        var _this = this;
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(function() {
            return _this.animate();
        });
    };
    proto.positionSlider = function() {
        var x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        var translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? "translate3d(".concat(translateX, ",0,0)") : "translateX(".concat(translateX, ")");
    };
    proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if (!firstSlide) return;
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        var isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        var _this = this;
        cells.forEach(function(cell) {
            var cellShift = gap > 0 ? shift : 0;
            _this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        var _this = this;
        if (!cells || !cells.length) return;
        cells.forEach(function(cell) {
            return _this._wrapShiftCell(cell, 0);
        });
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("efOuG", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("a9AlG")), (parcelRequire("61zEy")), (parcelRequire("9pNai")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    var proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = '';
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        this.on('pointerDown', this.handlePointerDown);
        this.on('pointerUp', this.handlePointerUp);
        this.on('pointerDown', this.handlePointerDone);
        this.on('dragStart', this.handleDragStart);
        this.on('dragMove', this.handleDragMove);
        this.on('dragEnd', this.handleDragEnd);
        this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle('is-draggable', this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        var isTouchStart = event.type === 'touchstart';
        var isTouchPointer = event.pointerType === 'touch';
        var isFocusNode = event.target.matches('input, textarea, select');
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        var freeScroll = this.options.freeScroll;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        function(dist, minDist) {
            return dist <= minDist;
        } : function(dist, minDist) {
            return dist < minDist;
        };
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("61zEy", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("3eBkK")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    var proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    var startEvent, activeEvents;
    if ('ontouchstart' in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        activeEvents = [
            'touchmove',
            'touchend',
            'touchcancel'
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = 'pointerdown';
        activeEvents = [
            'pointermove',
            'pointerup',
            'pointercancel'
        ];
    } else {
        // mouse events
        startEvent = 'mousedown';
        activeEvents = [
            'mousemove',
            'mouseup'
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = 'none';
    proto.bindHandles = function() {
        this._bindHandles('addEventListener', this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles('removeEventListener', '');
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        var _this = this;
        this.handles.forEach(function(handle) {
            handle[bindMethod](startEvent, _this);
            handle[bindMethod]('click', _this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        var _this = this;
        activeEvents.forEach(function(eventName) {
            window1.addEventListener(eventName, _this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        var _this = this;
        activeEvents.forEach(function(eventName) {
            window1.removeEventListener(eventName, _this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        var touch;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = event.changedTouches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var changedTouch = _step.value;
                if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    var cursorNodes = [
        'TEXTAREA',
        'INPUT',
        'SELECT',
        'OPTION'
    ];
    // input types that do not have text fields
    var clickTypes = [
        'radio',
        'checkbox',
        'button',
        'submit',
        'image',
        'file'
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        var isCursorNode = cursorNodes.includes(event.target.nodeName);
        var isClickType = clickTypes.includes(event.target.type);
        var isOkayElement = !isCursorNode || isClickType;
        var isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer('pointerMove', event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch('pointerMove', event);
    };
    proto.pointerMove = function(event, pointer) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        var isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer('pointerUp', event);
    };
    proto.ontouchend = function(event) {
        this.withTouch('pointerUp', event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        var _this = this;
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(function() {
            return delete _this.isPreventingClicks;
        });
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent('pointerDone');
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer('pointerCancel', event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch('pointerCancel', event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        var _this = this;
        // ignore emulated mouse up clicks
        var isMouseup = event.type === 'mouseup';
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(function() {
                delete _this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});


parcelRegister("fGfjf", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("a9AlG")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    var svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === 'previous';
        this.isLeft = direction === 'left';
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        var element = this.element = document.createElement('button');
        element.className = "flickity-button flickity-prev-next-button ".concat(this.increment);
        var label = this.isPrevious ? 'Previous' : 'Next';
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        element.setAttribute('aria-label', label);
        // init as disabled
        this.disable();
        // create arrow
        var svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        var svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        // add title #1189
        var title = document.createElementNS(svgURI, 'title');
        title.append(label);
        // add path
        var path = document.createElementNS(svgURI, 'path');
        var pathMovements = getArrowMovements(arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180)');
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        var x0 = shape.x0, x1 = shape.x1, x2 = shape.x2, x3 = shape.x3, y1 = shape.y1, y2 = shape.y2;
        // create movement string
        return "M ".concat(x0, ", 50\n    L ").concat(x1, ", ").concat(y1 + 50, "\n    L ").concat(x2, ", ").concat(y2 + 50, "\n    L ").concat(x3, ", 50\n    L ").concat(x2, ", ").concat(50 - y2, "\n    L ").concat(x1, ", ").concat(50 - y1, "\n    Z");
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute('disabled');
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute('disabled', true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        var _this = this;
        if (!this.options.prevNextButtons) return;
        var _this_options = this.options, rightToLeft = _this_options.rightToLeft, arrowShape = _this_options.arrowShape;
        var prevDirection = rightToLeft ? 'right' : 'left';
        var nextDirection = rightToLeft ? 'left' : 'right';
        this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
        this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = function() {
            _this.uiChange();
            _this.previous();
        };
        this.handleNextButtonClick = function() {
            _this.uiChange();
            _this.next();
        };
        this.on('activate', this.activatePrevNextButtons);
        this.on('select', this.updatePrevNextButtons);
    };
    var proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        var lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        var isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? 'enable' : 'disable']();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        var isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("1KrC3", function(module, exports) {

var $2b6Uo = parcelRequire("2b6Uo");


// page dots
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("a9AlG")), (parcelRequire("9pNai")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : undefined, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement('div');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        var delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        var _this = this;
        var _this_holder;
        var newDots = new Array(count).fill().map(function(item, i) {
            var dot = document.createElement('button');
            dot.setAttribute('type', 'button');
            var num = i + 1 + _this.dots.length;
            dot.className = 'flickity-page-dot';
            dot.textContent = "View slide ".concat(num);
            return dot;
        });
        (_this_holder = this.holder).append.apply(_this_holder, (0, $2b6Uo._)(newDots));
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        var removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function(dot) {
            return dot.remove();
        });
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove('is-selected');
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add('is-selected');
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    var proto = Flickity.prototype;
    proto.activatePageDots = function() {
        var _this_focusableElems;
        this.pageDots.setDots(this.slides.length);
        (_this_focusableElems = this.focusableElems).push.apply(_this_focusableElems, (0, $2b6Uo._)(this.pageDots.dots));
        this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        var index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        var _this = this;
        var _this_focusableElems;
        this.pageDots.dots.forEach(function(dot) {
            utils.removeFrom(_this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        (_this_focusableElems = this.focusableElems).push.apply(_this_focusableElems, (0, $2b6Uo._)(this.pageDots.dots));
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("2Icld", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("a9AlG")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        var _this = this;
        // do not tick if not playing
        if (this.state !== 'playing') return;
        // default to 3 seconds
        var time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function() {
            _this.onTick();
            _this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        var _this = this;
        this.player = new Player(this.options.autoPlay, function() {
            _this.next(true);
        });
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    var proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("24jq9", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("a9AlG")), (parcelRequire("9pNai")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function(cell) {
            return fragment.appendChild(cell.element);
        });
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    var proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment(cells);
        // append to slider
        var isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        var _this = this;
        var cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function(cell) {
            cell.remove();
            var index = _this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(_this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        var cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        var cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("7LFoK", function(module, exports) {

var $2b6Uo = parcelRequire("2b6Uo");


// lazyload
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("a9AlG")), (parcelRequire("9pNai")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : undefined, function factory(Flickity, utils) {
    var lazyAttr = 'data-flickity-lazyload';
    var lazySrcAttr = "".concat(lazyAttr, "-src");
    var lazySrcsetAttr = "".concat(lazyAttr, "-srcset");
    var imgSelector = "img[".concat(lazyAttr, "], img[").concat(lazySrcAttr, "], ") + "img[".concat(lazySrcsetAttr, "], source[").concat(lazySrcsetAttr, "]");
    Flickity.create.lazyLoad = function() {
        this.on('select', this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    var proto = Flickity.prototype;
    proto.lazyLoad = function() {
        var _this = this;
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach(function(img) {
            return new LazyLoader(img, _this.handleLazyLoadComplete);
        });
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches('img')) {
            var cellAttr = cellElem.getAttribute(lazyAttr);
            var cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            var cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return (0, $2b6Uo._)(cellElem.querySelectorAll(imgSelector));
    }
    proto.onLazyLoadComplete = function(img, event) {
        var cell = this.getParentCell(img);
        var cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        var src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        var srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        var mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("qngma", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("a9AlG")), (parcelRequire("6LNXi")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        var _this = this;
        if (!this.options.imagesLoaded) return;
        var onImagesLoadedProgress = function(instance, image) {
            var cell = _this.getParentCell(image.img);
            _this.cellSizeChange(cell && cell.element);
            if (!_this.options.freeScroll) _this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("6LNXi", function(module, exports) {

var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("3eBkK")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : undefined, function factory(window1, EvEmitter) {
    var $ = window1.jQuery;
    var console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        var isArrayLike = (typeof obj === "undefined" ? "undefined" : (0, $22yUM._)(obj)) == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return (0, $2b6Uo._)(obj);
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        var queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error("Bad element for imagesLoaded ".concat(queryElem || elem));
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    var elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        var nodeType = elem.nodeType;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        var childImgs = elem.querySelectorAll('img');
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // concat childElems to filterFound array
            for(var _iterator = childImgs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var img = _step.value;
                this.addImage(img);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // get child background images
        if (typeof this.options.background == 'string') {
            var children = elem.querySelectorAll(this.options.background);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = children[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var child = _step1.value;
                    this.addElementBackgroundImages(child);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    };
    var reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        var style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        var matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            var url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        var loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        var background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        var _this = this;
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ var onProgress = function(image, elem, message) {
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(function() {
                _this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log("progress: ".concat(message), image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        var eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        var parentNode = this.img.parentNode;
        // emit progress with parent <picture> or self <img>
        var elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        var method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            var instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});


parcelRegister("ayD5C", function(module, exports) {

$parcel$export(module.exports, "MarkerClusterer", function () { return MarkerClusterer; });

var $g1iGh = parcelRequire("g1iGh");

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $5IDCd = parcelRequire("5IDCd");

var $iFZdg = parcelRequire("iFZdg");

var $2b6Uo = parcelRequire("2b6Uo");

var $99Lhl = parcelRequire("99Lhl");

var $h1vET = parcelRequire("h1vET");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ var MarkerUtils = /*#__PURE__*/ function() {
    "use strict";
    function MarkerUtils() {
        (0, $eCXNS._)(this, MarkerUtils);
    }
    (0, $7M9bt._)(MarkerUtils, null, [
        {
            key: "isAdvancedMarkerAvailable",
            value: function isAdvancedMarkerAvailable(map) {
                return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
            }
        },
        {
            key: "isAdvancedMarker",
            value: function isAdvancedMarker(marker) {
                return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
            }
        },
        {
            key: "setMap",
            value: function setMap(marker, map) {
                if (this.isAdvancedMarker(marker)) marker.map = map;
                else marker.setMap(map);
            }
        },
        {
            key: "getPosition",
            value: function getPosition(marker) {
                // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
                if (this.isAdvancedMarker(marker)) {
                    if (marker.position) {
                        if (marker.position instanceof google.maps.LatLng) return marker.position;
                        // since we can't cast to LatLngLiteral for reasons =(
                        if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
                    }
                    return new google.maps.LatLng(null);
                }
                return marker.getPosition();
            }
        },
        {
            key: "getVisible",
            value: function getVisible(marker) {
                if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
                return marker.getVisible();
            }
        }
    ]);
    return MarkerUtils;
}();
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var Cluster = /*#__PURE__*/ function() {
    "use strict";
    function Cluster(param) {
        var markers = param.markers, position = param.position;
        (0, $eCXNS._)(this, Cluster);
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    (0, $7M9bt._)(Cluster, [
        {
            key: "bounds",
            get: function get() {
                if (this.markers.length === 0 && !this._position) return;
                var bounds = new google.maps.LatLngBounds(this._position, this._position);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.markers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var marker = _step.value;
                        bounds.extend(MarkerUtils.getPosition(marker));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return bounds;
            }
        },
        {
            key: "position",
            get: function get() {
                return this._position || this.bounds.getCenter();
            }
        },
        {
            key: "count",
            get: /**
     * Get the count of **visible** markers.
     */ function get() {
                return this.markers.filter(function(m) {
                    return MarkerUtils.getVisible(m);
                }).length;
            }
        },
        {
            /**
     * Add a marker to the cluster.
     */ key: "push",
            value: function push(marker) {
                this.markers.push(marker);
            }
        },
        {
            /**
     * Cleanup references and remove marker from map.
     */ key: "delete",
            value: function _delete() {
                if (this.marker) {
                    MarkerUtils.setMap(this.marker, null);
                    this.marker = undefined;
                }
                this.markers.length = 0;
            }
        }
    ]);
    return Cluster;
}();
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ var filterMarkersToPaddedViewport = function(map, mapCanvasProjection, markers, viewportPaddingPixels) {
    var extendedMapBounds = extendBoundsToPaddedViewport(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter(function(marker) {
        return extendedMapBounds.contains(MarkerUtils.getPosition(marker));
    });
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ var extendBoundsToPaddedViewport = function(bounds, projection, numPixels) {
    var _latLngBoundsToPixelBounds = latLngBoundsToPixelBounds(bounds, projection), northEast = _latLngBoundsToPixelBounds.northEast, southWest = _latLngBoundsToPixelBounds.southWest;
    var extendedPixelBounds = extendPixelBounds({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ var getPaddedViewport = function(bounds, projection, pixels) {
    var extended = extendBoundsToPaddedViewport(bounds, projection, pixels);
    var ne = extended.getNorthEast();
    var sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ var distanceBetweenPoints = function(p1, p2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat - p1.lat) * Math.PI / 180;
    var dLon = (p2.lng - p1.lng) * Math.PI / 180;
    var sinDLat = Math.sin(dLat / 2);
    var sinDLon = Math.sin(dLon / 2);
    var a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ var latLngBoundsToPixelBounds = function(bounds, projection) {
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ var extendPixelBounds = function(param, numPixels) {
    var northEast = param.northEast, southWest = param.southWest;
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ var pixelBoundsToLatLngBounds = function(param, projection) {
    var northEast = param.northEast, southWest = param.southWest;
    var sw = projection.fromDivPixelToLatLng(southWest);
    var ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ var AbstractAlgorithm = /*#__PURE__*/ function() {
    "use strict";
    function AbstractAlgorithm(param) {
        var _param_maxZoom = param.maxZoom, maxZoom = _param_maxZoom === void 0 ? 16 : _param_maxZoom;
        (0, $eCXNS._)(this, AbstractAlgorithm);
        this.maxZoom = maxZoom;
    }
    (0, $7M9bt._)(AbstractAlgorithm, [
        {
            /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ key: "noop",
            value: function noop1(param) {
                var markers = param.markers;
                return noop(markers);
            }
        }
    ]);
    return AbstractAlgorithm;
}();
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ var AbstractViewportAlgorithm = /*#__PURE__*/ function(AbstractAlgorithm) {
    "use strict";
    (0, $5IDCd._)(AbstractViewportAlgorithm, AbstractAlgorithm);
    function AbstractViewportAlgorithm(_a) {
        (0, $eCXNS._)(this, AbstractViewportAlgorithm);
        var _this;
        var _a_viewportPadding = _a.viewportPadding, viewportPadding = _a_viewportPadding === void 0 ? 60 : _a_viewportPadding, options = __rest(_a, [
            "viewportPadding"
        ]);
        _this = (0, $g1iGh._)(this, AbstractViewportAlgorithm, [
            options
        ]);
        _this.viewportPadding = 60;
        _this.viewportPadding = viewportPadding;
        return _this;
    }
    (0, $7M9bt._)(AbstractViewportAlgorithm, [
        {
            key: "calculate",
            value: function calculate(param) {
                var markers = param.markers, map = param.map, mapCanvasProjection = param.mapCanvasProjection;
                if (map.getZoom() >= this.maxZoom) return {
                    clusters: this.noop({
                        markers: markers
                    }),
                    changed: false
                };
                return {
                    clusters: this.cluster({
                        markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                        map: map,
                        mapCanvasProjection: mapCanvasProjection
                    })
                };
            }
        }
    ]);
    return AbstractViewportAlgorithm;
}(AbstractAlgorithm);
/**
 * @hidden
 */ var noop = function(markers) {
    var clusters = markers.map(function(marker) {
        return new Cluster({
            position: MarkerUtils.getPosition(marker),
            markers: [
                marker
            ]
        });
    });
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ var GridAlgorithm = /*#__PURE__*/ function(AbstractViewportAlgorithm) {
    "use strict";
    (0, $5IDCd._)(GridAlgorithm, AbstractViewportAlgorithm);
    function GridAlgorithm(_a) {
        (0, $eCXNS._)(this, GridAlgorithm);
        var _this;
        var _a_maxDistance = _a.maxDistance, maxDistance = _a_maxDistance === void 0 ? 40000 : _a_maxDistance, _a_gridSize = _a.gridSize, gridSize = _a_gridSize === void 0 ? 40 : _a_gridSize, options = __rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        _this = (0, $g1iGh._)(this, GridAlgorithm, [
            options
        ]);
        _this.clusters = [];
        _this.state = {
            zoom: -1
        };
        _this.maxDistance = maxDistance;
        _this.gridSize = gridSize;
        return _this;
    }
    (0, $7M9bt._)(GridAlgorithm, [
        {
            key: "calculate",
            value: function calculate(param) {
                var markers = param.markers, map = param.map, mapCanvasProjection = param.mapCanvasProjection;
                var state = {
                    zoom: map.getZoom()
                };
                var changed = false;
                if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
                else changed = !(0, (/*@__PURE__*/$parcel$interopDefault($99Lhl)))(this.state, state);
                this.state = state;
                if (map.getZoom() >= this.maxZoom) return {
                    clusters: this.noop({
                        markers: markers
                    }),
                    changed: changed
                };
                return {
                    clusters: this.cluster({
                        markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                        map: map,
                        mapCanvasProjection: mapCanvasProjection
                    })
                };
            }
        },
        {
            key: "cluster",
            value: function cluster(param) {
                var _this = this;
                var markers = param.markers, map = param.map, mapCanvasProjection = param.mapCanvasProjection;
                this.clusters = [];
                markers.forEach(function(marker) {
                    _this.addToClosestCluster(marker, map, mapCanvasProjection);
                });
                return this.clusters;
            }
        },
        {
            key: "addToClosestCluster",
            value: function addToClosestCluster(marker, map, projection) {
                var maxDistance = this.maxDistance; // Some large number
                var cluster = null;
                for(var i = 0; i < this.clusters.length; i++){
                    var candidate = this.clusters[i];
                    var distance = distanceBetweenPoints(candidate.bounds.getCenter().toJSON(), MarkerUtils.getPosition(marker).toJSON());
                    if (distance < maxDistance) {
                        maxDistance = distance;
                        cluster = candidate;
                    }
                }
                if (cluster && extendBoundsToPaddedViewport(cluster.bounds, projection, this.gridSize).contains(MarkerUtils.getPosition(marker))) cluster.push(marker);
                else {
                    var cluster1 = new Cluster({
                        markers: [
                            marker
                        ]
                    });
                    this.clusters.push(cluster1);
                }
            }
        }
    ]);
    return GridAlgorithm;
}(AbstractViewportAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ var NoopAlgorithm = /*#__PURE__*/ function(AbstractAlgorithm) {
    "use strict";
    (0, $5IDCd._)(NoopAlgorithm, AbstractAlgorithm);
    function NoopAlgorithm(_a) {
        (0, $eCXNS._)(this, NoopAlgorithm);
        var options = __rest(_a, []);
        return (0, $g1iGh._)(this, NoopAlgorithm, [
            options
        ]);
    }
    (0, $7M9bt._)(NoopAlgorithm, [
        {
            key: "calculate",
            value: function calculate(param) {
                var markers = param.markers, map = param.map, mapCanvasProjection = param.mapCanvasProjection;
                return {
                    clusters: this.cluster({
                        markers: markers,
                        map: map,
                        mapCanvasProjection: mapCanvasProjection
                    }),
                    changed: false
                };
            }
        },
        {
            key: "cluster",
            value: function cluster(input) {
                return this.noop(input);
            }
        }
    ]);
    return NoopAlgorithm;
}(AbstractAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ var SuperClusterAlgorithm = /*#__PURE__*/ function(AbstractAlgorithm) {
    "use strict";
    (0, $5IDCd._)(SuperClusterAlgorithm, AbstractAlgorithm);
    function SuperClusterAlgorithm(_a) {
        (0, $eCXNS._)(this, SuperClusterAlgorithm);
        var _this;
        var maxZoom = _a.maxZoom, _a_radius = _a.radius, radius = _a_radius === void 0 ? 60 : _a_radius, options = __rest(_a, [
            "maxZoom",
            "radius"
        ]);
        _this = (0, $g1iGh._)(this, SuperClusterAlgorithm, [
            {
                maxZoom: maxZoom
            }
        ]);
        _this.state = {
            zoom: -1
        };
        _this.superCluster = new (0, $h1vET.default)(Object.assign({
            maxZoom: _this.maxZoom,
            radius: radius
        }, options));
        return _this;
    }
    (0, $7M9bt._)(SuperClusterAlgorithm, [
        {
            key: "calculate",
            value: function calculate(input) {
                var changed = false;
                var state = {
                    zoom: input.map.getZoom()
                };
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($99Lhl)))(input.markers, this.markers)) {
                    changed = true;
                    // TODO use proxy to avoid copy?
                    this.markers = (0, $2b6Uo._)(input.markers);
                    var points = this.markers.map(function(marker) {
                        var position = MarkerUtils.getPosition(marker);
                        var coordinates = [
                            position.lng(),
                            position.lat()
                        ];
                        return {
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: coordinates
                            },
                            properties: {
                                marker: marker
                            }
                        };
                    });
                    this.superCluster.load(points);
                }
                if (!changed) {
                    if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, (/*@__PURE__*/$parcel$interopDefault($99Lhl)))(this.state, state);
                }
                this.state = state;
                if (changed) this.clusters = this.cluster(input);
                return {
                    clusters: this.clusters,
                    changed: changed
                };
            }
        },
        {
            key: "cluster",
            value: function cluster(param) {
                var _this = this;
                var map = param.map;
                return this.superCluster.getClusters([
                    -180,
                    -90,
                    180,
                    90
                ], Math.round(map.getZoom())).map(function(feature) {
                    return _this.transformCluster(feature);
                });
            }
        },
        {
            key: "transformCluster",
            value: function transformCluster(param) {
                var _param_geometry = param.geometry, _param_geometry_coordinates = (0, $iFZdg._)(_param_geometry.coordinates, 2), lng = _param_geometry_coordinates[0], lat = _param_geometry_coordinates[1], properties = param.properties;
                if (properties.cluster) return new Cluster({
                    markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map(function(leaf) {
                        return leaf.properties.marker;
                    }),
                    position: {
                        lat: lat,
                        lng: lng
                    }
                });
                var marker = properties.marker;
                return new Cluster({
                    markers: [
                        marker
                    ],
                    position: MarkerUtils.getPosition(marker)
                });
            }
        }
    ]);
    return SuperClusterAlgorithm;
}(AbstractAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ var SuperClusterViewportAlgorithm = /*#__PURE__*/ function(AbstractViewportAlgorithm) {
    "use strict";
    (0, $5IDCd._)(SuperClusterViewportAlgorithm, AbstractViewportAlgorithm);
    function SuperClusterViewportAlgorithm(_a) {
        (0, $eCXNS._)(this, SuperClusterViewportAlgorithm);
        var _this;
        var maxZoom = _a.maxZoom, _a_radius = _a.radius, radius = _a_radius === void 0 ? 60 : _a_radius, _a_viewportPadding = _a.viewportPadding, viewportPadding = _a_viewportPadding === void 0 ? 60 : _a_viewportPadding, options = __rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        _this = (0, $g1iGh._)(this, SuperClusterViewportAlgorithm, [
            {
                maxZoom: maxZoom,
                viewportPadding: viewportPadding
            }
        ]);
        _this.superCluster = new (0, $h1vET.default)(Object.assign({
            maxZoom: _this.maxZoom,
            radius: radius
        }, options));
        _this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
        return _this;
    }
    (0, $7M9bt._)(SuperClusterViewportAlgorithm, [
        {
            key: "calculate",
            value: function calculate(input) {
                var state = {
                    zoom: Math.round(input.map.getZoom()),
                    view: getPaddedViewport(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
                };
                var changed = !(0, (/*@__PURE__*/$parcel$interopDefault($99Lhl)))(this.state, state);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($99Lhl)))(input.markers, this.markers)) {
                    changed = true;
                    // TODO use proxy to avoid copy?
                    this.markers = (0, $2b6Uo._)(input.markers);
                    var points = this.markers.map(function(marker) {
                        var position = MarkerUtils.getPosition(marker);
                        var coordinates = [
                            position.lng(),
                            position.lat()
                        ];
                        return {
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: coordinates
                            },
                            properties: {
                                marker: marker
                            }
                        };
                    });
                    this.superCluster.load(points);
                }
                if (changed) {
                    this.clusters = this.cluster(input);
                    this.state = state;
                }
                return {
                    clusters: this.clusters,
                    changed: changed
                };
            }
        },
        {
            key: "cluster",
            value: function cluster(param) {
                var _this = this;
                var map = param.map, mapCanvasProjection = param.mapCanvasProjection;
                /* recalculate new state because we can't use the cached version. */ var state = {
                    zoom: Math.round(map.getZoom()),
                    view: getPaddedViewport(map.getBounds(), mapCanvasProjection, this.viewportPadding)
                };
                return this.superCluster.getClusters(state.view, state.zoom).map(function(feature) {
                    return _this.transformCluster(feature);
                });
            }
        },
        {
            key: "transformCluster",
            value: function transformCluster(param) {
                var _param_geometry = param.geometry, _param_geometry_coordinates = (0, $iFZdg._)(_param_geometry.coordinates, 2), lng = _param_geometry_coordinates[0], lat = _param_geometry_coordinates[1], properties = param.properties;
                if (properties.cluster) return new Cluster({
                    markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map(function(leaf) {
                        return leaf.properties.marker;
                    }),
                    position: {
                        lat: lat,
                        lng: lng
                    }
                });
                var marker = properties.marker;
                return new Cluster({
                    markers: [
                        marker
                    ],
                    position: MarkerUtils.getPosition(marker)
                });
            }
        }
    ]);
    return SuperClusterViewportAlgorithm;
}(AbstractViewportAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ var ClusterStats = function ClusterStats(markers, clusters) {
    "use strict";
    var _Math, _Math1;
    (0, $eCXNS._)(this, ClusterStats);
    this.markers = {
        sum: markers.length
    };
    var clusterMarkerCounts = clusters.map(function(a) {
        return a.count;
    });
    var clusterMarkerSum = clusterMarkerCounts.reduce(function(a, b) {
        return a + b;
    }, 0);
    this.clusters = {
        count: clusters.length,
        markers: {
            mean: clusterMarkerSum / clusters.length,
            sum: clusterMarkerSum,
            min: (_Math = Math).min.apply(_Math, (0, $2b6Uo._)(clusterMarkerCounts)),
            max: (_Math1 = Math).max.apply(_Math1, (0, $2b6Uo._)(clusterMarkerCounts))
        }
    };
};
var DefaultRenderer = /*#__PURE__*/ function() {
    "use strict";
    function DefaultRenderer() {
        (0, $eCXNS._)(this, DefaultRenderer);
    }
    (0, $7M9bt._)(DefaultRenderer, [
        {
            /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ key: "render",
            value: function render(param, stats, map) {
                var count = param.count, position = param.position;
                // change color if this cluster has more markers than the mean cluster
                var color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
                // create svg literal with fill color
                var svg = '<svg fill="'.concat(color, '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">\n<circle cx="120" cy="120" opacity=".6" r="70" />\n<circle cx="120" cy="120" opacity=".3" r="90" />\n<circle cx="120" cy="120" opacity=".2" r="110" />\n<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">').concat(count, "</text>\n</svg>");
                var title = "Cluster of ".concat(count, " markers"), // adjust zIndex to be above other markers
                zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
                if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
                    // create cluster SVG element
                    var parser = new DOMParser();
                    var svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
                    svgEl.setAttribute("transform", "translate(0 25)");
                    var clusterOptions = {
                        map: map,
                        position: position,
                        zIndex: zIndex,
                        title: title,
                        content: svgEl
                    };
                    return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
                }
                var clusterOptions1 = {
                    position: position,
                    zIndex: zIndex,
                    title: title,
                    icon: {
                        url: "data:image/svg+xml;base64,".concat(btoa(svg)),
                        anchor: new google.maps.Point(25, 25)
                    }
                };
                return new google.maps.Marker(clusterOptions1);
            }
        }
    ]);
    return DefaultRenderer;
}();
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(var property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ var OverlayViewSafe = function OverlayViewSafe() {
    "use strict";
    (0, $eCXNS._)(this, OverlayViewSafe);
    // MarkerClusterer implements google.maps.OverlayView interface. We use the
    // extend function to extend MarkerClusterer with google.maps.OverlayView
    // because it might not always be available when the code is defined so we
    // look for it at the last possible moment. If it doesn't exist now then
    // there is no point going ahead :)
    extend(OverlayViewSafe, google.maps.OverlayView);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var MarkerClustererEvents;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
var defaultOnClusterClickHandler = function(_, cluster, map) {
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ var MarkerClusterer = /*#__PURE__*/ function(OverlayViewSafe) {
    "use strict";
    (0, $5IDCd._)(MarkerClusterer, OverlayViewSafe);
    function MarkerClusterer(param) {
        var map = param.map, _param_markers = param.markers, markers = _param_markers === void 0 ? [] : _param_markers, _param_algorithmOptions = param.algorithmOptions, algorithmOptions = _param_algorithmOptions === void 0 ? {} : _param_algorithmOptions, _param_algorithm = param.algorithm, algorithm = _param_algorithm === void 0 ? new SuperClusterAlgorithm(algorithmOptions) : _param_algorithm, _param_renderer = param.renderer, renderer = _param_renderer === void 0 ? new DefaultRenderer() : _param_renderer, _param_onClusterClick = param.onClusterClick, onClusterClick = _param_onClusterClick === void 0 ? defaultOnClusterClickHandler : _param_onClusterClick;
        (0, $eCXNS._)(this, MarkerClusterer);
        var _this;
        _this = (0, $g1iGh._)(this, MarkerClusterer);
        _this.markers = (0, $2b6Uo._)(markers);
        _this.clusters = [];
        _this.algorithm = algorithm;
        _this.renderer = renderer;
        _this.onClusterClick = onClusterClick;
        if (map) _this.setMap(map);
        return _this;
    }
    (0, $7M9bt._)(MarkerClusterer, [
        {
            key: "addMarker",
            value: function addMarker(marker, noDraw) {
                if (this.markers.includes(marker)) return;
                this.markers.push(marker);
                if (!noDraw) this.render();
            }
        },
        {
            key: "addMarkers",
            value: function addMarkers(markers, noDraw) {
                var _this = this;
                markers.forEach(function(marker) {
                    _this.addMarker(marker, true);
                });
                if (!noDraw) this.render();
            }
        },
        {
            key: "removeMarker",
            value: function removeMarker(marker, noDraw) {
                var index = this.markers.indexOf(marker);
                if (index === -1) // Marker is not in our list of markers, so do nothing:
                return false;
                MarkerUtils.setMap(marker, null);
                this.markers.splice(index, 1); // Remove the marker from the list of managed markers
                if (!noDraw) this.render();
                return true;
            }
        },
        {
            key: "removeMarkers",
            value: function removeMarkers(markers, noDraw) {
                var _this = this;
                var removed = false;
                markers.forEach(function(marker) {
                    removed = _this.removeMarker(marker, true) || removed;
                });
                if (removed && !noDraw) this.render();
                return removed;
            }
        },
        {
            key: "clearMarkers",
            value: function clearMarkers(noDraw) {
                this.markers.length = 0;
                if (!noDraw) this.render();
            }
        },
        {
            /**
     * Recalculates and draws all the marker clusters.
     */ key: "render",
            value: function render() {
                var map = this.getMap();
                if (map instanceof google.maps.Map && map.getProjection()) {
                    google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
                    var _this_algorithm_calculate = this.algorithm.calculate({
                        markers: this.markers,
                        map: map,
                        mapCanvasProjection: this.getProjection()
                    }), clusters = _this_algorithm_calculate.clusters, changed = _this_algorithm_calculate.changed;
                    // Allow algorithms to return flag on whether the clusters/markers have changed.
                    if (changed || changed == undefined) {
                        // Accumulate the markers of the clusters composed of a single marker.
                        // Those clusters directly use the marker.
                        // Clusters with more than one markers use a group marker generated by a renderer.
                        var singleMarker = new Set();
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = clusters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var cluster = _step.value;
                                if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var groupMarkers = [];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            // Iterate the clusters that are currently rendered.
                            for(var _iterator1 = this.clusters[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var cluster1 = _step1.value;
                                if (cluster1.marker == null) continue;
                                if (cluster1.markers.length == 1) {
                                    if (!singleMarker.has(cluster1.marker)) // The marker:
                                    // - was previously rendered because it is from a cluster with 1 marker,
                                    // - should no more be rendered as it is not in singleMarker.
                                    MarkerUtils.setMap(cluster1.marker, null);
                                } else // Delay the removal of old group markers to avoid flickering.
                                groupMarkers.push(cluster1.marker);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        this.clusters = clusters;
                        this.renderClusters();
                        // Delayed removal of the markers of the former groups.
                        requestAnimationFrame(function() {
                            return groupMarkers.forEach(function(marker) {
                                return MarkerUtils.setMap(marker, null);
                            });
                        });
                    }
                    google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
                }
            }
        },
        {
            key: "onAdd",
            value: function onAdd() {
                this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
                this.render();
            }
        },
        {
            key: "onRemove",
            value: function onRemove() {
                google.maps.event.removeListener(this.idleListener);
                this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.markers.forEach(function(marker) {
                    return MarkerUtils.setMap(marker, null);
                });
                this.clusters.forEach(function(cluster) {
                    return cluster.delete();
                });
                this.clusters = [];
            }
        },
        {
            key: "renderClusters",
            value: function renderClusters() {
                var _this = this;
                // Generate stats to pass to renderers.
                var stats = new ClusterStats(this.markers, this.clusters);
                var map = this.getMap();
                this.clusters.forEach(function(cluster) {
                    if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
                    else {
                        // Generate the marker to represent the group.
                        cluster.marker = _this.renderer.render(cluster, stats, map);
                        // Make sure all individual markers are removed from the map.
                        cluster.markers.forEach(function(marker) {
                            return MarkerUtils.setMap(marker, null);
                        });
                        if (_this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ function(event) {
                            google.maps.event.trigger(_this, MarkerClustererEvents.CLUSTER_CLICK, cluster);
                            _this.onClusterClick(event, cluster, map);
                        });
                    }
                    MarkerUtils.setMap(cluster.marker, map);
                });
            }
        }
    ]);
    return MarkerClusterer;
}(OverlayViewSafe);

});
parcelRegister("g1iGh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba9b3af6d173df65$export$71511d61b312f219; });

var $hzVoy = parcelRequire("hzVoy");

var $wppeX = parcelRequire("wppeX");

var $8cFxo = parcelRequire("8cFxo");
function $ba9b3af6d173df65$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $hzVoy._)(derived);
    return (0, $8cFxo._)(_this, (0, $wppeX._)() ? Reflect.construct(derived, args || [], (0, $hzVoy._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("hzVoy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccc23a021f1e6bc0$export$71511d61b312f219; });
function $ccc23a021f1e6bc0$export$71511d61b312f219(o) {
    $ccc23a021f1e6bc0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ccc23a021f1e6bc0$export$71511d61b312f219(o);
}

});

parcelRegister("wppeX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0616b26550fb407b$export$71511d61b312f219; });
function $0616b26550fb407b$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($0616b26550fb407b$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("8cFxo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5f8faa38aa7bcc75$export$71511d61b312f219; });

var $aabtM = parcelRequire("aabtM");

var $22yUM = parcelRequire("22yUM");
function $5f8faa38aa7bcc75$export$71511d61b312f219(self, call) {
    if (call && ((0, $22yUM._)(call) === "object" || typeof call === "function")) return call;
    return (0, $aabtM._)(self);
}

});
parcelRegister("aabtM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7663be19a9d89647$export$71511d61b312f219; });
function $7663be19a9d89647$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("eCXNS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aa63010954ffd74c$export$71511d61b312f219; });
function $aa63010954ffd74c$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7M9bt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5a9423d6bdf9478a$export$71511d61b312f219; });
function $5a9423d6bdf9478a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5a9423d6bdf9478a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("5IDCd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $429fca99a37ce120$export$71511d61b312f219; });

var $cU6r8 = parcelRequire("cU6r8");
function $429fca99a37ce120$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cU6r8._)(subClass, superClass);
}

});
parcelRegister("cU6r8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $964fb531acf43ca5$export$71511d61b312f219; });
function $964fb531acf43ca5$export$71511d61b312f219(o, p) {
    $964fb531acf43ca5$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $964fb531acf43ca5$export$71511d61b312f219(o, p);
}

});


parcelRegister("iFZdg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d98b89efad01a571$export$71511d61b312f219; });

var $1SZ4G = parcelRequire("1SZ4G");

var $eXaIS = parcelRequire("eXaIS");

var $2XoEB = parcelRequire("2XoEB");

var $ghR52 = parcelRequire("ghR52");
function $d98b89efad01a571$export$71511d61b312f219(arr, i) {
    return (0, $1SZ4G._)(arr) || (0, $eXaIS._)(arr, i) || (0, $ghR52._)(arr, i) || (0, $2XoEB._)();
}

});
parcelRegister("1SZ4G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15fa35b92343d82d$export$71511d61b312f219; });
function $15fa35b92343d82d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("eXaIS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae2ee4b241bf08f3$export$71511d61b312f219; });
function $ae2ee4b241bf08f3$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("2XoEB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $22743732e33643c8$export$71511d61b312f219; });
function $22743732e33643c8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("99Lhl", function(module, exports) {

var $22yUM = parcelRequire("22yUM");
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $22yUM._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $22yUM._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("h1vET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c64b1664908c1adc$export$2e2bcd8739ae039; });

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $iFZdg = parcelRequire("iFZdg");

var $6QpbF = parcelRequire("6QpbF");
var $c64b1664908c1adc$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: function(props) {
        return props // props => ({sum: props.my_value})
        ;
    }
};
var $c64b1664908c1adc$var$fround = Math.fround || function(tmp) {
    return function(x) {
        tmp[0] = +x;
        return tmp[0];
    };
}(new Float32Array(1));
var $c64b1664908c1adc$var$OFFSET_ZOOM = 2;
var $c64b1664908c1adc$var$OFFSET_ID = 3;
var $c64b1664908c1adc$var$OFFSET_PARENT = 4;
var $c64b1664908c1adc$var$OFFSET_NUM = 5;
var $c64b1664908c1adc$var$OFFSET_PROP = 6;
var $c64b1664908c1adc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Supercluster(options) {
        (0, $eCXNS._)(this, Supercluster);
        this.options = Object.assign(Object.create($c64b1664908c1adc$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    (0, $7M9bt._)(Supercluster, [
        {
            key: "load",
            value: function load(points) {
                var _this_options = this.options, log = _this_options.log, minZoom = _this_options.minZoom, maxZoom = _this_options.maxZoom;
                if (log) console.time('total time');
                var timerId = "prepare ".concat(points.length, " points");
                if (log) console.time(timerId);
                this.points = points;
                // generate a cluster object for each point and index input points into a KD-tree
                var data = [];
                for(var i = 0; i < points.length; i++){
                    var p = points[i];
                    if (!p.geometry) continue;
                    var _p_geometry_coordinates = (0, $iFZdg._)(p.geometry.coordinates, 2), lng = _p_geometry_coordinates[0], lat = _p_geometry_coordinates[1];
                    var x = $c64b1664908c1adc$var$fround($c64b1664908c1adc$var$lngX(lng));
                    var y = $c64b1664908c1adc$var$fround($c64b1664908c1adc$var$latY(lat));
                    // store internal point/cluster data in flat numeric arrays for performance
                    data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
                    );
                    if (this.options.reduce) data.push(0); // noop
                }
                var tree = this.trees[maxZoom + 1] = this._createTree(data);
                if (log) console.timeEnd(timerId);
                // cluster points on max zoom, then cluster the results on previous zoom, etc.;
                // results in a cluster hierarchy across zoom levels
                for(var z = maxZoom; z >= minZoom; z--){
                    var now = +Date.now();
                    // create a new set of clusters for the zoom and index them with a KD-tree
                    tree = this.trees[z] = this._createTree(this._cluster(tree, z));
                    if (log) console.log('z%d: %d clusters in %dms', z, tree.numItems, +Date.now() - now);
                }
                if (log) console.timeEnd('total time');
                return this;
            }
        },
        {
            key: "getClusters",
            value: function getClusters(bbox, zoom) {
                var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
                var minLat = Math.max(-90, Math.min(90, bbox[1]));
                var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
                var maxLat = Math.max(-90, Math.min(90, bbox[3]));
                if (bbox[2] - bbox[0] >= 360) {
                    minLng = -180;
                    maxLng = 180;
                } else if (minLng > maxLng) {
                    var easternHem = this.getClusters([
                        minLng,
                        minLat,
                        180,
                        maxLat
                    ], zoom);
                    var westernHem = this.getClusters([
                        -180,
                        minLat,
                        maxLng,
                        maxLat
                    ], zoom);
                    return easternHem.concat(westernHem);
                }
                var tree = this.trees[this._limitZoom(zoom)];
                var ids = tree.range($c64b1664908c1adc$var$lngX(minLng), $c64b1664908c1adc$var$latY(maxLat), $c64b1664908c1adc$var$lngX(maxLng), $c64b1664908c1adc$var$latY(minLat));
                var data = tree.data;
                var clusters = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var id = _step.value;
                        var k = this.stride * id;
                        clusters.push(data[k + $c64b1664908c1adc$var$OFFSET_NUM] > 1 ? $c64b1664908c1adc$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $c64b1664908c1adc$var$OFFSET_ID]]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return clusters;
            }
        },
        {
            key: "getChildren",
            value: function getChildren(clusterId) {
                var originId = this._getOriginId(clusterId);
                var originZoom = this._getOriginZoom(clusterId);
                var errorMsg = 'No cluster with the specified id.';
                var tree = this.trees[originZoom];
                if (!tree) throw new Error(errorMsg);
                var data = tree.data;
                if (originId * this.stride >= data.length) throw new Error(errorMsg);
                var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
                var x = data[originId * this.stride];
                var y = data[originId * this.stride + 1];
                var ids = tree.within(x, y, r);
                var children = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var id = _step.value;
                        var k = id * this.stride;
                        if (data[k + $c64b1664908c1adc$var$OFFSET_PARENT] === clusterId) children.push(data[k + $c64b1664908c1adc$var$OFFSET_NUM] > 1 ? $c64b1664908c1adc$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $c64b1664908c1adc$var$OFFSET_ID]]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (children.length === 0) throw new Error(errorMsg);
                return children;
            }
        },
        {
            key: "getLeaves",
            value: function getLeaves(clusterId, limit, offset) {
                limit = limit || 10;
                offset = offset || 0;
                var leaves = [];
                this._appendLeaves(leaves, clusterId, limit, offset, 0);
                return leaves;
            }
        },
        {
            key: "getTile",
            value: function getTile(z, x, y) {
                var tree = this.trees[this._limitZoom(z)];
                var z2 = Math.pow(2, z);
                var _this_options = this.options, extent = _this_options.extent, radius = _this_options.radius;
                var p = radius / extent;
                var top = (y - p) / z2;
                var bottom = (y + 1 + p) / z2;
                var tile = {
                    features: []
                };
                this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
                if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
                if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
                return tile.features.length ? tile : null;
            }
        },
        {
            key: "getClusterExpansionZoom",
            value: function getClusterExpansionZoom(clusterId) {
                var expansionZoom = this._getOriginZoom(clusterId) - 1;
                while(expansionZoom <= this.options.maxZoom){
                    var children = this.getChildren(clusterId);
                    expansionZoom++;
                    if (children.length !== 1) break;
                    clusterId = children[0].properties.cluster_id;
                }
                return expansionZoom;
            }
        },
        {
            key: "_appendLeaves",
            value: function _appendLeaves(result, clusterId, limit, offset, skipped) {
                var children = this.getChildren(clusterId);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        var props = child.properties;
                        if (props && props.cluster) {
                            if (skipped + props.point_count <= offset) // skip the whole cluster
                            skipped += props.point_count;
                            else // enter the cluster
                            skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
                        } else if (skipped < offset) // skip a single point
                        skipped++;
                        else // add a single point
                        result.push(child);
                        if (result.length === limit) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return skipped;
            }
        },
        {
            key: "_createTree",
            value: function _createTree(data) {
                var tree = new (0, $6QpbF.default)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(var i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
                tree.finish();
                tree.data = data;
                return tree;
            }
        },
        {
            key: "_addTileFeatures",
            value: function _addTileFeatures(ids, data, x, y, z2, tile) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var k = i * this.stride;
                        var isCluster = data[k + $c64b1664908c1adc$var$OFFSET_NUM] > 1;
                        var tags = void 0, px = void 0, py = void 0;
                        if (isCluster) {
                            tags = $c64b1664908c1adc$var$getClusterProperties(data, k, this.clusterProps);
                            px = data[k];
                            py = data[k + 1];
                        } else {
                            var p = this.points[data[k + $c64b1664908c1adc$var$OFFSET_ID]];
                            tags = p.properties;
                            var _p_geometry_coordinates = (0, $iFZdg._)(p.geometry.coordinates, 2), lng = _p_geometry_coordinates[0], lat = _p_geometry_coordinates[1];
                            px = $c64b1664908c1adc$var$lngX(lng);
                            py = $c64b1664908c1adc$var$latY(lat);
                        }
                        var f = {
                            type: 1,
                            geometry: [
                                [
                                    Math.round(this.options.extent * (px * z2 - x)),
                                    Math.round(this.options.extent * (py * z2 - y))
                                ]
                            ],
                            tags: tags
                        };
                        // assign id
                        var id = void 0;
                        if (isCluster || this.options.generateId) // optionally generate id for points
                        id = data[k + $c64b1664908c1adc$var$OFFSET_ID];
                        else // keep id if already assigned
                        id = this.points[data[k + $c64b1664908c1adc$var$OFFSET_ID]].id;
                        if (id !== undefined) f.id = id;
                        tile.features.push(f);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_limitZoom",
            value: function _limitZoom(z) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
            }
        },
        {
            key: "_cluster",
            value: function _cluster(tree, zoom) {
                var _this_options = this.options, radius = _this_options.radius, extent = _this_options.extent, reduce = _this_options.reduce, minPoints = _this_options.minPoints;
                var r = radius / (extent * Math.pow(2, zoom));
                var data = tree.data;
                var nextData = [];
                var stride = this.stride;
                // loop through each point
                for(var i = 0; i < data.length; i += stride){
                    // if we've already visited the point at this zoom level, skip it
                    if (data[i + $c64b1664908c1adc$var$OFFSET_ZOOM] <= zoom) continue;
                    data[i + $c64b1664908c1adc$var$OFFSET_ZOOM] = zoom;
                    // find all nearby points
                    var x = data[i];
                    var y = data[i + 1];
                    var neighborIds = tree.within(data[i], data[i + 1], r);
                    var numPointsOrigin = data[i + $c64b1664908c1adc$var$OFFSET_NUM];
                    var numPoints = numPointsOrigin;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // count the number of points in a potential cluster
                        for(var _iterator = neighborIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var neighborId = _step.value;
                            var k = neighborId * stride;
                            // filter out neighbors that are already processed
                            if (data[k + $c64b1664908c1adc$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $c64b1664908c1adc$var$OFFSET_NUM];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // if there were neighbors to merge, and there are enough points to form a cluster
                    if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                        var wx = x * numPointsOrigin;
                        var wy = y * numPointsOrigin;
                        var clusterProperties = void 0;
                        var clusterPropIndex = -1;
                        // encode both zoom and point index on which the cluster originated -- offset by total length of features
                        var id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = neighborIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var neighborId1 = _step1.value;
                                var k1 = neighborId1 * stride;
                                if (data[k1 + $c64b1664908c1adc$var$OFFSET_ZOOM] <= zoom) continue;
                                data[k1 + $c64b1664908c1adc$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                                var numPoints2 = data[k1 + $c64b1664908c1adc$var$OFFSET_NUM];
                                wx += data[k1] * numPoints2; // accumulate coordinates for calculating weighted center
                                wy += data[k1 + 1] * numPoints2;
                                data[k1 + $c64b1664908c1adc$var$OFFSET_PARENT] = id;
                                if (reduce) {
                                    if (!clusterProperties) {
                                        clusterProperties = this._map(data, i, true);
                                        clusterPropIndex = this.clusterProps.length;
                                        this.clusterProps.push(clusterProperties);
                                    }
                                    reduce(clusterProperties, this._map(data, k1));
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        data[i + $c64b1664908c1adc$var$OFFSET_PARENT] = id;
                        nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                        if (reduce) nextData.push(clusterPropIndex);
                    } else {
                        for(var j = 0; j < stride; j++)nextData.push(data[i + j]);
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        if (numPoints > 1) try {
                            for(var _iterator2 = neighborIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var neighborId2 = _step2.value;
                                var k2 = neighborId2 * stride;
                                if (data[k2 + $c64b1664908c1adc$var$OFFSET_ZOOM] <= zoom) continue;
                                data[k2 + $c64b1664908c1adc$var$OFFSET_ZOOM] = zoom;
                                for(var j1 = 0; j1 < stride; j1++)nextData.push(data[k2 + j1]);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
                return nextData;
            }
        },
        {
            // get index of the point from which the cluster originated
            key: "_getOriginId",
            value: function _getOriginId(clusterId) {
                return clusterId - this.points.length >> 5;
            }
        },
        {
            // get zoom of the point from which the cluster originated
            key: "_getOriginZoom",
            value: function _getOriginZoom(clusterId) {
                return (clusterId - this.points.length) % 32;
            }
        },
        {
            key: "_map",
            value: function _map(data, i, clone) {
                if (data[i + $c64b1664908c1adc$var$OFFSET_NUM] > 1) {
                    var props = this.clusterProps[data[i + $c64b1664908c1adc$var$OFFSET_PROP]];
                    return clone ? Object.assign({}, props) : props;
                }
                var original = this.points[data[i + $c64b1664908c1adc$var$OFFSET_ID]].properties;
                var result = this.options.map(original);
                return clone && result === original ? Object.assign({}, result) : result;
            }
        }
    ]);
    return Supercluster;
}();
function $c64b1664908c1adc$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: 'Feature',
        id: data[i + $c64b1664908c1adc$var$OFFSET_ID],
        properties: $c64b1664908c1adc$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: 'Point',
            coordinates: [
                $c64b1664908c1adc$var$xLng(data[i]),
                $c64b1664908c1adc$var$yLat(data[i + 1])
            ]
        }
    };
}
function $c64b1664908c1adc$var$getClusterProperties(data, i, clusterProps) {
    var count = data[i + $c64b1664908c1adc$var$OFFSET_NUM];
    var abbrev = count >= 10000 ? "".concat(Math.round(count / 1000), "k") : count >= 1000 ? "".concat(Math.round(count / 100) / 10, "k") : count;
    var propIndex = data[i + $c64b1664908c1adc$var$OFFSET_PROP];
    var properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $c64b1664908c1adc$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $c64b1664908c1adc$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $c64b1664908c1adc$var$latY(lat) {
    var sin = Math.sin(lat * Math.PI / 180);
    var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $c64b1664908c1adc$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $c64b1664908c1adc$var$yLat(y) {
    var y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

});
parcelRegister("6QpbF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fbb2310d03b878c$export$2e2bcd8739ae039; });

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $iFZdg = parcelRequire("iFZdg");
var $4fbb2310d03b878c$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ var $4fbb2310d03b878c$var$VERSION = 1; // serialized format version
var $4fbb2310d03b878c$var$HEADER_SIZE = 8;
var $4fbb2310d03b878c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function KDBush(numItems) {
        var nodeSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, ArrayType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Float64Array, data = arguments.length > 3 ? arguments[3] : void 0;
        (0, $eCXNS._)(this, KDBush);
        if (isNaN(numItems) || numItems < 0) throw new Error("Unpexpected numItems value: ".concat(numItems, "."));
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        var arrayTypeIndex = $4fbb2310d03b878c$var$ARRAY_TYPES.indexOf(this.ArrayType);
        var coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        var idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        var padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error("Unexpected typed array class: ".concat(ArrayType, "."));
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $4fbb2310d03b878c$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $4fbb2310d03b878c$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($4fbb2310d03b878c$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $4fbb2310d03b878c$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $4fbb2310d03b878c$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($4fbb2310d03b878c$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    (0, $7M9bt._)(KDBush, [
        {
            /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ key: "add",
            value: function add(x, y) {
                var index = this._pos >> 1;
                this.ids[index] = index;
                this.coords[this._pos++] = x;
                this.coords[this._pos++] = y;
                return index;
            }
        },
        {
            /**
     * Perform indexing of the added points.
     */ key: "finish",
            value: function finish() {
                var numAdded = this._pos >> 1;
                if (numAdded !== this.numItems) throw new Error("Added ".concat(numAdded, " items when expected ").concat(this.numItems, "."));
                // kd-sort both arrays for efficient search
                $4fbb2310d03b878c$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
                this._finished = true;
                return this;
            }
        },
        {
            /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ key: "range",
            value: function range(minX, minY, maxX, maxY) {
                if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
                var _this = this, ids = _this.ids, coords = _this.coords, nodeSize = _this.nodeSize;
                var stack = [
                    0,
                    ids.length - 1,
                    0
                ];
                var result = [];
                // recursively search for items in range in the kd-sorted arrays
                while(stack.length){
                    var axis = stack.pop() || 0;
                    var right = stack.pop() || 0;
                    var left = stack.pop() || 0;
                    // if we reached "tree node", search linearly
                    if (right - left <= nodeSize) {
                        for(var i = left; i <= right; i++){
                            var x = coords[2 * i];
                            var y = coords[2 * i + 1];
                            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                        }
                        continue;
                    }
                    // otherwise find the middle index
                    var m = left + right >> 1;
                    // include the middle item if it's in range
                    var x1 = coords[2 * m];
                    var y1 = coords[2 * m + 1];
                    if (x1 >= minX && x1 <= maxX && y1 >= minY && y1 <= maxY) result.push(ids[m]);
                    // queue search in halves that intersect the query
                    if (axis === 0 ? minX <= x1 : minY <= y1) {
                        stack.push(left);
                        stack.push(m - 1);
                        stack.push(1 - axis);
                    }
                    if (axis === 0 ? maxX >= x1 : maxY >= y1) {
                        stack.push(m + 1);
                        stack.push(right);
                        stack.push(1 - axis);
                    }
                }
                return result;
            }
        },
        {
            /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ key: "within",
            value: function within(qx, qy, r) {
                if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
                var _this = this, ids = _this.ids, coords = _this.coords, nodeSize = _this.nodeSize;
                var stack = [
                    0,
                    ids.length - 1,
                    0
                ];
                var result = [];
                var r2 = r * r;
                // recursively search for items within radius in the kd-sorted arrays
                while(stack.length){
                    var axis = stack.pop() || 0;
                    var right = stack.pop() || 0;
                    var left = stack.pop() || 0;
                    // if we reached "tree node", search linearly
                    if (right - left <= nodeSize) {
                        for(var i = left; i <= right; i++)if ($4fbb2310d03b878c$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                        continue;
                    }
                    // otherwise find the middle index
                    var m = left + right >> 1;
                    // include the middle item if it's in range
                    var x = coords[2 * m];
                    var y = coords[2 * m + 1];
                    if ($4fbb2310d03b878c$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
                    // queue search in halves that intersect the query
                    if (axis === 0 ? qx - r <= x : qy - r <= y) {
                        stack.push(left);
                        stack.push(m - 1);
                        stack.push(1 - axis);
                    }
                    if (axis === 0 ? qx + r >= x : qy + r >= y) {
                        stack.push(m + 1);
                        stack.push(right);
                        stack.push(1 - axis);
                    }
                }
                return result;
            }
        }
    ], [
        {
            key: "from",
            value: /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ function from(data) {
                if (!(data instanceof ArrayBuffer)) throw new Error('Data must be an instance of ArrayBuffer.');
                var _ref = (0, $iFZdg._)(new Uint8Array(data, 0, 2), 2), magic = _ref[0], versionAndType = _ref[1];
                if (magic !== 0xdb) throw new Error('Data does not appear to be in a KDBush format.');
                var version = versionAndType >> 4;
                if (version !== $4fbb2310d03b878c$var$VERSION) throw new Error("Got v".concat(version, " data when expected v").concat($4fbb2310d03b878c$var$VERSION, "."));
                var ArrayType = $4fbb2310d03b878c$var$ARRAY_TYPES[versionAndType & 0x0f];
                if (!ArrayType) throw new Error('Unrecognized array type.');
                var _ref1 = (0, $iFZdg._)(new Uint16Array(data, 2, 1), 1), nodeSize = _ref1[0];
                var _ref2 = (0, $iFZdg._)(new Uint32Array(data, 4, 1), 1), numItems = _ref2[0];
                return new KDBush(numItems, nodeSize, ArrayType, data);
            }
        }
    ]);
    return KDBush;
}();
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $4fbb2310d03b878c$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    var m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $4fbb2310d03b878c$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $4fbb2310d03b878c$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $4fbb2310d03b878c$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $4fbb2310d03b878c$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $4fbb2310d03b878c$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        var t = coords[2 * k + axis];
        var i = left;
        var j = right;
        $4fbb2310d03b878c$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $4fbb2310d03b878c$var$swapItem(ids, coords, left, right);
        while(i < j){
            $4fbb2310d03b878c$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $4fbb2310d03b878c$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $4fbb2310d03b878c$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $4fbb2310d03b878c$var$swapItem(ids, coords, i, j) {
    $4fbb2310d03b878c$var$swap(ids, i, j);
    $4fbb2310d03b878c$var$swap(coords, 2 * i, 2 * j);
    $4fbb2310d03b878c$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $4fbb2310d03b878c$var$swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $4fbb2310d03b878c$var$sqDist(ax, ay, bx, by) {
    var dx = ax - bx;
    var dy = ay - by;
    return dx * dx + dy * dy;
}

});



var $1f6fbb010fec40c2$exports = {};
$parcel$extendImportMap({
    "429qR": "icon_cluster.09c2eec8.png"
});

// Standard
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $g1iGh = parcelRequire("g1iGh");

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $9HFeY = parcelRequire("9HFeY");

var $hzVoy = parcelRequire("hzVoy");
function $1a31f82b87f62ce4$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $hzVoy._)(object);
        if (object === null) break;
    }
    return object;
}


function $3eca773514dd6a70$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $3eca773514dd6a70$export$71511d61b312f219 = Reflect.get;
    else $3eca773514dd6a70$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $1a31f82b87f62ce4$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $3eca773514dd6a70$export$71511d61b312f219(target, property, receiver || target);
}



var $hzVoy = parcelRequire("hzVoy");

var $5IDCd = parcelRequire("5IDCd");

var $4udDG = parcelRequire("4udDG");
function $82dbc585330cff66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82dbc585330cff66$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $82dbc585330cff66$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $8cFxo = parcelRequire("8cFxo");

var $iFZdg = parcelRequire("iFZdg");

var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");
var $22226631ba3d4356$exports = {};

$parcel$export($22226631ba3d4356$exports, "popperGenerator", function () { return $ada4301381eadd7f$export$ed5e13716264f202; });
$parcel$export($22226631ba3d4356$exports, "detectOverflow", function () { return $5c75910e995426af$export$2e2bcd8739ae039; });
$parcel$export($22226631ba3d4356$exports, "createPopperBase", function () { return $ada4301381eadd7f$export$8f7491d57c8f97a9; });
$parcel$export($22226631ba3d4356$exports, "createPopper", function () { return $bdeead69b159d288$export$8f7491d57c8f97a9; });
$parcel$export($22226631ba3d4356$exports, "createPopperLite", function () { return $91bd71f001b9e709$export$8f7491d57c8f97a9; });
var $cefd77a409472d8d$exports = {};

$parcel$export($cefd77a409472d8d$exports, "top", function () { return $cefd77a409472d8d$export$1e95b668f3b82d; });
$parcel$export($cefd77a409472d8d$exports, "bottom", function () { return $cefd77a409472d8d$export$40e543e69a8b3fbb; });
$parcel$export($cefd77a409472d8d$exports, "right", function () { return $cefd77a409472d8d$export$79ffe56a765070d2; });
$parcel$export($cefd77a409472d8d$exports, "left", function () { return $cefd77a409472d8d$export$eabcd2c8791e7bf4; });
$parcel$export($cefd77a409472d8d$exports, "auto", function () { return $cefd77a409472d8d$export$dfb5619354ba860; });
$parcel$export($cefd77a409472d8d$exports, "basePlacements", function () { return $cefd77a409472d8d$export$aec2ce47c367b8c3; });
$parcel$export($cefd77a409472d8d$exports, "start", function () { return $cefd77a409472d8d$export$b3571188c770cc5a; });
$parcel$export($cefd77a409472d8d$exports, "end", function () { return $cefd77a409472d8d$export$bd5df0f255a350f8; });
$parcel$export($cefd77a409472d8d$exports, "clippingParents", function () { return $cefd77a409472d8d$export$390fd549c5303b4d; });
$parcel$export($cefd77a409472d8d$exports, "viewport", function () { return $cefd77a409472d8d$export$d7b7311ec04a3e8f; });
$parcel$export($cefd77a409472d8d$exports, "popper", function () { return $cefd77a409472d8d$export$ae5ab1c730825774; });
$parcel$export($cefd77a409472d8d$exports, "reference", function () { return $cefd77a409472d8d$export$ca50aac9f3ba507f; });
$parcel$export($cefd77a409472d8d$exports, "variationPlacements", function () { return $cefd77a409472d8d$export$368f9a87e87fa4e1; });
$parcel$export($cefd77a409472d8d$exports, "placements", function () { return $cefd77a409472d8d$export$803cd8101b6c182b; });
$parcel$export($cefd77a409472d8d$exports, "beforeRead", function () { return $cefd77a409472d8d$export$421679a7c3d56e; });
$parcel$export($cefd77a409472d8d$exports, "read", function () { return $cefd77a409472d8d$export$aafa59e2e03f2942; });
$parcel$export($cefd77a409472d8d$exports, "afterRead", function () { return $cefd77a409472d8d$export$6964f6c886723980; });
$parcel$export($cefd77a409472d8d$exports, "beforeMain", function () { return $cefd77a409472d8d$export$c65e99957a05207c; });
$parcel$export($cefd77a409472d8d$exports, "main", function () { return $cefd77a409472d8d$export$f22da7240b7add18; });
$parcel$export($cefd77a409472d8d$exports, "afterMain", function () { return $cefd77a409472d8d$export$bab79516f2d662fe; });
$parcel$export($cefd77a409472d8d$exports, "beforeWrite", function () { return $cefd77a409472d8d$export$8d4d2d70e7d46032; });
$parcel$export($cefd77a409472d8d$exports, "write", function () { return $cefd77a409472d8d$export$68d8715fc104d294; });
$parcel$export($cefd77a409472d8d$exports, "afterWrite", function () { return $cefd77a409472d8d$export$70a6e5159acce2e6; });
$parcel$export($cefd77a409472d8d$exports, "modifierPhases", function () { return $cefd77a409472d8d$export$d087d3878fdf71d5; });
var $cefd77a409472d8d$export$1e95b668f3b82d = 'top';
var $cefd77a409472d8d$export$40e543e69a8b3fbb = 'bottom';
var $cefd77a409472d8d$export$79ffe56a765070d2 = 'right';
var $cefd77a409472d8d$export$eabcd2c8791e7bf4 = 'left';
var $cefd77a409472d8d$export$dfb5619354ba860 = 'auto';
var $cefd77a409472d8d$export$aec2ce47c367b8c3 = [
    $cefd77a409472d8d$export$1e95b668f3b82d,
    $cefd77a409472d8d$export$40e543e69a8b3fbb,
    $cefd77a409472d8d$export$79ffe56a765070d2,
    $cefd77a409472d8d$export$eabcd2c8791e7bf4
];
var $cefd77a409472d8d$export$b3571188c770cc5a = 'start';
var $cefd77a409472d8d$export$bd5df0f255a350f8 = 'end';
var $cefd77a409472d8d$export$390fd549c5303b4d = 'clippingParents';
var $cefd77a409472d8d$export$d7b7311ec04a3e8f = 'viewport';
var $cefd77a409472d8d$export$ae5ab1c730825774 = 'popper';
var $cefd77a409472d8d$export$ca50aac9f3ba507f = 'reference';
var $cefd77a409472d8d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cefd77a409472d8d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []);
var $cefd77a409472d8d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cefd77a409472d8d$export$aec2ce47c367b8c3, [
    $cefd77a409472d8d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cefd77a409472d8d$export$421679a7c3d56e = 'beforeRead';
var $cefd77a409472d8d$export$aafa59e2e03f2942 = 'read';
var $cefd77a409472d8d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $cefd77a409472d8d$export$c65e99957a05207c = 'beforeMain';
var $cefd77a409472d8d$export$f22da7240b7add18 = 'main';
var $cefd77a409472d8d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cefd77a409472d8d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $cefd77a409472d8d$export$68d8715fc104d294 = 'write';
var $cefd77a409472d8d$export$70a6e5159acce2e6 = 'afterWrite';
var $cefd77a409472d8d$export$d087d3878fdf71d5 = [
    $cefd77a409472d8d$export$421679a7c3d56e,
    $cefd77a409472d8d$export$aafa59e2e03f2942,
    $cefd77a409472d8d$export$6964f6c886723980,
    $cefd77a409472d8d$export$c65e99957a05207c,
    $cefd77a409472d8d$export$f22da7240b7add18,
    $cefd77a409472d8d$export$bab79516f2d662fe,
    $cefd77a409472d8d$export$8d4d2d70e7d46032,
    $cefd77a409472d8d$export$68d8715fc104d294,
    $cefd77a409472d8d$export$70a6e5159acce2e6
];


var $30fb6fc8419c2434$exports = {};

$parcel$export($30fb6fc8419c2434$exports, "applyStyles", function () { return $74054666164da556$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "arrow", function () { return $83dc86f42fc279ac$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "computeStyles", function () { return $3fb07310bceb7864$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "eventListeners", function () { return $e4433c3268ceda30$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "flip", function () { return $bed9f5a8c2893a90$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "hide", function () { return $222ad0d139efc5fd$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "offset", function () { return $07171abb3b970e38$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "popperOffsets", function () { return $f7ba4eded364f4f7$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "preventOverflow", function () { return $19834a509ede1e0f$export$2e2bcd8739ae039; });
function $335c1d630991db9d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $52a68dbbf79b0696$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $02e3a7a40389e518$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $02e3a7a40389e518$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $02e3a7a40389e518$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $74054666164da556$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) || !(0, $335c1d630991db9d$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $74054666164da556$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) || !(0, $335c1d630991db9d$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $74054666164da556$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $74054666164da556$var$applyStyles,
    effect: $74054666164da556$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $41b6b608ffa08ca1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $cfac5f0503fa0c0c$export$8960430cfd85939f = Math.max;
var $cfac5f0503fa0c0c$export$96ec731ed4dcb222 = Math.min;
var $cfac5f0503fa0c0c$export$2077e0241d6afd3c = Math.round;



function $0496b7e7c66765a6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b496e8e32f6ce209$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $0496b7e7c66765a6$export$2e2bcd8739ae039)());
}


function $8e6bc95b10844cc4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(element) ? (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b496e8e32f6ce209$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0af463a2f2f36779$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $78c67adc35462806$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $02e3a7a40389e518$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $aa613a05ba685ccb$export$2e2bcd8739ae039(element) {
    return (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $061cc7497f9f99cf$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $335c1d630991db9d$export$2e2bcd8739ae039)(element)) >= 0;
}




function $562fcd476b3355d2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $a13476024d635e41$export$2e2bcd8739ae039(element) {
    if ((0, $335c1d630991db9d$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $02e3a7a40389e518$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $44d2dcfa9b6528d5$var$getTrueOffsetParent(element) {
    if (!(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $44d2dcfa9b6528d5$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $0496b7e7c66765a6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $0496b7e7c66765a6$export$2e2bcd8739ae039)());
    if (isIE && (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $a13476024d635e41$export$2e2bcd8739ae039)(element);
    if ((0, $02e3a7a40389e518$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $335c1d630991db9d$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $44d2dcfa9b6528d5$export$2e2bcd8739ae039(element) {
    var window = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element);
    var offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $061cc7497f9f99cf$export$2e2bcd8739ae039)(offsetParent) && (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $335c1d630991db9d$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $335c1d630991db9d$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $44d2dcfa9b6528d5$var$getContainingBlock(element) || window;
}


function $367fb99255482738$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $af737c27d799169c$export$f28d906d67a997f3(min, value, max) {
    return (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(min, (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(value, max));
}
function $af737c27d799169c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $af737c27d799169c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $a5ee4ff71e95e5f9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $96514a6e68cf3ac6$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $a5ee4ff71e95e5f9$export$2e2bcd8739ae039)(), paddingObject);
}


function $30de99b1366d30c9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $83dc86f42fc279ac$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $96514a6e68cf3ac6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $30de99b1366d30c9$export$2e2bcd8739ae039)(padding, (0, $cefd77a409472d8d$export$aec2ce47c367b8c3)));
};
function $83dc86f42fc279ac$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $367fb99255482738$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4),
        (0, $cefd77a409472d8d$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $83dc86f42fc279ac$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0af463a2f2f36779$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $cefd77a409472d8d$export$1e95b668f3b82d) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $af737c27d799169c$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $83dc86f42fc279ac$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $78c67adc35462806$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $83dc86f42fc279ac$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $83dc86f42fc279ac$var$arrow,
    effect: $83dc86f42fc279ac$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $963149affb10e1b3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $3fb07310bceb7864$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3fb07310bceb7864$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3fb07310bceb7864$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
    var sideY = (0, $cefd77a409472d8d$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(popper);
            if ((0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cefd77a409472d8d$export$1e95b668f3b82d) || (placement === (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4) || placement === (0, $cefd77a409472d8d$export$79ffe56a765070d2)) && variation === (0, $cefd77a409472d8d$export$bd5df0f255a350f8)) {
            sideY = (0, $cefd77a409472d8d$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4) || (placement === (0, $cefd77a409472d8d$export$1e95b668f3b82d) || placement === (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)) && variation === (0, $cefd77a409472d8d$export$bd5df0f255a350f8)) {
            sideX = (0, $cefd77a409472d8d$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3fb07310bceb7864$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3fb07310bceb7864$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3fb07310bceb7864$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $963149affb10e1b3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3fb07310bceb7864$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3fb07310bceb7864$var$computeStyles,
    data: {}
};



var $e4433c3268ceda30$var$passive = {
    passive: true
};
function $e4433c3268ceda30$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e4433c3268ceda30$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e4433c3268ceda30$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e4433c3268ceda30$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e4433c3268ceda30$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e4433c3268ceda30$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e4433c3268ceda30$var$effect,
    data: {}
};


var $f1842893058158ff$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f1842893058158ff$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f1842893058158ff$var$hash[matched];
    });
}



var $52285ff45efd9816$var$hash = {
    start: 'end',
    end: 'start'
};
function $52285ff45efd9816$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $52285ff45efd9816$var$hash[matched];
    });
}








function $c4e0cf975615cf4c$export$2e2bcd8739ae039(node) {
    var win = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $30c541c7d797b61f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)((0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element)).left + (0, $c4e0cf975615cf4c$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $616485e4a91e3db8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element);
    var html = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b496e8e32f6ce209$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $30c541c7d797b61f$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $c9bc4bd93d03c0dd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c4e0cf975615cf4c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $30c541c7d797b61f$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $555c06a00f1841ba$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $4cb396b5b9e812c5$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $335c1d630991db9d$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(node) && (0, $555c06a00f1841ba$export$2e2bcd8739ae039)(node)) return node;
    return $4cb396b5b9e812c5$export$2e2bcd8739ae039((0, $a13476024d635e41$export$2e2bcd8739ae039)(node));
}





function $2faa903c271e9c84$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4cb396b5b9e812c5$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $555c06a00f1841ba$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2faa903c271e9c84$export$2e2bcd8739ae039((0, $a13476024d635e41$export$2e2bcd8739ae039)(target)));
}










function $58ad4cd3a98c7161$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $33bb425c939e76c7$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cefd77a409472d8d$export$d7b7311ec04a3e8f) ? (0, $58ad4cd3a98c7161$export$2e2bcd8739ae039)((0, $616485e4a91e3db8$export$2e2bcd8739ae039)(element, strategy)) : (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(clippingParent) ? $33bb425c939e76c7$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $58ad4cd3a98c7161$export$2e2bcd8739ae039)((0, $c9bc4bd93d03c0dd$export$2e2bcd8739ae039)((0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $33bb425c939e76c7$var$getClippingParents(element) {
    var clippingParents = (0, $2faa903c271e9c84$export$2e2bcd8739ae039)((0, $a13476024d635e41$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) ? (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(clippingParent) && (0, $78c67adc35462806$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $335c1d630991db9d$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $33bb425c939e76c7$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $33bb425c939e76c7$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $33bb425c939e76c7$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $ef298a14a6d7c348$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cefd77a409472d8d$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cefd77a409472d8d$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cefd77a409472d8d$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cefd77a409472d8d$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $367fb99255482738$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cefd77a409472d8d$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cefd77a409472d8d$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $5c75910e995426af$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cefd77a409472d8d$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cefd77a409472d8d$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cefd77a409472d8d$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $96514a6e68cf3ac6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $30de99b1366d30c9$export$2e2bcd8739ae039)(padding, (0, $cefd77a409472d8d$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $cefd77a409472d8d$export$ae5ab1c730825774) ? (0, $cefd77a409472d8d$export$ca50aac9f3ba507f) : (0, $cefd77a409472d8d$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $33bb425c939e76c7$export$2e2bcd8739ae039)((0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $ef298a14a6d7c348$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $58ad4cd3a98c7161$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cefd77a409472d8d$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cefd77a409472d8d$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cefd77a409472d8d$export$79ffe56a765070d2),
                (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cefd77a409472d8d$export$1e95b668f3b82d),
                (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $99991629c512342a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cefd77a409472d8d$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $cefd77a409472d8d$export$368f9a87e87fa4e1) : (0, $cefd77a409472d8d$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $cefd77a409472d8d$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(placement) {
    if ((0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement) === (0, $cefd77a409472d8d$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $f1842893058158ff$export$2e2bcd8739ae039)(placement);
    return [
        (0, $52285ff45efd9816$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $52285ff45efd9816$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $bed9f5a8c2893a90$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $f1842893058158ff$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement) === (0, $cefd77a409472d8d$export$dfb5619354ba860) ? (0, $99991629c512342a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement) === (0, $cefd77a409472d8d$export$b3571188c770cc5a);
        var isVertical = [
            (0, $cefd77a409472d8d$export$1e95b668f3b82d),
            (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cefd77a409472d8d$export$79ffe56a765070d2) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $f1842893058158ff$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $f1842893058158ff$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $bed9f5a8c2893a90$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $bed9f5a8c2893a90$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $222ad0d139efc5fd$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $222ad0d139efc5fd$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cefd77a409472d8d$export$1e95b668f3b82d),
        (0, $cefd77a409472d8d$export$79ffe56a765070d2),
        (0, $cefd77a409472d8d$export$40e543e69a8b3fbb),
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $222ad0d139efc5fd$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $222ad0d139efc5fd$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $222ad0d139efc5fd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $222ad0d139efc5fd$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $222ad0d139efc5fd$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $222ad0d139efc5fd$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $222ad0d139efc5fd$var$hide
};




function $07171abb3b970e38$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4),
        (0, $cefd77a409472d8d$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4),
        (0, $cefd77a409472d8d$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $07171abb3b970e38$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cefd77a409472d8d$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $07171abb3b970e38$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $07171abb3b970e38$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $07171abb3b970e38$var$offset
};



function $f7ba4eded364f4f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $ef298a14a6d7c348$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f7ba4eded364f4f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f7ba4eded364f4f7$var$popperOffsets,
    data: {}
};





function $27d0d9b036ab2393$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $19834a509ede1e0f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $963149affb10e1b3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $367fb99255482738$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $27d0d9b036ab2393$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cefd77a409472d8d$export$1e95b668f3b82d) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cefd77a409472d8d$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cefd77a409472d8d$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0af463a2f2f36779$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $a5ee4ff71e95e5f9$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $af737c27d799169c$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $af737c27d799169c$export$f28d906d67a997f3)(tether ? (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cefd77a409472d8d$export$1e95b668f3b82d) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cefd77a409472d8d$export$1e95b668f3b82d),
            (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $af737c27d799169c$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $af737c27d799169c$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $19834a509ede1e0f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $19834a509ede1e0f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $1522d2d0b08b8e74$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $6958779f792d73b3$export$2e2bcd8739ae039(node) {
    if (node === (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node) || !(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(node)) return (0, $c4e0cf975615cf4c$export$2e2bcd8739ae039)(node);
    else return (0, $1522d2d0b08b8e74$export$2e2bcd8739ae039)(node);
}








function $ba496b91dbb50203$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ba496b91dbb50203$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(offsetParent) && $ba496b91dbb50203$var$isElementScaled(offsetParent);
    var documentElement = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $335c1d630991db9d$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $555c06a00f1841ba$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $6958779f792d73b3$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $30c541c7d797b61f$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $55372a8a1c1b1368$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $55372a8a1c1b1368$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $55372a8a1c1b1368$var$order(modifiers); // order based on phase
    return (0, $cefd77a409472d8d$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $894c4f4cf7ffd620$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $05d485493b85a587$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $ada4301381eadd7f$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $ada4301381eadd7f$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $ada4301381eadd7f$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $ada4301381eadd7f$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $ada4301381eadd7f$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(reference) ? (0, $2faa903c271e9c84$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $2faa903c271e9c84$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $2faa903c271e9c84$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $55372a8a1c1b1368$export$2e2bcd8739ae039)((0, $05d485493b85a587$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$ada4301381eadd7f$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ba496b91dbb50203$export$2e2bcd8739ae039)(_$reference, (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $0af463a2f2f36779$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $894c4f4cf7ffd620$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$ada4301381eadd7f$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $ada4301381eadd7f$export$8f7491d57c8f97a9 = /*#__PURE__*/ $ada4301381eadd7f$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $bdeead69b159d288$export$d34966752335dd47 = [
    (0, $e4433c3268ceda30$export$2e2bcd8739ae039),
    (0, $f7ba4eded364f4f7$export$2e2bcd8739ae039),
    (0, $3fb07310bceb7864$export$2e2bcd8739ae039),
    (0, $74054666164da556$export$2e2bcd8739ae039),
    (0, $07171abb3b970e38$export$2e2bcd8739ae039),
    (0, $bed9f5a8c2893a90$export$2e2bcd8739ae039),
    (0, $19834a509ede1e0f$export$2e2bcd8739ae039),
    (0, $83dc86f42fc279ac$export$2e2bcd8739ae039),
    (0, $222ad0d139efc5fd$export$2e2bcd8739ae039)
];
var $bdeead69b159d288$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ada4301381eadd7f$export$ed5e13716264f202)({
    defaultModifiers: $bdeead69b159d288$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $91bd71f001b9e709$export$d34966752335dd47 = [
    (0, $e4433c3268ceda30$export$2e2bcd8739ae039),
    (0, $f7ba4eded364f4f7$export$2e2bcd8739ae039),
    (0, $3fb07310bceb7864$export$2e2bcd8739ae039),
    (0, $74054666164da556$export$2e2bcd8739ae039)
];
var $91bd71f001b9e709$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ada4301381eadd7f$export$ed5e13716264f202)({
    defaultModifiers: $91bd71f001b9e709$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($22226631ba3d4356$exports, $cefd77a409472d8d$exports);
$parcel$exportWildcard($22226631ba3d4356$exports, $30fb6fc8419c2434$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$elementMap = new Map();
var $a3e6c60bea301201$var$Data = {
    set: function(element, key, instance) {
        if (!$a3e6c60bea301201$var$elementMap.has(element)) $a3e6c60bea301201$var$elementMap.set(element, new Map());
        var instanceMap = $a3e6c60bea301201$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($a3e6c60bea301201$var$elementMap.has(element)) return $a3e6c60bea301201$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$a3e6c60bea301201$var$elementMap.has(element)) return;
        var instanceMap = $a3e6c60bea301201$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $a3e6c60bea301201$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$MAX_UID = 1000000;
var $a3e6c60bea301201$var$MILLISECONDS_MULTIPLIER = 1000;
var $a3e6c60bea301201$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $a3e6c60bea301201$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $a3e6c60bea301201$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $a3e6c60bea301201$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $a3e6c60bea301201$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $a3e6c60bea301201$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $a3e6c60bea301201$var$MILLISECONDS_MULTIPLIER;
};
var $a3e6c60bea301201$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($a3e6c60bea301201$var$TRANSITION_END));
};
var $a3e6c60bea301201$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $22yUM._)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $a3e6c60bea301201$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($a3e6c60bea301201$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($a3e6c60bea301201$var$parseSelector(object));
    return null;
};
var $a3e6c60bea301201$var$isVisible = function(element) {
    if (!$a3e6c60bea301201$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $a3e6c60bea301201$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $a3e6c60bea301201$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $a3e6c60bea301201$var$findShadowRoot(element.parentNode);
};
var $a3e6c60bea301201$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $a3e6c60bea301201$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $a3e6c60bea301201$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $a3e6c60bea301201$var$DOMContentLoadedCallbacks = [];
var $a3e6c60bea301201$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$a3e6c60bea301201$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $a3e6c60bea301201$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $a3e6c60bea301201$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $a3e6c60bea301201$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $a3e6c60bea301201$var$defineJQueryPlugin = function(plugin) {
    $a3e6c60bea301201$var$onDOMContentLoaded(function() {
        var $ = $a3e6c60bea301201$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $a3e6c60bea301201$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    return typeof possibleCallback === 'function' ? possibleCallback.apply(void 0, (0, $2b6Uo._)(args)) : defaultValue;
};
var $a3e6c60bea301201$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $a3e6c60bea301201$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $a3e6c60bea301201$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($a3e6c60bea301201$var$TRANSITION_END, handler);
        $a3e6c60bea301201$var$execute(callback);
    };
    transitionElement.addEventListener($a3e6c60bea301201$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $a3e6c60bea301201$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $a3e6c60bea301201$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $a3e6c60bea301201$var$stripNameRegex = /\..*/;
var $a3e6c60bea301201$var$stripUidRegex = /::\d+$/;
var $a3e6c60bea301201$var$eventRegistry = {}; // Events storage
var $a3e6c60bea301201$var$uidEvent = 1;
var $a3e6c60bea301201$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $a3e6c60bea301201$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $a3e6c60bea301201$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($a3e6c60bea301201$var$uidEvent++) || element.uidEvent || $a3e6c60bea301201$var$uidEvent++;
}
function $a3e6c60bea301201$var$getElementEvents(element) {
    var uid = $a3e6c60bea301201$var$makeEventUid(element);
    element.uidEvent = uid;
    $a3e6c60bea301201$var$eventRegistry[uid] = $a3e6c60bea301201$var$eventRegistry[uid] || {};
    return $a3e6c60bea301201$var$eventRegistry[uid];
}
function $a3e6c60bea301201$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $a3e6c60bea301201$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $a3e6c60bea301201$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $a3e6c60bea301201$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $a3e6c60bea301201$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $a3e6c60bea301201$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $a3e6c60bea301201$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $a3e6c60bea301201$var$getTypeEvent(originalTypeEvent);
    if (!$a3e6c60bea301201$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $a3e6c60bea301201$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $iFZdg._)($a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $a3e6c60bea301201$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $a3e6c60bea301201$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $a3e6c60bea301201$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $a3e6c60bea301201$var$makeEventUid(callable, originalTypeEvent.replace($a3e6c60bea301201$var$namespaceRegex, ''));
    var fn = isDelegated ? $a3e6c60bea301201$var$bootstrapDelegationHandler(element, handler, callable) : $a3e6c60bea301201$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $a3e6c60bea301201$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $a3e6c60bea301201$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $iFZdg._)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $a3e6c60bea301201$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($a3e6c60bea301201$var$stripNameRegex, '');
    return $a3e6c60bea301201$var$customEvents[event] || event;
}
var $a3e6c60bea301201$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $a3e6c60bea301201$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $a3e6c60bea301201$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $iFZdg._)($a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $a3e6c60bea301201$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $a3e6c60bea301201$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $iFZdg._)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($a3e6c60bea301201$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $a3e6c60bea301201$var$getjQuery();
        var typeEvent = $a3e6c60bea301201$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $a3e6c60bea301201$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $a3e6c60bea301201$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $iFZdg._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $a3e6c60bea301201$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $a3e6c60bea301201$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $a3e6c60bea301201$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = $a3e6c60bea301201$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $a3e6c60bea301201$var$normalizeData(element.getAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $a3e6c60bea301201$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $eCXNS._)(this, Config);
    }
    (0, $7M9bt._)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $a3e6c60bea301201$var$isElement(element) ? $a3e6c60bea301201$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $4udDG._)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $22yUM._)(jsonConfig)) === 'object' ? jsonConfig : {}, $a3e6c60bea301201$var$isElement(element) ? $a3e6c60bea301201$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $22yUM._)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $a3e6c60bea301201$var$isElement(value) ? 'element' : $a3e6c60bea301201$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$VERSION = '5.3.3';
/**
 * Class definition
 */ var $a3e6c60bea301201$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $eCXNS._)(this, BaseComponent);
        var _this;
        _this = (0, $g1iGh._)(this, BaseComponent);
        element = $a3e6c60bea301201$var$getElement(element);
        if (!element) return (0, $8cFxo._)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $a3e6c60bea301201$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $7M9bt._)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $a3e6c60bea301201$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $a3e6c60bea301201$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $a3e6c60bea301201$var$Data.get($a3e6c60bea301201$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $22yUM._)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $a3e6c60bea301201$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map(function(sel) {
        return $a3e6c60bea301201$var$parseSelector(sel);
    }).join(',') : null;
};
var $a3e6c60bea301201$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$a3e6c60bea301201$var$isDisabled(el) && $a3e6c60bea301201$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        if (selector) return $a3e6c60bea301201$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        return selector ? $a3e6c60bea301201$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        return selector ? $a3e6c60bea301201$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $a3e6c60bea301201$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($a3e6c60bea301201$var$isDisabled(this)) return;
        var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$f = 'alert';
var $a3e6c60bea301201$var$DATA_KEY$a = 'bs.alert';
var $a3e6c60bea301201$var$EVENT_KEY$b = ".".concat($a3e6c60bea301201$var$DATA_KEY$a);
var $a3e6c60bea301201$var$EVENT_CLOSE = "close".concat($a3e6c60bea301201$var$EVENT_KEY$b);
var $a3e6c60bea301201$var$EVENT_CLOSED = "closed".concat($a3e6c60bea301201$var$EVENT_KEY$b);
var $a3e6c60bea301201$var$CLASS_NAME_FADE$5 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $a3e6c60bea301201$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Alert, BaseComponent);
    function Alert() {
        (0, $eCXNS._)(this, Alert);
        return (0, $g1iGh._)(this, Alert, arguments);
    }
    (0, $7M9bt._)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$e = 'button';
var $a3e6c60bea301201$var$DATA_KEY$9 = 'bs.button';
var $a3e6c60bea301201$var$EVENT_KEY$a = ".".concat($a3e6c60bea301201$var$DATA_KEY$9);
var $a3e6c60bea301201$var$DATA_API_KEY$6 = '.data-api';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$3 = 'active';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$6 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$a).concat($a3e6c60bea301201$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $a3e6c60bea301201$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Button, BaseComponent);
    function Button() {
        (0, $eCXNS._)(this, Button);
        return (0, $g1iGh._)(this, Button, arguments);
    }
    (0, $7M9bt._)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$6, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5);
    var data = $a3e6c60bea301201$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$d = 'swipe';
var $a3e6c60bea301201$var$EVENT_KEY$9 = '.bs.swipe';
var $a3e6c60bea301201$var$EVENT_TOUCHSTART = "touchstart".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_TOUCHMOVE = "touchmove".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_TOUCHEND = "touchend".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_POINTERDOWN = "pointerdown".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_POINTERUP = "pointerup".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$POINTER_TYPE_TOUCH = 'touch';
var $a3e6c60bea301201$var$POINTER_TYPE_PEN = 'pen';
var $a3e6c60bea301201$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $a3e6c60bea301201$var$SWIPE_THRESHOLD = 40;
var $a3e6c60bea301201$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $a3e6c60bea301201$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(Swipe, Config);
    function Swipe(element, config) {
        (0, $eCXNS._)(this, Swipe);
        var _this;
        _this = (0, $g1iGh._)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $8cFxo._)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $7M9bt._)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$EventHandler.off(this._element, $a3e6c60bea301201$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $a3e6c60bea301201$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $a3e6c60bea301201$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $a3e6c60bea301201$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $a3e6c60bea301201$var$POINTER_TYPE_PEN || event.pointerType === $a3e6c60bea301201$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$c = 'carousel';
var $a3e6c60bea301201$var$DATA_KEY$8 = 'bs.carousel';
var $a3e6c60bea301201$var$EVENT_KEY$8 = ".".concat($a3e6c60bea301201$var$DATA_KEY$8);
var $a3e6c60bea301201$var$DATA_API_KEY$5 = '.data-api';
var $a3e6c60bea301201$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $a3e6c60bea301201$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $a3e6c60bea301201$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $a3e6c60bea301201$var$ORDER_NEXT = 'next';
var $a3e6c60bea301201$var$ORDER_PREV = 'prev';
var $a3e6c60bea301201$var$DIRECTION_LEFT = 'left';
var $a3e6c60bea301201$var$DIRECTION_RIGHT = 'right';
var $a3e6c60bea301201$var$EVENT_SLIDE = "slide".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_SLID = "slid".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_KEYDOWN$1 = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_DRAG_START = "dragstart".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$3 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$8).concat($a3e6c60bea301201$var$DATA_API_KEY$5);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$5 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$8).concat($a3e6c60bea301201$var$DATA_API_KEY$5);
var $a3e6c60bea301201$var$CLASS_NAME_CAROUSEL = 'carousel';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2 = 'active';
var $a3e6c60bea301201$var$CLASS_NAME_SLIDE = 'slide';
var $a3e6c60bea301201$var$CLASS_NAME_END = 'carousel-item-end';
var $a3e6c60bea301201$var$CLASS_NAME_START = 'carousel-item-start';
var $a3e6c60bea301201$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $a3e6c60bea301201$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $a3e6c60bea301201$var$SELECTOR_ACTIVE = '.active';
var $a3e6c60bea301201$var$SELECTOR_ITEM = '.carousel-item';
var $a3e6c60bea301201$var$SELECTOR_ACTIVE_ITEM = $a3e6c60bea301201$var$SELECTOR_ACTIVE + $a3e6c60bea301201$var$SELECTOR_ITEM;
var $a3e6c60bea301201$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $a3e6c60bea301201$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $a3e6c60bea301201$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $a3e6c60bea301201$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $a3e6c60bea301201$var$_obj;
var $a3e6c60bea301201$var$KEY_TO_DIRECTION = ($a3e6c60bea301201$var$_obj = {}, (0, $9HFeY._)($a3e6c60bea301201$var$_obj, $a3e6c60bea301201$var$ARROW_LEFT_KEY$1, $a3e6c60bea301201$var$DIRECTION_RIGHT), (0, $9HFeY._)($a3e6c60bea301201$var$_obj, $a3e6c60bea301201$var$ARROW_RIGHT_KEY$1, $a3e6c60bea301201$var$DIRECTION_LEFT), $a3e6c60bea301201$var$_obj);
var $a3e6c60bea301201$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $a3e6c60bea301201$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $eCXNS._)(this, Carousel);
        var _this;
        _this = (0, $g1iGh._)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $a3e6c60bea301201$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $7M9bt._)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($a3e6c60bea301201$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $a3e6c60bea301201$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($a3e6c60bea301201$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $a3e6c60bea301201$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $a3e6c60bea301201$var$EventHandler.one(this._element, $a3e6c60bea301201$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $a3e6c60bea301201$var$EventHandler.one(this._element, $a3e6c60bea301201$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $a3e6c60bea301201$var$ORDER_NEXT : $a3e6c60bea301201$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $a3e6c60bea301201$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(img, $a3e6c60bea301201$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $a3e6c60bea301201$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($a3e6c60bea301201$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($a3e6c60bea301201$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $a3e6c60bea301201$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $a3e6c60bea301201$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $a3e6c60bea301201$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $a3e6c60bea301201$var$ORDER_NEXT;
                var nextElement = element || $a3e6c60bea301201$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $a3e6c60bea301201$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($a3e6c60bea301201$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $a3e6c60bea301201$var$CLASS_NAME_START : $a3e6c60bea301201$var$CLASS_NAME_END;
                var orderClassName = isNext ? $a3e6c60bea301201$var$CLASS_NAME_NEXT : $a3e6c60bea301201$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $a3e6c60bea301201$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($a3e6c60bea301201$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($a3e6c60bea301201$var$isRTL()) return direction === $a3e6c60bea301201$var$DIRECTION_LEFT ? $a3e6c60bea301201$var$ORDER_PREV : $a3e6c60bea301201$var$ORDER_NEXT;
                return direction === $a3e6c60bea301201$var$DIRECTION_LEFT ? $a3e6c60bea301201$var$ORDER_NEXT : $a3e6c60bea301201$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($a3e6c60bea301201$var$isRTL()) return order === $a3e6c60bea301201$var$ORDER_PREV ? $a3e6c60bea301201$var$DIRECTION_LEFT : $a3e6c60bea301201$var$DIRECTION_RIGHT;
                return order === $a3e6c60bea301201$var$ORDER_PREV ? $a3e6c60bea301201$var$DIRECTION_RIGHT : $a3e6c60bea301201$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$5, $a3e6c60bea301201$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($a3e6c60bea301201$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $a3e6c60bea301201$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($a3e6c60bea301201$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $a3e6c60bea301201$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$b = 'collapse';
var $a3e6c60bea301201$var$DATA_KEY$7 = 'bs.collapse';
var $a3e6c60bea301201$var$EVENT_KEY$7 = ".".concat($a3e6c60bea301201$var$DATA_KEY$7);
var $a3e6c60bea301201$var$DATA_API_KEY$4 = '.data-api';
var $a3e6c60bea301201$var$EVENT_SHOW$6 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_SHOWN$6 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_HIDE$6 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_HIDDEN$6 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$4 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$7).concat($a3e6c60bea301201$var$DATA_API_KEY$4);
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$7 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSE = 'collapse';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $a3e6c60bea301201$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, " .").concat($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
var $a3e6c60bea301201$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $a3e6c60bea301201$var$WIDTH = 'width';
var $a3e6c60bea301201$var$HEIGHT = 'height';
var $a3e6c60bea301201$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $a3e6c60bea301201$var$Default$a = {
    parent: null,
    toggle: true
};
var $a3e6c60bea301201$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $eCXNS._)(this, Collapse);
        var _this;
        _this = (0, $g1iGh._)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $a3e6c60bea301201$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $a3e6c60bea301201$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $7M9bt._)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($a3e6c60bea301201$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, $a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, $a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $a3e6c60bea301201$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_HORIZONTAL) ? $a3e6c60bea301201$var$WIDTH : $a3e6c60bea301201$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $a3e6c60bea301201$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($a3e6c60bea301201$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$4, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $a3e6c60bea301201$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$a = 'dropdown';
var $a3e6c60bea301201$var$DATA_KEY$6 = 'bs.dropdown';
var $a3e6c60bea301201$var$EVENT_KEY$6 = ".".concat($a3e6c60bea301201$var$DATA_KEY$6);
var $a3e6c60bea301201$var$DATA_API_KEY$3 = '.data-api';
var $a3e6c60bea301201$var$ESCAPE_KEY$2 = 'Escape';
var $a3e6c60bea301201$var$TAB_KEY$1 = 'Tab';
var $a3e6c60bea301201$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $a3e6c60bea301201$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $a3e6c60bea301201$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $a3e6c60bea301201$var$EVENT_HIDE$5 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_HIDDEN$5 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_SHOW$5 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_SHOWN$5 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$EVENT_KEYUP_DATA_API = "keyup".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$6 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_DROPUP = 'dropup';
var $a3e6c60bea301201$var$CLASS_NAME_DROPEND = 'dropend';
var $a3e6c60bea301201$var$CLASS_NAME_DROPSTART = 'dropstart';
var $a3e6c60bea301201$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, ".").concat($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
var $a3e6c60bea301201$var$SELECTOR_MENU = '.dropdown-menu';
var $a3e6c60bea301201$var$SELECTOR_NAVBAR = '.navbar';
var $a3e6c60bea301201$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $a3e6c60bea301201$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $a3e6c60bea301201$var$PLACEMENT_TOP = $a3e6c60bea301201$var$isRTL() ? 'top-end' : 'top-start';
var $a3e6c60bea301201$var$PLACEMENT_TOPEND = $a3e6c60bea301201$var$isRTL() ? 'top-start' : 'top-end';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOM = $a3e6c60bea301201$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOMEND = $a3e6c60bea301201$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $a3e6c60bea301201$var$PLACEMENT_RIGHT = $a3e6c60bea301201$var$isRTL() ? 'left-start' : 'right-start';
var $a3e6c60bea301201$var$PLACEMENT_LEFT = $a3e6c60bea301201$var$isRTL() ? 'right-start' : 'left-start';
var $a3e6c60bea301201$var$PLACEMENT_TOPCENTER = 'top';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $a3e6c60bea301201$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $a3e6c60bea301201$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $eCXNS._)(this, Dropdown);
        var _this;
        _this = (0, $g1iGh._)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $a3e6c60bea301201$var$SelectorEngine.next(_this._element, $a3e6c60bea301201$var$SELECTOR_MENU)[0] || $a3e6c60bea301201$var$SelectorEngine.prev(_this._element, $a3e6c60bea301201$var$SELECTOR_MENU)[0] || $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $7M9bt._)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($a3e6c60bea301201$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($a3e6c60bea301201$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($a3e6c60bea301201$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.off(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $a3e6c60bea301201$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$5, relatedTarget);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $22yUM._)(config.reference) === 'object' && !$a3e6c60bea301201$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($a3e6c60bea301201$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $22226631ba3d4356$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($a3e6c60bea301201$var$isElement(this._config.reference)) referenceElement = $a3e6c60bea301201$var$getElement(this._config.reference);
                else if ((0, $22yUM._)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $22226631ba3d4356$exports.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPEND)) return $a3e6c60bea301201$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPSTART)) return $a3e6c60bea301201$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPUP_CENTER)) return $a3e6c60bea301201$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_CENTER)) return $a3e6c60bea301201$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPUP)) return isEnd ? $a3e6c60bea301201$var$PLACEMENT_TOPEND : $a3e6c60bea301201$var$PLACEMENT_TOP;
                return isEnd ? $a3e6c60bea301201$var$PLACEMENT_BOTTOMEND : $a3e6c60bea301201$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($a3e6c60bea301201$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $a3e6c60bea301201$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $4udDG._)({}, defaultBsPopperConfig, $a3e6c60bea301201$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $a3e6c60bea301201$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $a3e6c60bea301201$var$getNextActiveElement(items, target, key === $a3e6c60bea301201$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $a3e6c60bea301201$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $a3e6c60bea301201$var$TAB_KEY$1) return;
                var openToggles = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $a3e6c60bea301201$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $a3e6c60bea301201$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $a3e6c60bea301201$var$ARROW_UP_KEY$1,
                    $a3e6c60bea301201$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3) ? this : $a3e6c60bea301201$var$SelectorEngine.prev(this, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3)[0] || $a3e6c60bea301201$var$SelectorEngine.next(this, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3)[0] || $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, $a3e6c60bea301201$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API, $a3e6c60bea301201$var$SELECTOR_MENU, $a3e6c60bea301201$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3, $a3e6c60bea301201$export$931cbfb6bfb85fc.clearMenus);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYUP_DATA_API, $a3e6c60bea301201$export$931cbfb6bfb85fc.clearMenus);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $a3e6c60bea301201$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$9 = 'backdrop';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$4 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$5 = 'show';
var $a3e6c60bea301201$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($a3e6c60bea301201$var$NAME$9);
var $a3e6c60bea301201$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $a3e6c60bea301201$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(Backdrop, Config);
    function Backdrop(config) {
        (0, $eCXNS._)(this, Backdrop);
        var _this;
        _this = (0, $g1iGh._)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $7M9bt._)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $a3e6c60bea301201$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $a3e6c60bea301201$var$reflow(element);
                element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $a3e6c60bea301201$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $a3e6c60bea301201$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $a3e6c60bea301201$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $a3e6c60bea301201$var$EventHandler.off(this._element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $a3e6c60bea301201$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $a3e6c60bea301201$var$EventHandler.on(element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN, function() {
                    $a3e6c60bea301201$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $a3e6c60bea301201$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$8 = 'focustrap';
var $a3e6c60bea301201$var$DATA_KEY$5 = 'bs.focustrap';
var $a3e6c60bea301201$var$EVENT_KEY$5 = ".".concat($a3e6c60bea301201$var$DATA_KEY$5);
var $a3e6c60bea301201$var$EVENT_FOCUSIN$2 = "focusin".concat($a3e6c60bea301201$var$EVENT_KEY$5);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($a3e6c60bea301201$var$EVENT_KEY$5);
var $a3e6c60bea301201$var$TAB_KEY = 'Tab';
var $a3e6c60bea301201$var$TAB_NAV_FORWARD = 'forward';
var $a3e6c60bea301201$var$TAB_NAV_BACKWARD = 'backward';
var $a3e6c60bea301201$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $a3e6c60bea301201$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $eCXNS._)(this, FocusTrap);
        var _this;
        _this = (0, $g1iGh._)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $7M9bt._)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $a3e6c60bea301201$var$EventHandler.off(document, $a3e6c60bea301201$var$EVENT_KEY$5); // guard against infinite focus loop
                $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $a3e6c60bea301201$var$EventHandler.off(document, $a3e6c60bea301201$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $a3e6c60bea301201$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $a3e6c60bea301201$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $a3e6c60bea301201$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $a3e6c60bea301201$var$TAB_NAV_BACKWARD : $a3e6c60bea301201$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $a3e6c60bea301201$var$PROPERTY_PADDING = 'padding-right';
var $a3e6c60bea301201$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $a3e6c60bea301201$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $eCXNS._)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $7M9bt._)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $a3e6c60bea301201$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT, $a3e6c60bea301201$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT, $a3e6c60bea301201$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $a3e6c60bea301201$var$PROPERTY_PADDING);
                this._resetElementAttributes($a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT, $a3e6c60bea301201$var$PROPERTY_PADDING);
                this._resetElementAttributes($a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT, $a3e6c60bea301201$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $a3e6c60bea301201$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $a3e6c60bea301201$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $a3e6c60bea301201$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($a3e6c60bea301201$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$7 = 'modal';
var $a3e6c60bea301201$var$DATA_KEY$4 = 'bs.modal';
var $a3e6c60bea301201$var$EVENT_KEY$4 = ".".concat($a3e6c60bea301201$var$DATA_KEY$4);
var $a3e6c60bea301201$var$DATA_API_KEY$2 = '.data-api';
var $a3e6c60bea301201$var$ESCAPE_KEY$1 = 'Escape';
var $a3e6c60bea301201$var$EVENT_HIDE$4 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_HIDDEN$4 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_SHOW$4 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_SHOWN$4 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_RESIZE$1 = "resize".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$2 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$4).concat($a3e6c60bea301201$var$DATA_API_KEY$2);
var $a3e6c60bea301201$var$CLASS_NAME_OPEN = 'modal-open';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$3 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$4 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_STATIC = 'modal-static';
var $a3e6c60bea301201$var$OPEN_SELECTOR$1 = '.modal.show';
var $a3e6c60bea301201$var$SELECTOR_DIALOG = '.modal-dialog';
var $a3e6c60bea301201$var$SELECTOR_MODAL_BODY = '.modal-body';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $a3e6c60bea301201$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $a3e6c60bea301201$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $eCXNS._)(this, Modal);
        var _this;
        _this = (0, $g1iGh._)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $a3e6c60bea301201$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $7M9bt._)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($a3e6c60bea301201$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$EventHandler.off(window, $a3e6c60bea301201$var$EVENT_KEY$4);
                $a3e6c60bea301201$var$EventHandler.off(this._dialog, $a3e6c60bea301201$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $a3e6c60bea301201$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $a3e6c60bea301201$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $a3e6c60bea301201$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $a3e6c60bea301201$var$EventHandler.one(_this._element, $a3e6c60bea301201$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($a3e6c60bea301201$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $a3e6c60bea301201$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $a3e6c60bea301201$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$2, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_HIDDEN$4, function() {
            if ($a3e6c60bea301201$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $a3e6c60bea301201$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $a3e6c60bea301201$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$6 = 'offcanvas';
var $a3e6c60bea301201$var$DATA_KEY$3 = 'bs.offcanvas';
var $a3e6c60bea301201$var$EVENT_KEY$3 = ".".concat($a3e6c60bea301201$var$DATA_KEY$3);
var $a3e6c60bea301201$var$DATA_API_KEY$1 = '.data-api';
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$2 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$3).concat($a3e6c60bea301201$var$DATA_API_KEY$1);
var $a3e6c60bea301201$var$ESCAPE_KEY = 'Escape';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$3 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_SHOWING$1 = 'showing';
var $a3e6c60bea301201$var$CLASS_NAME_HIDING = 'hiding';
var $a3e6c60bea301201$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $a3e6c60bea301201$var$OPEN_SELECTOR = '.offcanvas.show';
var $a3e6c60bea301201$var$EVENT_SHOW$3 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_SHOWN$3 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDE$3 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDDEN$3 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_RESIZE = "resize".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$1 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$3).concat($a3e6c60bea301201$var$DATA_API_KEY$1);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $a3e6c60bea301201$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $a3e6c60bea301201$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $eCXNS._)(this, Offcanvas);
        var _this;
        _this = (0, $g1iGh._)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $7M9bt._)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $a3e6c60bea301201$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING$1);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$3, $a3e6c60bea301201$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $a3e6c60bea301201$var$ScrollBarHelper().reset();
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $a3e6c60bea301201$var$Backdrop({
                    className: $a3e6c60bea301201$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $a3e6c60bea301201$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $a3e6c60bea301201$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$1, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($a3e6c60bea301201$var$isDisabled(this)) return;
    $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($a3e6c60bea301201$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $a3e6c60bea301201$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $a3e6c60bea301201$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $a3e6c60bea301201$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $a3e6c60bea301201$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $a3e6c60bea301201$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
var $a3e6c60bea301201$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $a3e6c60bea301201$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($a3e6c60bea301201$var$uriAttributes.has(attributeName)) return Boolean($a3e6c60bea301201$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $a3e6c60bea301201$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $2b6Uo._)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$a3e6c60bea301201$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$5 = 'TemplateFactory';
var $a3e6c60bea301201$var$Default$4 = {
    allowList: $a3e6c60bea301201$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $a3e6c60bea301201$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $a3e6c60bea301201$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $eCXNS._)(this, TemplateFactory);
        var _this;
        _this = (0, $g1iGh._)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $7M9bt._)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $4udDG._)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $2b6Uo._)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $a3e6c60bea301201$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $a3e6c60bea301201$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($a3e6c60bea301201$var$isElement(content)) {
                    this._putElementInTemplate($a3e6c60bea301201$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $a3e6c60bea301201$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $a3e6c60bea301201$var$execute(arg, [
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$4 = 'tooltip';
var $a3e6c60bea301201$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $a3e6c60bea301201$var$CLASS_NAME_FADE$2 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_MODAL = 'modal';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$2 = 'show';
var $a3e6c60bea301201$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $a3e6c60bea301201$var$SELECTOR_MODAL = ".".concat($a3e6c60bea301201$var$CLASS_NAME_MODAL);
var $a3e6c60bea301201$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $a3e6c60bea301201$var$TRIGGER_HOVER = 'hover';
var $a3e6c60bea301201$var$TRIGGER_FOCUS = 'focus';
var $a3e6c60bea301201$var$TRIGGER_CLICK = 'click';
var $a3e6c60bea301201$var$TRIGGER_MANUAL = 'manual';
var $a3e6c60bea301201$var$EVENT_HIDE$2 = 'hide';
var $a3e6c60bea301201$var$EVENT_HIDDEN$2 = 'hidden';
var $a3e6c60bea301201$var$EVENT_SHOW$2 = 'show';
var $a3e6c60bea301201$var$EVENT_SHOWN$2 = 'shown';
var $a3e6c60bea301201$var$EVENT_INSERTED = 'inserted';
var $a3e6c60bea301201$var$EVENT_CLICK$1 = 'click';
var $a3e6c60bea301201$var$EVENT_FOCUSIN$1 = 'focusin';
var $a3e6c60bea301201$var$EVENT_FOCUSOUT$1 = 'focusout';
var $a3e6c60bea301201$var$EVENT_MOUSEENTER = 'mouseenter';
var $a3e6c60bea301201$var$EVENT_MOUSELEAVE = 'mouseleave';
var $a3e6c60bea301201$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $a3e6c60bea301201$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $a3e6c60bea301201$var$isRTL() ? 'right' : 'left'
};
var $a3e6c60bea301201$var$Default$3 = {
    allowList: $a3e6c60bea301201$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $a3e6c60bea301201$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $eCXNS._)(this, Tooltip);
        var _this;
        if (typeof $22226631ba3d4356$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        _this = (0, $g1iGh._)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $7M9bt._)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                this._activeTrigger.click = !this._activeTrigger.click;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $a3e6c60bea301201$var$EventHandler.off(this._element.closest($a3e6c60bea301201$var$SELECTOR_MODAL), $a3e6c60bea301201$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_SHOW$2));
                var shadowRoot = $a3e6c60bea301201$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, _this.constructor.eventName($a3e6c60bea301201$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.off(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, _this.constructor.eventName($a3e6c60bea301201$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($a3e6c60bea301201$var$CLASS_NAME_FADE$2, $a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $a3e6c60bea301201$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $a3e6c60bea301201$var$TemplateFactory((0, $82dbc585330cff66$export$71511d61b312f219)((0, $4udDG._)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $9HFeY._)({}, $a3e6c60bea301201$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $a3e6c60bea301201$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $a3e6c60bea301201$var$AttachmentMap[placement.toUpperCase()];
                return $22226631ba3d4356$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $a3e6c60bea301201$var$execute(arg, [
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $4udDG._)({}, defaultBsPopperConfig, $a3e6c60bea301201$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $a3e6c60bea301201$var$EventHandler.on(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context.toggle();
                        });
                        else if (trigger !== $a3e6c60bea301201$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $a3e6c60bea301201$var$TRIGGER_HOVER ? this.constructor.eventName($a3e6c60bea301201$var$EVENT_MOUSEENTER) : this.constructor.eventName($a3e6c60bea301201$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $a3e6c60bea301201$var$TRIGGER_HOVER ? this.constructor.eventName($a3e6c60bea301201$var$EVENT_MOUSELEAVE) : this.constructor.eventName($a3e6c60bea301201$var$EVENT_FOCUSOUT$1);
                            $a3e6c60bea301201$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $a3e6c60bea301201$var$TRIGGER_FOCUS : $a3e6c60bea301201$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $a3e6c60bea301201$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $a3e6c60bea301201$var$TRIGGER_FOCUS : $a3e6c60bea301201$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $a3e6c60bea301201$var$EventHandler.on(this._element.closest($a3e6c60bea301201$var$SELECTOR_MODAL), $a3e6c60bea301201$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $a3e6c60bea301201$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($a3e6c60bea301201$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $4udDG._)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $22yUM._)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $a3e6c60bea301201$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$3 = 'popover';
var $a3e6c60bea301201$var$SELECTOR_TITLE = '.popover-header';
var $a3e6c60bea301201$var$SELECTOR_CONTENT = '.popover-body';
var $a3e6c60bea301201$var$Default$2 = (0, $82dbc585330cff66$export$71511d61b312f219)((0, $4udDG._)({}, $a3e6c60bea301201$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $a3e6c60bea301201$var$DefaultType$2 = (0, $82dbc585330cff66$export$71511d61b312f219)((0, $4udDG._)({}, $a3e6c60bea301201$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $a3e6c60bea301201$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $5IDCd._)(Popover, Tooltip);
    function Popover() {
        (0, $eCXNS._)(this, Popover);
        return (0, $g1iGh._)(this, Popover, arguments);
    }
    (0, $7M9bt._)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $9HFeY._)(_obj, $a3e6c60bea301201$var$SELECTOR_TITLE, this._getTitle()), (0, $9HFeY._)(_obj, $a3e6c60bea301201$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($a3e6c60bea301201$export$28c660c63b792dea);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$2 = 'scrollspy';
var $a3e6c60bea301201$var$DATA_KEY$2 = 'bs.scrollspy';
var $a3e6c60bea301201$var$EVENT_KEY$2 = ".".concat($a3e6c60bea301201$var$DATA_KEY$2);
var $a3e6c60bea301201$var$DATA_API_KEY = '.data-api';
var $a3e6c60bea301201$var$EVENT_ACTIVATE = "activate".concat($a3e6c60bea301201$var$EVENT_KEY$2);
var $a3e6c60bea301201$var$EVENT_CLICK = "click".concat($a3e6c60bea301201$var$EVENT_KEY$2);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$1 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$2).concat($a3e6c60bea301201$var$DATA_API_KEY);
var $a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1 = 'active';
var $a3e6c60bea301201$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $a3e6c60bea301201$var$SELECTOR_TARGET_LINKS = '[href]';
var $a3e6c60bea301201$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $a3e6c60bea301201$var$SELECTOR_NAV_LINKS = '.nav-link';
var $a3e6c60bea301201$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $a3e6c60bea301201$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $a3e6c60bea301201$var$SELECTOR_LINK_ITEMS = "".concat($a3e6c60bea301201$var$SELECTOR_NAV_LINKS, ", ").concat($a3e6c60bea301201$var$SELECTOR_NAV_ITEMS, " > ").concat($a3e6c60bea301201$var$SELECTOR_NAV_LINKS, ", ").concat($a3e6c60bea301201$var$SELECTOR_LIST_ITEMS);
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN = '.dropdown';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $a3e6c60bea301201$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $a3e6c60bea301201$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $eCXNS._)(this, ScrollSpy);
        var _this;
        _this = (0, $g1iGh._)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $7M9bt._)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $a3e6c60bea301201$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $a3e6c60bea301201$var$EventHandler.off(this._config.target, $a3e6c60bea301201$var$EVENT_CLICK);
                $a3e6c60bea301201$var$EventHandler.on(this._config.target, $a3e6c60bea301201$var$EVENT_CLICK, $a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $a3e6c60bea301201$var$isDisabled(anchor)) continue;
                        var observableSection = $a3e6c60bea301201$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($a3e6c60bea301201$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($a3e6c60bea301201$var$SELECTOR_DROPDOWN)).classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.parents(target, $a3e6c60bea301201$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $a3e6c60bea301201$var$SelectorEngine.prev(listGroup, $a3e6c60bea301201$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $a3e6c60bea301201$var$SelectorEngine.find("".concat($a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, ".").concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $a3e6c60bea301201$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$1 = 'tab';
var $a3e6c60bea301201$var$DATA_KEY$1 = 'bs.tab';
var $a3e6c60bea301201$var$EVENT_KEY$1 = ".".concat($a3e6c60bea301201$var$DATA_KEY$1);
var $a3e6c60bea301201$var$EVENT_HIDE$1 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_HIDDEN$1 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_SHOW$1 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_SHOWN$1 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API = "click".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_KEYDOWN = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API = "load".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $a3e6c60bea301201$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $a3e6c60bea301201$var$ARROW_UP_KEY = 'ArrowUp';
var $a3e6c60bea301201$var$ARROW_DOWN_KEY = 'ArrowDown';
var $a3e6c60bea301201$var$HOME_KEY = 'Home';
var $a3e6c60bea301201$var$END_KEY = 'End';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE = 'active';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$1 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$1 = 'show';
var $a3e6c60bea301201$var$CLASS_DROPDOWN = 'dropdown';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $a3e6c60bea301201$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $a3e6c60bea301201$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $a3e6c60bea301201$var$SELECTOR_INNER = ".nav-link".concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $a3e6c60bea301201$var$SELECTOR_INNER_ELEM = "".concat($a3e6c60bea301201$var$SELECTOR_INNER, ", ").concat($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $a3e6c60bea301201$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Tab, BaseComponent);
    function Tab(element) {
        (0, $eCXNS._)(this, Tab);
        var _this;
        _this = (0, $g1iGh._)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($a3e6c60bea301201$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $8cFxo._)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $a3e6c60bea301201$var$EventHandler.on(_this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $7M9bt._)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $a3e6c60bea301201$var$EventHandler.trigger(active, $a3e6c60bea301201$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(innerElem, $a3e6c60bea301201$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                this._activate($a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $a3e6c60bea301201$var$EventHandler.trigger(element, $a3e6c60bea301201$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $a3e6c60bea301201$var$EventHandler.trigger(element, $a3e6c60bea301201$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $a3e6c60bea301201$var$ARROW_LEFT_KEY,
                    $a3e6c60bea301201$var$ARROW_RIGHT_KEY,
                    $a3e6c60bea301201$var$ARROW_UP_KEY,
                    $a3e6c60bea301201$var$ARROW_DOWN_KEY,
                    $a3e6c60bea301201$var$HOME_KEY,
                    $a3e6c60bea301201$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$a3e6c60bea301201$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $a3e6c60bea301201$var$HOME_KEY,
                    $a3e6c60bea301201$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $a3e6c60bea301201$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $a3e6c60bea301201$var$ARROW_RIGHT_KEY,
                        $a3e6c60bea301201$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $a3e6c60bea301201$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($a3e6c60bea301201$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $a3e6c60bea301201$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE, $a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                toggle($a3e6c60bea301201$var$SELECTOR_DROPDOWN_MENU, $a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($a3e6c60bea301201$var$SELECTOR_INNER_ELEM) ? elem : $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($a3e6c60bea301201$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($a3e6c60bea301201$var$isDisabled(this)) return;
    $a3e6c60bea301201$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $a3e6c60bea301201$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME = 'toast';
var $a3e6c60bea301201$var$DATA_KEY = 'bs.toast';
var $a3e6c60bea301201$var$EVENT_KEY = ".".concat($a3e6c60bea301201$var$DATA_KEY);
var $a3e6c60bea301201$var$EVENT_MOUSEOVER = "mouseover".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_MOUSEOUT = "mouseout".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_FOCUSIN = "focusin".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_FOCUSOUT = "focusout".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_HIDE = "hide".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_HIDDEN = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_SHOW = "show".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_SHOWN = "shown".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$CLASS_NAME_FADE = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $a3e6c60bea301201$var$CLASS_NAME_SHOW = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_SHOWING = 'showing';
var $a3e6c60bea301201$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $a3e6c60bea301201$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $eCXNS._)(this, Toast);
        var _this;
        _this = (0, $g1iGh._)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $7M9bt._)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_HIDE); // @deprecated
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW, $a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING, $a3e6c60bea301201$var$CLASS_NAME_SHOW);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN);
                };
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW);
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $hzVoy._)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$8d8dc7d5f743331b);


// Scroll To Top Button
var $41cd67c878bc7559$exports = {};
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if (0, $41cd67c878bc7559$exports) {
    var $41cd67c878bc7559$var$Flickity = (parcelRequire("a9AlG"));
    (parcelRequire("efOuG"));
    (parcelRequire("fGfjf"));
    (parcelRequire("1KrC3"));
    (parcelRequire("2Icld"));
    (parcelRequire("24jq9"));
    (parcelRequire("7LFoK"));
    (parcelRequire("qngma"));
    $41cd67c878bc7559$exports = $41cd67c878bc7559$var$Flickity;
}


function $f7c23755e44054e0$export$3edbe7f15b86182e(image, caption) {
    var lightBoxContainer = document.createElement("div");
    var lightBoxContent = document.createElement("div");
    var lightBoxImg = document.createElement("img");
    lightBoxContainer.classList.add("lightbox");
    lightBoxContent.classList.add("lightbox-content");
    lightBoxContainer.appendChild(lightBoxContent);
    lightBoxContent.appendChild(lightBoxImg);
    // caption
    if (caption) {
        var lightBoxCaption = document.createElement("div");
        lightBoxCaption.classList.add('lightbox-caption');
        lightBoxCaption.textContent = caption;
        lightBoxContent.appendChild(lightBoxCaption);
    }
    document.body.appendChild(lightBoxContainer);
    lightBoxContainer.style.display = "block";
    lightBoxImg.setAttribute("src", image);
    function closeLightBox() {
        if (this === event.target) lightBoxContainer.style.display = "none";
    }
    lightBoxContainer.addEventListener("click", closeLightBox);
}


if (document.querySelectorAll("#back-to-top").length) {
    var $e77e57f2abfd97c1$var$scrollFunction = function scrollFunction() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) $e77e57f2abfd97c1$var$mybutton.style.display = "block";
        else $e77e57f2abfd97c1$var$mybutton.style.display = "none";
    };
    var $e77e57f2abfd97c1$var$topFunction = function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };
    var $e77e57f2abfd97c1$var$mybutton = document.getElementById("back-to-top");
    window.onscroll = function() {
        $e77e57f2abfd97c1$var$scrollFunction();
    };
    document.getElementById("back-to-top").onclick = function() {
        $e77e57f2abfd97c1$var$topFunction();
    };
}
// Metanav - Slide Up On Scroll
// if (document.querySelectorAll("#metanav").length) {
//   let scrollpos = window.scrollY
//   const header = document.getElementById("metanav")
//   const scrollChange = 1
//   const add_class_on_scroll = () => header.classList.add("display-none")
//   const remove_class_on_scroll = () => header.classList.remove("display-none")
//   window.addEventListener('scroll', function() {
//     scrollpos = window.scrollY;
//     if (scrollpos >= scrollChange) { add_class_on_scroll() }
//     else { remove_class_on_scroll() }
//   })
// }
// Navbar  - Change height on Scroll
if (document.querySelectorAll("#nav-height").length) {
    var $e77e57f2abfd97c1$var$scrollpos = window.scrollY;
    var $e77e57f2abfd97c1$var$header = document.getElementById("nav-height");
    var $e77e57f2abfd97c1$var$scrollChange = 1;
    var $e77e57f2abfd97c1$var$add_class_on_scroll = function() {
        return $e77e57f2abfd97c1$var$header.classList.add("sticky");
    };
    var $e77e57f2abfd97c1$var$remove_class_on_scroll = function() {
        return $e77e57f2abfd97c1$var$header.classList.remove("sticky");
    };
    window.addEventListener('scroll', function() {
        $e77e57f2abfd97c1$var$scrollpos = window.scrollY;
        if ($e77e57f2abfd97c1$var$scrollpos >= $e77e57f2abfd97c1$var$scrollChange) $e77e57f2abfd97c1$var$add_class_on_scroll();
        else $e77e57f2abfd97c1$var$remove_class_on_scroll();
    });
}
// Dropdown opens on mousehover
document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth > 992) document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem) {
        everyitem.addEventListener('mouseover', function(e) {
            var el_link = this.querySelector('a[data-bs-toggle]');
            if (el_link != null) {
                var nextEl = el_link.nextElementSibling;
                el_link.classList.add('show');
                nextEl.classList.add('show');
            }
        });
        everyitem.addEventListener('mouseleave', function(e) {
            var el_link = this.querySelector('a[data-bs-toggle]');
            if (el_link != null) {
                var nextEl = el_link.nextElementSibling;
                el_link.classList.remove('show');
                nextEl.classList.remove('show');
            }
        });
    });
});
var $e77e57f2abfd97c1$var$infinitySlider = document.querySelectorAll('.main-carousel');
$e77e57f2abfd97c1$var$infinitySlider.forEach(function(carouselImage) {
    var carousel = new (0, (/*@__PURE__*/$parcel$interopDefault($41cd67c878bc7559$exports)))(carouselImage, {
        // options
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        wrapAround: true
    });
    carousel.on('staticClick', function(event, pointer, cellElement, cellIndex) {
        if (!cellElement || !cellElement.classList.contains('with-lightbox')) return;
        (0, $f7c23755e44054e0$export$3edbe7f15b86182e)(cellElement.dataset.image, cellElement.dataset.caption);
    });
});
if (document.querySelectorAll("#contact-flap").length) document.querySelector('#contact-flap').addEventListener('click', function(event) {
    event.preventDefault();
    var target = document.querySelector('#contact-flap');
    if (target.classList.contains('open')) target.classList.remove('open');
    else target.classList.add('open');
});


// if (document.querySelectorAll("#heroHeader").length) {
//   let scrollpos = window.scrollY
//   const header = document.getElementById("heroHeader")
//   const scrollChange = 1
//   const add_class_on_scroll = () => header.classList.add("sticky")
//   const remove_class_on_scroll = () => header.classList.remove("sticky")
//   window.addEventListener('scroll', function() { 
//     scrollpos = window.scrollY;
//     if (scrollpos >= scrollChange) { add_class_on_scroll() }
//     else { remove_class_on_scroll() }
//   })
// }
// else {
//   alert("The element does not exist");
// }


function $4efc12ae56ab5601$var$createGallery(galleryItem) {
    var lightBoxContainer = document.createElement("div");
    var lightBoxContent = document.createElement("div");
    var lightBoxImg = document.createElement("img");
    var lightBoxPrev = document.createElement("div");
    var lightBoxNext = document.createElement("div");
    lightBoxContainer.classList.add("lightbox");
    lightBoxContent.classList.add("lightbox-content");
    lightBoxPrev.classList.add("carousel-control-prev-icon");
    lightBoxNext.classList.add("carousel-control-next-icon");
    lightBoxContainer.appendChild(lightBoxContent);
    lightBoxContent.appendChild(lightBoxImg);
    lightBoxContent.appendChild(lightBoxPrev);
    lightBoxContent.appendChild(lightBoxNext);
    document.body.appendChild(lightBoxContainer);
    var index = 1;
    function showLightBox(n) {
        if (n > galleryItem.length) index = 1;
        else if (n < 1) index = galleryItem.length;
        var imageLocation = galleryItem[index - 1].getAttribute("data-src");
        if (!imageLocation) imageLocation = galleryItem[index - 1].children[0].getAttribute("src");
        lightBoxImg.setAttribute("src", imageLocation);
    }
    function currentImage() {
        lightBoxContainer.style.display = "block";
        var imageIndex = parseInt(this.getAttribute("data-index"));
        showLightBox(index = imageIndex);
    }
    for(var i = 0; i < galleryItem.length; i++)galleryItem[i].addEventListener("click", currentImage);
    function slideImage(n) {
        showLightBox(index += n);
    }
    function prevImage() {
        slideImage(-1);
    }
    function nextImage() {
        slideImage(1);
    }
    lightBoxPrev.addEventListener("click", prevImage);
    lightBoxNext.addEventListener("click", nextImage);
    function closeLightBox() {
        if (this === event.target) lightBoxContainer.style.display = "none";
    }
    lightBoxContainer.addEventListener("click", closeLightBox);
}
document.addEventListener('DOMContentLoaded', function() {
    var galleryItem = document.getElementsByClassName("gallery-item");
    if (galleryItem.length) $4efc12ae56ab5601$var$createGallery(galleryItem);
});


// equalHeight
(function() {
    $c7fee72a1158c845$var$equalHeight(false);
})();
window.addEventListener('resize', function() {
    $c7fee72a1158c845$var$equalHeight(true);
});
window.addEventListener('load', function() {
    $c7fee72a1158c845$var$equalHeight(true);
}, false);
function $c7fee72a1158c845$var$equalHeight(resize) {
    var groups = new Map();
    document.querySelectorAll(".equalHeight").forEach(function(el) {
        var _el_getAttribute;
        var groupKey = (_el_getAttribute = el.getAttribute('data-group')) !== null && _el_getAttribute !== void 0 ? _el_getAttribute : -1;
        var elements = groups.has(groupKey) ? groups.get(groupKey) : [];
        elements.push(el);
        groups.set(groupKey, elements);
    });
    groups.forEach(function(elements) {
        var allHeights = [], i = 0;
        if (resize === true) for(i = 0; i < elements.length; i++)elements[i].style.height = 'auto';
        for(i = 0; i < elements.length; i++)allHeights.push(elements[i].clientHeight);
        var maxHeight = Math.max.apply(Math, allHeights);
        for(i = 0; i < elements.length; i++)elements[i].style.height = maxHeight + 'px';
    });
}


function $bbe69c3d84bfc4d6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $bbe69c3d84bfc4d6$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $bbe69c3d84bfc4d6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $bbe69c3d84bfc4d6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $iFZdg = parcelRequire("iFZdg");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $22yUM = parcelRequire("22yUM");
var $9fa84b99705ce7ea$var$extendStatics = function extendStatics1(d, b) {
    $9fa84b99705ce7ea$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9fa84b99705ce7ea$var$extendStatics(d, b);
};
function $9fa84b99705ce7ea$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9fa84b99705ce7ea$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9fa84b99705ce7ea$export$18ce0697a983be9b = function __assign1() {
    $9fa84b99705ce7ea$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9fa84b99705ce7ea$export$18ce0697a983be9b.apply(this, arguments);
};
function $9fa84b99705ce7ea$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9fa84b99705ce7ea$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $22yUM._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9fa84b99705ce7ea$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9fa84b99705ce7ea$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $22yUM._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9fa84b99705ce7ea$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9fa84b99705ce7ea$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $22yUM._)(x)) === "symbol" ? x : "".concat(x);
}
function $9fa84b99705ce7ea$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $22yUM._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9fa84b99705ce7ea$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $22yUM._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9fa84b99705ce7ea$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9fa84b99705ce7ea$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9fa84b99705ce7ea$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9fa84b99705ce7ea$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9fa84b99705ce7ea$export$45d3717a4c69092e(o, m, p);
}
function $9fa84b99705ce7ea$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9fa84b99705ce7ea$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9fa84b99705ce7ea$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9fa84b99705ce7ea$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9fa84b99705ce7ea$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9fa84b99705ce7ea$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9fa84b99705ce7ea$export$10c90e4f7922046c(v) {
    return this instanceof $9fa84b99705ce7ea$export$10c90e4f7922046c ? (this.v = v, this) : new $9fa84b99705ce7ea$export$10c90e4f7922046c(v);
}
function $9fa84b99705ce7ea$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9fa84b99705ce7ea$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9fa84b99705ce7ea$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9fa84b99705ce7ea$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9fa84b99705ce7ea$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9fa84b99705ce7ea$export$19a8beecd37a4c45 === "function" ? $9fa84b99705ce7ea$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9fa84b99705ce7ea$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9fa84b99705ce7ea$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $9fa84b99705ce7ea$var$ownKeys = function ownKeys1(o) {
    $9fa84b99705ce7ea$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $9fa84b99705ce7ea$var$ownKeys(o);
};
function $9fa84b99705ce7ea$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $9fa84b99705ce7ea$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9fa84b99705ce7ea$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $9fa84b99705ce7ea$var$__setModuleDefault(result, mod);
    return result;
}
function $9fa84b99705ce7ea$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9fa84b99705ce7ea$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9fa84b99705ce7ea$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9fa84b99705ce7ea$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $22yUM._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9fa84b99705ce7ea$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $22yUM._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9fa84b99705ce7ea$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9fa84b99705ce7ea$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9fa84b99705ce7ea$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $9fa84b99705ce7ea$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $9fa84b99705ce7ea$export$2e2bcd8739ae039 = {
    __extends: $9fa84b99705ce7ea$export$a8ba968b8961cb8a,
    __assign: $9fa84b99705ce7ea$export$18ce0697a983be9b,
    __rest: $9fa84b99705ce7ea$export$3c9a16f847548506,
    __decorate: $9fa84b99705ce7ea$export$29e00dfd3077644b,
    __param: $9fa84b99705ce7ea$export$d5ad3fd78186038f,
    __esDecorate: $9fa84b99705ce7ea$export$3a84e1ae4e97e9b0,
    __runInitializers: $9fa84b99705ce7ea$export$d831c04e792af3d,
    __propKey: $9fa84b99705ce7ea$export$6a2a36740a146cb8,
    __setFunctionName: $9fa84b99705ce7ea$export$d1a06452d3489bc7,
    __metadata: $9fa84b99705ce7ea$export$f1db080c865becb9,
    __awaiter: $9fa84b99705ce7ea$export$1050f835b63b671e,
    __generator: $9fa84b99705ce7ea$export$67ebef60e6f28a6,
    __createBinding: $9fa84b99705ce7ea$export$45d3717a4c69092e,
    __exportStar: $9fa84b99705ce7ea$export$f33643c0debef087,
    __values: $9fa84b99705ce7ea$export$19a8beecd37a4c45,
    __read: $9fa84b99705ce7ea$export$8d051b38c9118094,
    __spread: $9fa84b99705ce7ea$export$afc72e2116322959,
    __spreadArrays: $9fa84b99705ce7ea$export$6388937ca91ccae8,
    __spreadArray: $9fa84b99705ce7ea$export$1216008129fb82ed,
    __await: $9fa84b99705ce7ea$export$10c90e4f7922046c,
    __asyncGenerator: $9fa84b99705ce7ea$export$e427f37a30a4de9b,
    __asyncDelegator: $9fa84b99705ce7ea$export$bbd80228419bb833,
    __asyncValues: $9fa84b99705ce7ea$export$e3b29a3d6162315f,
    __makeTemplateObject: $9fa84b99705ce7ea$export$4fb47efe1390b86f,
    __importStar: $9fa84b99705ce7ea$export$c21735bcef00d192,
    __importDefault: $9fa84b99705ce7ea$export$da59b14a69baef04,
    __classPrivateFieldGet: $9fa84b99705ce7ea$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9fa84b99705ce7ea$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9fa84b99705ce7ea$export$81fdc39f203e4e04,
    __addDisposableResource: $9fa84b99705ce7ea$export$88ac25d8e944e405,
    __disposeResources: $9fa84b99705ce7ea$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $9fa84b99705ce7ea$export$889dfb5d17574b0b
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");

function $d2e3d7ac0064a11e$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $d2e3d7ac0064a11e$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
// do not edit .js files directly - edit src/index.jst
var $d2e3d7ac0064a11e$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $22yUM._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $22yUM._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $d2e3d7ac0064a11e$var$isEqual = /*@__PURE__*/ $d2e3d7ac0064a11e$var$getDefaultExportFromCjs($d2e3d7ac0064a11e$var$fastDeepEqual);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d2e3d7ac0064a11e$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $d2e3d7ac0064a11e$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($d2e3d7ac0064a11e$export$406cfe323c8bb8e4 || ($d2e3d7ac0064a11e$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ var $d2e3d7ac0064a11e$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader(param) {
        var apiKey = param.apiKey, authReferrerPolicy = param.authReferrerPolicy, channel = param.channel, client = param.client, _param_id = param.id, id = _param_id === void 0 ? $d2e3d7ac0064a11e$export$19fc78b4b5aa5d0d : _param_id, language = param.language, _param_libraries = param.libraries, libraries = _param_libraries === void 0 ? [] : _param_libraries, mapIds = param.mapIds, nonce = param.nonce, region = param.region, _param_retries = param.retries, retries = _param_retries === void 0 ? 3 : _param_retries, _param_url = param.url, url = _param_url === void 0 ? "https://maps.googleapis.com/maps/api/js" : _param_url, version = param.version;
        (0, $eCXNS._)(this, Loader);
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $d2e3d7ac0064a11e$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!$d2e3d7ac0064a11e$var$isEqual(this.options, Loader.instance.options)) throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(Loader.instance.options)));
            return Loader.instance;
        }
        Loader.instance = this;
    }
    (0, $7M9bt._)(Loader, [
        {
            key: "options",
            get: function get() {
                return {
                    version: this.version,
                    apiKey: this.apiKey,
                    channel: this.channel,
                    client: this.client,
                    id: this.id,
                    libraries: this.libraries,
                    language: this.language,
                    region: this.region,
                    mapIds: this.mapIds,
                    nonce: this.nonce,
                    url: this.url,
                    authReferrerPolicy: this.authReferrerPolicy
                };
            }
        },
        {
            key: "status",
            get: function get() {
                if (this.errors.length) return $d2e3d7ac0064a11e$export$406cfe323c8bb8e4.FAILURE;
                if (this.done) return $d2e3d7ac0064a11e$export$406cfe323c8bb8e4.SUCCESS;
                if (this.loading) return $d2e3d7ac0064a11e$export$406cfe323c8bb8e4.LOADING;
                return $d2e3d7ac0064a11e$export$406cfe323c8bb8e4.INITIALIZED;
            }
        },
        {
            key: "failed",
            get: function get() {
                return this.done && !this.loading && this.errors.length >= this.retries + 1;
            }
        },
        {
            /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ key: "createUrl",
            value: function createUrl() {
                var url = this.url;
                url += "?callback=__googleMapsCallback&loading=async";
                if (this.apiKey) url += "&key=".concat(this.apiKey);
                if (this.channel) url += "&channel=".concat(this.channel);
                if (this.client) url += "&client=".concat(this.client);
                if (this.libraries.length > 0) url += "&libraries=".concat(this.libraries.join(","));
                if (this.language) url += "&language=".concat(this.language);
                if (this.region) url += "&region=".concat(this.region);
                if (this.version) url += "&v=".concat(this.version);
                if (this.mapIds) url += "&map_ids=".concat(this.mapIds.join(","));
                if (this.authReferrerPolicy) url += "&auth_referrer_policy=".concat(this.authReferrerPolicy);
                return url;
            }
        },
        {
            key: "deleteScript",
            value: function deleteScript() {
                var script = document.getElementById(this.id);
                if (script) script.remove();
            }
        },
        {
            /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ key: "load",
            value: function load() {
                return this.loadPromise();
            }
        },
        {
            /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ key: "loadPromise",
            value: function loadPromise() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    _this.loadCallback(function(err) {
                        if (!err) resolve(window.google);
                        else reject(err.error);
                    });
                });
            }
        },
        {
            key: "importLibrary",
            value: function importLibrary(name) {
                this.execute();
                return google.maps.importLibrary(name);
            }
        },
        {
            /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ key: "loadCallback",
            value: function loadCallback(fn) {
                this.callbacks.push(fn);
                this.execute();
            }
        },
        {
            /**
     * Set the script on document.
     */ key: "setScript",
            value: function setScript() {
                var _this = this;
                var _a, _b;
                if (document.getElementById(this.id)) {
                    // TODO wrap onerror callback for cases where the script was loaded elsewhere
                    this.callback();
                    return;
                }
                var params = {
                    key: this.apiKey,
                    channel: this.channel,
                    client: this.client,
                    libraries: this.libraries.length && this.libraries,
                    v: this.version,
                    mapIds: this.mapIds,
                    language: this.language,
                    region: this.region,
                    authReferrerPolicy: this.authReferrerPolicy
                };
                // keep the URL minimal:
                Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                function(key) {
                    return !params[key] && delete params[key];
                });
                if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
                // which also sets the base url, the id, and the nonce
                /* eslint-disable */ (function(g) {
                    var _d;
                    // @ts-ignore
                    var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                    // @ts-ignore
                    b = b[c] || (b[c] = {});
                    // @ts-ignore
                    var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = function() {
                        return(// @ts-ignore
                        h || (h = new Promise(function(f, n) {
                            return $d2e3d7ac0064a11e$var$__awaiter(_this, void 0, void 0, function() {
                                var _a;
                                return (0, $9fa84b99705ce7ea$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                a = m.createElement("script")
                                            ];
                                        case 1:
                                            _state.sent();
                                            a.id = this.id;
                                            e.set("libraries", (0, $2b6Uo._)(r) + "");
                                            // @ts-ignore
                                            for(k in g)e.set(k.replace(/[A-Z]/g, function(t) {
                                                return "_" + t[0].toLowerCase();
                                            }), g[k]);
                                            e.set("callback", c + ".maps." + q);
                                            a.src = this.url + "?" + e;
                                            d[q] = f;
                                            a.onerror = function() {
                                                return h = n(Error(p + " could not load."));
                                            };
                                            // @ts-ignore
                                            a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                                            m.head.append(a);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        })));
                    };
                    // @ts-ignore
                    d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = function(f) {
                        for(var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            n[_key - 1] = arguments[_key];
                        }
                        return r.add(f) && u().then(function() {
                            return (_d = d)[l].apply(_d, [
                                f
                            ].concat((0, $2b6Uo._)(n)));
                        });
                    };
                })(params);
                // While most libraries populate the global namespace when loaded via bootstrap params,
                // this is not the case for "marker" when used with the inline bootstrap loader
                // (and maybe others in the future). So ensure there is an importLibrary for each:
                var libraryPromises = this.libraries.map(function(library) {
                    return _this.importLibrary(library);
                });
                // ensure at least one library, to kick off loading...
                if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
                Promise.all(libraryPromises).then(function() {
                    return _this.callback();
                }, function(error) {
                    var event = new ErrorEvent("error", {
                        error: error
                    }); // for backwards compat
                    _this.loadErrorCallback(event);
                });
            }
        },
        {
            /**
     * Reset the loader state.
     */ key: "reset",
            value: function reset() {
                this.deleteScript();
                this.done = false;
                this.loading = false;
                this.errors = [];
                this.onerrorEvent = null;
            }
        },
        {
            key: "resetIfRetryingFailed",
            value: function resetIfRetryingFailed() {
                if (this.failed) this.reset();
            }
        },
        {
            key: "loadErrorCallback",
            value: function loadErrorCallback(e) {
                var _this = this;
                this.errors.push(e);
                if (this.errors.length <= this.retries) {
                    var delay = this.errors.length * Math.pow(2, this.errors.length);
                    console.error("Failed to load Google Maps script, retrying in ".concat(delay, " ms."));
                    setTimeout(function() {
                        _this.deleteScript();
                        _this.setScript();
                    }, delay);
                } else {
                    this.onerrorEvent = e;
                    this.callback();
                }
            }
        },
        {
            key: "callback",
            value: function callback() {
                var _this = this;
                this.done = true;
                this.loading = false;
                this.callbacks.forEach(function(cb) {
                    cb(_this.onerrorEvent);
                });
                this.callbacks = [];
            }
        },
        {
            key: "execute",
            value: function execute() {
                this.resetIfRetryingFailed();
                if (this.loading) // do nothing but wait
                return;
                if (this.done) this.callback();
                else {
                    // short circuit and warn if google.maps is already loaded
                    if (window.google && window.google.maps && window.google.maps.version) {
                        console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                        this.callback();
                        return;
                    }
                    this.loading = true;
                    this.setScript();
                }
            }
        }
    ]);
    return Loader;
}();



var $ayD5C = parcelRequire("ayD5C");

var $6880c7350553ef7b$var$mapElement = document.getElementById('immoMap');
if ($6880c7350553ef7b$var$mapElement) {
    if ($6880c7350553ef7b$var$mapElement.dataset.consent !== '0') {
        var $6880c7350553ef7b$var$btn = document.getElementById('accept-consent');
        if ($6880c7350553ef7b$var$btn) $6880c7350553ef7b$var$btn.addEventListener('click', function() {
            $6880c7350553ef7b$var$createMap();
        });
    } else $6880c7350553ef7b$var$createMap();
}
function $6880c7350553ef7b$var$createMap() {
    var map;
    document.querySelectorAll('.hide-without-consent').forEach(function(el) {
        return el.style.display = null;
    });
    var loader = new (0, $d2e3d7ac0064a11e$export$3b0d6d7590275603)({
        apiKey: $6880c7350553ef7b$var$mapElement.dataset.key,
        version: 'weekly'
    });
    Promise.all([
        $6880c7350553ef7b$var$getMarkerData(),
        loader.load()
    ]).then(function(param) {
        var _param = (0, $iFZdg._)(param, 1), markerData = _param[0];
        map = new google.maps.Map($6880c7350553ef7b$var$mapElement, {
            center: markerData.center,
            zoom: 11
        });
        var infoWindow = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: true
        });
        var markers = markerData.markers.map(function(param) {
            var position = param.position, content = param.content;
            var marker = new google.maps.Marker({
                position: position,
                icon: (0, {}),
                label: {
                    text: '1',
                    color: '#fff'
                }
            });
            marker.addListener('click', function() {
                infoWindow.setContent(content);
                infoWindow.open(map, marker);
            });
            return marker;
        });
        new (0, $ayD5C.MarkerClusterer)({
            map: map,
            markers: markers,
            renderer: {
                render: function render(param, stats) {
                    var count = param.count, position = param.position;
                    return new google.maps.Marker({
                        position: position,
                        icon: (0, {}),
                        label: {
                            text: String(count),
                            color: '#fff'
                        },
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
                    });
                }
            }
        });
    });
}
function $6880c7350553ef7b$var$getMarkerData() {
    return $6880c7350553ef7b$var$_getMarkerData.apply(this, arguments);
}
function $6880c7350553ef7b$var$_getMarkerData() {
    $6880c7350553ef7b$var$_getMarkerData = (0, $bbe69c3d84bfc4d6$export$71511d61b312f219)(function() {
        var markers, latSum, lngSum;
        return (0, $9fa84b99705ce7ea$export$67ebef60e6f28a6)(this, function(_state) {
            markers = [];
            latSum = 0.0;
            lngSum = 0.0;
            document.querySelectorAll('.marker').forEach(function(el) {
                var lat = parseFloat(el.dataset.lat);
                var lng = parseFloat(el.dataset.lng);
                latSum += lat;
                lngSum += lng;
                markers.push({
                    content: el.outerHTML,
                    position: {
                        lat: lat,
                        lng: lng
                    }
                });
            });
            return [
                2,
                {
                    center: {
                        lat: latSum / markers.length,
                        lng: lngSum / markers.length
                    },
                    markers: markers
                }
            ];
        });
    });
    return $6880c7350553ef7b$var$_getMarkerData.apply(this, arguments);
}
function $6880c7350553ef7b$var$createLightbox(image) {
    var lightBoxContainer = document.createElement("div");
    var lightBoxContent = document.createElement("div");
    var lightBoxImg = document.createElement("img");
    lightBoxContainer.classList.add("lightbox");
    lightBoxContent.classList.add("lightbox-content");
    lightBoxContainer.appendChild(lightBoxContent);
    lightBoxContent.appendChild(lightBoxImg);
    document.body.appendChild(lightBoxContainer);
    lightBoxContainer.style.display = "block";
    lightBoxImg.setAttribute("src", image);
    function closeLightBox() {
        if (this === event.target) lightBoxContainer.style.display = "none";
    }
    lightBoxContainer.addEventListener("click", closeLightBox);
}
document.addEventListener('click', function(e) {
    if (e.target.dataset.lightbox) {
        e.preventDefault();
        $6880c7350553ef7b$var$createLightbox(e.target.dataset.lightbox);
    }
}, false);
var $6880c7350553ef7b$var$lighboxes = document.querySelectorAll('.open-lightbox');
var $6880c7350553ef7b$var$_iteratorNormalCompletion = true, $6880c7350553ef7b$var$_didIteratorError = false, $6880c7350553ef7b$var$_iteratorError = undefined;
try {
    var $6880c7350553ef7b$var$_loop = function() {
        var lightbox = $6880c7350553ef7b$var$_step.value;
        lightbox.addEventListener('click', function(e) {
            e.preventDefault();
            $6880c7350553ef7b$var$createLightbox(lightbox.href);
        });
    };
    for(var $6880c7350553ef7b$var$_iterator = $6880c7350553ef7b$var$lighboxes[Symbol.iterator](), $6880c7350553ef7b$var$_step; !($6880c7350553ef7b$var$_iteratorNormalCompletion = ($6880c7350553ef7b$var$_step = $6880c7350553ef7b$var$_iterator.next()).done); $6880c7350553ef7b$var$_iteratorNormalCompletion = true)$6880c7350553ef7b$var$_loop();
} catch (err) {
    $6880c7350553ef7b$var$_didIteratorError = true;
    $6880c7350553ef7b$var$_iteratorError = err;
} finally{
    try {
        if (!$6880c7350553ef7b$var$_iteratorNormalCompletion && $6880c7350553ef7b$var$_iterator.return != null) {
            $6880c7350553ef7b$var$_iterator.return();
        }
    } finally{
        if ($6880c7350553ef7b$var$_didIteratorError) {
            throw $6880c7350553ef7b$var$_iteratorError;
        }
    }
}


var $d3ab134fe27cd061$var$consentButtons = document.querySelectorAll('.accept-consent');
$d3ab134fe27cd061$var$consentButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        var replaceTarget = document.querySelector(button.dataset.replace);
        var target = document.querySelector(button.dataset.target);
        if (replaceTarget && target) replaceTarget.outerHTML = target.innerHTML;
    });
});


// Smooth Scroll To Anchor
document.querySelectorAll("a[href^=\"#\"]").forEach(function(anchor) {
    anchor.addEventListener("click", function(ev) {
        ev.preventDefault();
        var targetElement = document.querySelector(this.getAttribute("href"));
        targetElement.scrollIntoView({
            block: "start",
            alignToTop: true,
            behavior: "smooth"
        });
    });
});
// Leere Seitennavigation entfernen
var $9bfd803ebef8d089$var$sidebar = document.getElementById('sidebar_nav');
if ($9bfd803ebef8d089$var$sidebar) {
    if ($9bfd803ebef8d089$var$sidebar.querySelectorAll('ul > li').length <= 1) $9bfd803ebef8d089$var$sidebar.remove();
}



var $iFZdg = parcelRequire("iFZdg");
var $5dac4bdd26a2c0cd$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $c5e7aed4dc4d8616$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $a4e713c68be04974$exports = {};

$parcel$export($a4e713c68be04974$exports, "ArrayLiteral", function () { return $a4e713c68be04974$export$2477073908a0de26; }, function (v) { return $a4e713c68be04974$export$2477073908a0de26 = v; });
$parcel$export($a4e713c68be04974$exports, "BinaryExpression", function () { return $a4e713c68be04974$export$5351bc98fa48e09c; }, function (v) { return $a4e713c68be04974$export$5351bc98fa48e09c = v; });
$parcel$export($a4e713c68be04974$exports, "ConditionalExpression", function () { return $a4e713c68be04974$export$12447f42bd680fc8; }, function (v) { return $a4e713c68be04974$export$12447f42bd680fc8 = v; });
$parcel$export($a4e713c68be04974$exports, "FilterExpression", function () { return $a4e713c68be04974$export$6b8d6da04b395169; }, function (v) { return $a4e713c68be04974$export$6b8d6da04b395169 = v; });
$parcel$export($a4e713c68be04974$exports, "Identifier", function () { return $a4e713c68be04974$export$989167234458594d; }, function (v) { return $a4e713c68be04974$export$989167234458594d = v; });
$parcel$export($a4e713c68be04974$exports, "Literal", function () { return $a4e713c68be04974$export$e175ae9e414693bc; }, function (v) { return $a4e713c68be04974$export$e175ae9e414693bc = v; });
$parcel$export($a4e713c68be04974$exports, "ObjectLiteral", function () { return $a4e713c68be04974$export$4c0cd5cfd47f57a6; }, function (v) { return $a4e713c68be04974$export$4c0cd5cfd47f57a6 = v; });
$parcel$export($a4e713c68be04974$exports, "Transform", function () { return $a4e713c68be04974$export$563a914cafbdc389; }, function (v) { return $a4e713c68be04974$export$563a914cafbdc389 = v; });
$parcel$export($a4e713c68be04974$exports, "UnaryExpression", function () { return $a4e713c68be04974$export$b832e164a8af4bc7; }, function (v) { return $a4e713c68be04974$export$b832e164a8af4bc7 = v; });
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * Evaluates an ArrayLiteral by returning its value, with each element
 * independently run through the evaluator.
 * @param {{type: 'ObjectLiteral', value: <{}>}} ast An expression tree with an
 *      ObjectLiteral as the top node
 * @returns {Promise.<[]>} resolves to a map contained evaluated values.
 * @private
 */ var $a4e713c68be04974$export$2477073908a0de26;
/**
 * Evaluates a BinaryExpression node by running the Grammar's evaluator for
 * the given operator.
 * @param {{type: 'BinaryExpression', operator: <string>, left: {},
 *      right: {}}} ast An expression tree with a BinaryExpression as the top
 *      node
 * @returns {Promise<*>} resolves with the value of the BinaryExpression.
 * @private
 */ var $a4e713c68be04974$export$5351bc98fa48e09c;
/**
 * Evaluates a ConditionalExpression node by first evaluating its test branch,
 * and resolving with the consequent branch if the test is truthy, or the
 * alternate branch if it is not. If there is no consequent branch, the test
 * result will be used instead.
 * @param {{type: 'ConditionalExpression', test: {}, consequent: {},
 *      alternate: {}}} ast An expression tree with a ConditionalExpression as
 *      the top node
 * @private
 */ var $a4e713c68be04974$export$12447f42bd680fc8;
/**
 * Evaluates a FilterExpression by applying it to the subject value.
 * @param {{type: 'FilterExpression', relative: <boolean>, expr: {},
 *      subject: {}}} ast An expression tree with a FilterExpression as the top
 *      node
 * @returns {Promise<*>} resolves with the value of the FilterExpression.
 * @private
 */ var $a4e713c68be04974$export$6b8d6da04b395169;
/**
 * Evaluates an Identifier by either stemming from the evaluated 'from'
 * expression tree or accessing the context provided when this Evaluator was
 * constructed.
 * @param {{type: 'Identifier', value: <string>, [from]: {}}} ast An expression
 *      tree with an Identifier as the top node
 * @returns {Promise<*>|*} either the identifier's value, or a Promise that
 *      will resolve with the identifier's value.
 * @private
 */ var $a4e713c68be04974$export$989167234458594d;
/**
 * Evaluates a Literal by returning its value property.
 * @param {{type: 'Literal', value: <string|number|boolean>}} ast An expression
 *      tree with a Literal as its only node
 * @returns {string|number|boolean} The value of the Literal node
 * @private
 */ var $a4e713c68be04974$export$e175ae9e414693bc;
/**
 * Evaluates an ObjectLiteral by returning its value, with each key
 * independently run through the evaluator.
 * @param {{type: 'ObjectLiteral', value: <{}>}} ast An expression tree with an
 *      ObjectLiteral as the top node
 * @returns {Promise<{}>} resolves to a map contained evaluated values.
 * @private
 */ var $a4e713c68be04974$export$4c0cd5cfd47f57a6;
/**
 * Evaluates a Transform node by applying a function from the transforms map
 * to the subject value.
 * @param {{type: 'Transform', name: <string>, subject: {}}} ast An
 *      expression tree with a Transform as the top node
 * @returns {Promise<*>|*} the value of the transformation, or a Promise that
 *      will resolve with the transformed value.
 * @private
 */ var $a4e713c68be04974$export$563a914cafbdc389;
/**
 * Evaluates a Unary expression by passing the right side through the
 * operator's eval function.
 * @param {{type: 'UnaryExpression', operator: <string>, right: {}}} ast An
 *      expression tree with a UnaryExpression as the top node
 * @returns {Promise<*>} resolves with the value of the UnaryExpression.
 * @constructor
 */ var $a4e713c68be04974$export$b832e164a8af4bc7;
$a4e713c68be04974$export$2477073908a0de26 = function(ast) {
    return this.evalArray(ast.value);
};
$a4e713c68be04974$export$5351bc98fa48e09c = function(ast) {
    var self = this;
    return Promise.all([
        this.eval(ast.left),
        this.eval(ast.right)
    ]).then(function(arr) {
        return self._grammar[ast.operator].eval(arr[0], arr[1]);
    });
};
$a4e713c68be04974$export$12447f42bd680fc8 = function(ast) {
    var self = this;
    return this.eval(ast.test).then(function(res) {
        if (res) {
            if (ast.consequent) return self.eval(ast.consequent);
            return res;
        }
        return self.eval(ast.alternate);
    });
};
$a4e713c68be04974$export$6b8d6da04b395169 = function(ast) {
    var self = this;
    return this.eval(ast.subject).then(function(subject) {
        if (ast.relative) return self._filterRelative(subject, ast.expr);
        return self._filterStatic(subject, ast.expr);
    });
};
$a4e713c68be04974$export$989167234458594d = function(ast) {
    if (ast.from) return this.eval(ast.from).then(function(context) {
        if (context === undefined) return undefined;
        if (Array.isArray(context)) context = context[0];
        return context[ast.value];
    });
    else return ast.relative ? this._relContext[ast.value] : this._context[ast.value];
};
$a4e713c68be04974$export$e175ae9e414693bc = function(ast) {
    return ast.value;
};
$a4e713c68be04974$export$4c0cd5cfd47f57a6 = function(ast) {
    return this.evalMap(ast.value);
};
$a4e713c68be04974$export$563a914cafbdc389 = function(ast) {
    var transform = this._transforms[ast.name];
    if (!transform) throw new Error("Transform '" + ast.name + "' is not defined.");
    return Promise.all([
        this.eval(ast.subject),
        this.evalArray(ast.args || [])
    ]).then(function(arr) {
        return transform.apply(null, [
            arr[0]
        ].concat(arr[1]));
    });
};
$a4e713c68be04974$export$b832e164a8af4bc7 = function(ast) {
    var self = this;
    return this.eval(ast.right).then(function(right) {
        return self._grammar[ast.operator].eval(right);
    });
};


/**
 * The Evaluator takes a Jexl expression tree as generated by the
 * {@link Parser} and calculates its value within a given context. The
 * collection of transforms, context, and a relative context to be used as the
 * root for relative identifiers, are all specific to an Evaluator instance.
 * When any of these things change, a new instance is required.  However, a
 * single instance can be used to simultaneously evaluate many different
 * expressions, and does not have to be reinstantiated for each.
 * @param {{}} grammar A grammar map against which to evaluate the expression
 *      tree
 * @param {{}} [transforms] A map of transform names to transform functions. A
 *      transform function takes two arguments:
 *          - {*} val: A value to be transformed
 *          - {{}} args: A map of argument keys to their evaluated values, as
 *              specified in the expression string
 *      The transform function should return either the transformed value, or
 *      a Promises/A+ Promise object that resolves with the value and rejects
 *      or throws only when an unrecoverable error occurs. Transforms should
 *      generally return undefined when they don't make sense to be used on the
 *      given value type, rather than throw/reject. An error is only
 *      appropriate when the transform would normally return a value, but
 *      cannot due to some other failure.
 * @param {{}} [context] A map of variable keys to their values. This will be
 *      accessed to resolve the value of each non-relative identifier. Any
 *      Promise values will be passed to the expression as their resolved
 *      value.
 * @param {{}|Array<{}|Array>} [relativeContext] A map or array to be accessed
 *      to resolve the value of a relative identifier.
 * @constructor
 */ var $c5e7aed4dc4d8616$var$Evaluator = function Evaluator(grammar, transforms, context, relativeContext) {
    this._grammar = grammar;
    this._transforms = transforms || {};
    this._context = context || {};
    this._relContext = relativeContext || this._context;
};
/**
 * Evaluates an expression tree within the configured context.
 * @param {{}} ast An expression tree object
 * @returns {Promise<*>} resolves with the resulting value of the expression.
 */ $c5e7aed4dc4d8616$var$Evaluator.prototype.eval = function(ast) {
    var self = this;
    return Promise.resolve().then(function() {
        return $a4e713c68be04974$exports[ast.type].call(self, ast);
    });
};
/**
 * Simultaneously evaluates each expression within an array, and delivers the
 * response as an array with the resulting values at the same indexes as their
 * originating expressions.
 * @param {Array<string>} arr An array of expression strings to be evaluated
 * @returns {Promise<Array<{}>>} resolves with the result array
 */ $c5e7aed4dc4d8616$var$Evaluator.prototype.evalArray = function(arr) {
    return Promise.all(arr.map(function(elem) {
        return this.eval(elem);
    }, this));
};
/**
 * Simultaneously evaluates each expression within a map, and delivers the
 * response as a map with the same keys, but with the evaluated result for each
 * as their value.
 * @param {{}} map A map of expression names to expression trees to be
 *      evaluated
 * @returns {Promise<{}>} resolves with the result map.
 */ $c5e7aed4dc4d8616$var$Evaluator.prototype.evalMap = function(map) {
    var keys = Object.keys(map), result = {};
    var asts = keys.map(function(key) {
        return this.eval(map[key]);
    }, this);
    return Promise.all(asts).then(function(vals) {
        vals.forEach(function(val, idx) {
            result[keys[idx]] = val;
        });
        return result;
    });
};
/**
 * Applies a filter expression with relative identifier elements to a subject.
 * The intent is for the subject to be an array of subjects that will be
 * individually used as the relative context against the provided expression
 * tree. Only the elements whose expressions result in a truthy value will be
 * included in the resulting array.
 *
 * If the subject is not an array of values, it will be converted to a single-
 * element array before running the filter.
 * @param {*} subject The value to be filtered; usually an array. If this value is
 *      not an array, it will be converted to an array with this value as the
 *      only element.
 * @param {{}} expr The expression tree to run against each subject. If the
 *      tree evaluates to a truthy result, then the value will be included in
 *      the returned array; otherwise, it will be eliminated.
 * @returns {Promise<Array>} resolves with an array of values that passed the
 *      expression filter.
 * @private
 */ $c5e7aed4dc4d8616$var$Evaluator.prototype._filterRelative = function(subject, expr) {
    if (subject === undefined) return undefined;
    var promises = [];
    if (!Array.isArray(subject)) subject = [
        subject
    ];
    subject.forEach(function(elem) {
        var evalInst = new $c5e7aed4dc4d8616$var$Evaluator(this._grammar, this._transforms, this._context, elem);
        promises.push(evalInst.eval(expr));
    }, this);
    return Promise.all(promises).then(function(values) {
        var results = [];
        values.forEach(function(value, idx) {
            if (value) results.push(subject[idx]);
        });
        return results;
    });
};
/**
 * Applies a static filter expression to a subject value.  If the filter
 * expression evaluates to boolean true, the subject is returned; if false,
 * undefined.
 *
 * For any other resulting value of the expression, this function will attempt
 * to respond with the property at that name or index of the subject.
 * @param {*} subject The value to be filtered.  Usually an Array (for which
 *      the expression would generally resolve to a numeric index) or an
 *      Object (for which the expression would generally resolve to a string
 *      indicating a property name)
 * @param {{}} expr The expression tree to run against the subject
 * @returns {Promise<*>} resolves with the value of the drill-down.
 * @private
 */ $c5e7aed4dc4d8616$var$Evaluator.prototype._filterStatic = function(subject, expr) {
    return this.eval(expr).then(function(res) {
        if (typeof res === 'boolean') return res ? subject : undefined;
        if (subject === undefined) return undefined;
        return subject[res];
    });
};
$c5e7aed4dc4d8616$exports = $c5e7aed4dc4d8616$var$Evaluator;


var $a23c9611874f207f$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $a23c9611874f207f$var$numericRegex = /^-?(?:(?:[0-9]*\.[0-9]+)|[0-9]+)$/, $a23c9611874f207f$var$identRegex = /^[a-zA-Z_\$][a-zA-Z0-9_\$]*$/, $a23c9611874f207f$var$escEscRegex = /\\\\/, $a23c9611874f207f$var$preOpRegexElems = [
    // Strings
    "'(?:(?:\\\\')?[^'])*'",
    '"(?:(?:\\\\")?[^"])*"',
    // Whitespace
    '\\s+',
    // Booleans
    '\\btrue\\b',
    '\\bfalse\\b',
    // Octothorpe comments
    '#.*[\\n\\4]?'
], $a23c9611874f207f$var$postOpRegexElems = [
    // Identifiers
    '\\b[a-zA-Z_\\$][a-zA-Z0-9_\\$]*\\b',
    // Numerics (without negative symbol)
    '(?:(?:[0-9]*\\.[0-9]+)|[0-9]+)'
], $a23c9611874f207f$var$minusNegatesAfter = [
    'binaryOp',
    'unaryOp',
    'openParen',
    'openBracket',
    'question',
    'colon'
];
/**
 * Lexer is a collection of stateless, statically-accessed functions for the
 * lexical parsing of a Jexl string.  Its responsibility is to identify the
 * "parts of speech" of a Jexl expression, and tokenize and label each, but
 * to do only the most minimal syntax checking; the only errors the Lexer
 * should be concerned with are if it's unable to identify the utility of
 * any of its tokens.  Errors stemming from these tokens not being in a
 * sensible configuration should be left for the Parser to handle.
 * @type {{}}
 */ function $a23c9611874f207f$var$Lexer(grammar) {
    this._grammar = grammar;
}
/**
 * Splits a Jexl expression string into an array of expression elements.
 * @param {string} str A Jexl expression string
 * @returns {Array<string>} An array of substrings defining the functional
 *      elements of the expression.
 */ $a23c9611874f207f$var$Lexer.prototype.getElements = function(str) {
    var regex = this._getSplitRegex();
    return str.split(regex).filter(function(elem) {
        // Remove empty strings
        return elem;
    });
};
/**
 * Converts an array of expression elements into an array of tokens.  Note that
 * the resulting array may not equal the element array in length, as any
 * elements that consist only of whitespace get appended to the previous
 * token's "raw" property.  For the structure of a token object, please see
 * {@link Lexer#tokenize}.
 * @param {Array<string>} elements An array of Jexl expression elements to be
 *      converted to tokens
 * @returns {Array<{type, value, raw}>} an array of token objects.
 */ $a23c9611874f207f$var$Lexer.prototype.getTokens = function(elements) {
    var tokens = [], negate = false;
    for(var i = 0; i < elements.length; i++){
        if (this._isWhitespace(elements[i])) {
            if (tokens.length) tokens[tokens.length - 1].raw += elements[i];
        } else if (this._isComment(elements[i])) continue;
        else if (elements[i] === '-' && this._isNegative(tokens)) negate = true;
        else {
            if (negate) {
                elements[i] = '-' + elements[i];
                negate = false;
            }
            tokens.push(this._createToken(elements[i]));
        }
    }
    // Catch a - at the end of the string. Let the parser handle that issue.
    if (negate) tokens.push(this._createToken('-'));
    return tokens;
};
/**
 * Converts a Jexl string into an array of tokens.  Each token is an object
 * in the following format:
 *
 *     {
 *         type: <string>,
 *         [name]: <string>,
 *         value: <boolean|number|string>,
 *         raw: <string>
 *     }
 *
 * Type is one of the following:
 *
 *      literal, identifier, binaryOp, unaryOp
 *
 * OR, if the token is a control character its type is the name of the element
 * defined in the Grammar.
 *
 * Name appears only if the token is a control string found in
 * {@link grammar#elements}, and is set to the name of the element.
 *
 * Value is the value of the token in the correct type (boolean or numeric as
 * appropriate). Raw is the string representation of this value taken directly
 * from the expression string, including any trailing spaces.
 * @param {string} str The Jexl string to be tokenized
 * @returns {Array<{type, value, raw}>} an array of token objects.
 * @throws {Error} if the provided string contains an invalid token.
 */ $a23c9611874f207f$var$Lexer.prototype.tokenize = function(str) {
    var elements = this.getElements(str);
    return this.getTokens(elements);
};
/**
 * Creates a new token object from an element of a Jexl string. See
 * {@link Lexer#tokenize} for a description of the token object.
 * @param {string} element The element from which a token should be made
 * @returns {{value: number|boolean|string, [name]: string, type: string,
 *      raw: string}} a token object describing the provided element.
 * @throws {Error} if the provided string is not a valid expression element.
 * @private
 */ $a23c9611874f207f$var$Lexer.prototype._createToken = function(element) {
    var token = {
        type: 'literal',
        value: element,
        raw: element
    };
    if (element[0] == '"' || element[0] == "'") token.value = this._unquote(element);
    else if (element.match($a23c9611874f207f$var$numericRegex)) token.value = parseFloat(element);
    else if (element === 'true' || element === 'false') token.value = element === 'true';
    else if (this._grammar[element]) token.type = this._grammar[element].type;
    else if (element.match($a23c9611874f207f$var$identRegex)) token.type = 'identifier';
    else throw new Error("Invalid expression token: " + element);
    return token;
};
/**
 * Escapes a string so that it can be treated as a string literal within a
 * regular expression.
 * @param {string} str The string to be escaped
 * @returns {string} the RegExp-escaped string.
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions
 * @private
 */ $a23c9611874f207f$var$Lexer.prototype._escapeRegExp = function(str) {
    str = str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    if (str.match($a23c9611874f207f$var$identRegex)) str = '\\b' + str + '\\b';
    return str;
};
/**
 * Gets a RegEx object appropriate for splitting a Jexl string into its core
 * elements.
 * @returns {RegExp} An element-splitting RegExp object
 * @private
 */ $a23c9611874f207f$var$Lexer.prototype._getSplitRegex = function() {
    if (!this._splitRegex) {
        var elemArray = Object.keys(this._grammar);
        // Sort by most characters to least, then regex escape each
        elemArray = elemArray.sort(function(a, b) {
            return b.length - a.length;
        }).map(function(elem) {
            return this._escapeRegExp(elem);
        }, this);
        this._splitRegex = new RegExp('(' + [
            $a23c9611874f207f$var$preOpRegexElems.join('|'),
            elemArray.join('|'),
            $a23c9611874f207f$var$postOpRegexElems.join('|')
        ].join('|') + ')');
    }
    return this._splitRegex;
};
/**
 * Determines whether the addition of a '-' token should be interpreted as a
 * negative symbol for an upcoming number, given an array of tokens already
 * processed.
 * @param {Array<Object>} tokens An array of tokens already processed
 * @returns {boolean} true if adding a '-' should be considered a negative
 *      symbol; false otherwise
 * @private
 */ $a23c9611874f207f$var$Lexer.prototype._isNegative = function(tokens) {
    if (!tokens.length) return true;
    return $a23c9611874f207f$var$minusNegatesAfter.some(function(type) {
        return type === tokens[tokens.length - 1].type;
    });
};
/**
 * A utility function to determine if a string consists of only space
 * characters.
 * @param {string} str A string to be tested
 * @returns {boolean} true if the string is empty or consists of only whitespace;
 *      false otherwise.
 * @private
 */ var $a23c9611874f207f$var$_whitespaceRegex = /^\s*$/;
$a23c9611874f207f$var$Lexer.prototype._isWhitespace = function(str) {
    return $a23c9611874f207f$var$_whitespaceRegex.test(str);
};
/**
 * A utility function to determine if a string is an octothorpe comment
 * @param {string} str A string to be tested
 * @returns {boolean} true if the string is a comment, false otherwise.
 * @private
 */ $a23c9611874f207f$var$Lexer.prototype._isComment = function(str) {
    return str.startsWith('#');
};
/**
 * Removes the beginning and trailing quotes from a string, unescapes any
 * escaped quotes on its interior, and unescapes any escaped escape characters.
 * Note that this function is not defensive; it assumes that the provided
 * string is not empty, and that its first and last characters are actually
 * quotes.
 * @param {string} str A string whose first and last characters are quotes
 * @returns {string} a string with the surrounding quotes stripped and escapes
 *      properly processed.
 * @private
 */ $a23c9611874f207f$var$Lexer.prototype._unquote = function(str) {
    var quote = str[0], escQuoteRegex = new RegExp('\\\\' + quote, 'g');
    return str.substr(1, str.length - 2).replace(escQuoteRegex, quote).replace($a23c9611874f207f$var$escEscRegex, '\\');
};
$a23c9611874f207f$exports = $a23c9611874f207f$var$Lexer;


var $eee396428c4f8002$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $cfbf3f9f9fe9ddca$exports = {};

$parcel$export($cfbf3f9f9fe9ddca$exports, "argVal", function () { return $cfbf3f9f9fe9ddca$export$bf99ae2731a267af; }, function (v) { return $cfbf3f9f9fe9ddca$export$bf99ae2731a267af = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "arrayStart", function () { return $cfbf3f9f9fe9ddca$export$dbbb5fc86f066522; }, function (v) { return $cfbf3f9f9fe9ddca$export$dbbb5fc86f066522 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "arrayVal", function () { return $cfbf3f9f9fe9ddca$export$56baa95599a4a114; }, function (v) { return $cfbf3f9f9fe9ddca$export$56baa95599a4a114 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "binaryOp", function () { return $cfbf3f9f9fe9ddca$export$bf7110d4c5a71b17; }, function (v) { return $cfbf3f9f9fe9ddca$export$bf7110d4c5a71b17 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "dot", function () { return $cfbf3f9f9fe9ddca$export$94132a0e348806d4; }, function (v) { return $cfbf3f9f9fe9ddca$export$94132a0e348806d4 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "filter", function () { return $cfbf3f9f9fe9ddca$export$3dea766d36a8935f; }, function (v) { return $cfbf3f9f9fe9ddca$export$3dea766d36a8935f = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "identifier", function () { return $cfbf3f9f9fe9ddca$export$c2ab62c7bf24634; }, function (v) { return $cfbf3f9f9fe9ddca$export$c2ab62c7bf24634 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "literal", function () { return $cfbf3f9f9fe9ddca$export$c8ec6e1ec9fefcb0; }, function (v) { return $cfbf3f9f9fe9ddca$export$c8ec6e1ec9fefcb0 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "objKey", function () { return $cfbf3f9f9fe9ddca$export$a7e3a597b5fb619; }, function (v) { return $cfbf3f9f9fe9ddca$export$a7e3a597b5fb619 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "objStart", function () { return $cfbf3f9f9fe9ddca$export$ae43e9a7db1a053e; }, function (v) { return $cfbf3f9f9fe9ddca$export$ae43e9a7db1a053e = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "objVal", function () { return $cfbf3f9f9fe9ddca$export$316663dec3b13f08; }, function (v) { return $cfbf3f9f9fe9ddca$export$316663dec3b13f08 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "subExpression", function () { return $cfbf3f9f9fe9ddca$export$64f55baf472b5db; }, function (v) { return $cfbf3f9f9fe9ddca$export$64f55baf472b5db = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "ternaryEnd", function () { return $cfbf3f9f9fe9ddca$export$4747a6a8ead63555; }, function (v) { return $cfbf3f9f9fe9ddca$export$4747a6a8ead63555 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "ternaryMid", function () { return $cfbf3f9f9fe9ddca$export$b9522f35ae4fd641; }, function (v) { return $cfbf3f9f9fe9ddca$export$b9522f35ae4fd641 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "ternaryStart", function () { return $cfbf3f9f9fe9ddca$export$193e5ad6f5c47f1; }, function (v) { return $cfbf3f9f9fe9ddca$export$193e5ad6f5c47f1 = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "transform", function () { return $cfbf3f9f9fe9ddca$export$51186ad6e864892a; }, function (v) { return $cfbf3f9f9fe9ddca$export$51186ad6e864892a = v; });
$parcel$export($cfbf3f9f9fe9ddca$exports, "unaryOp", function () { return $cfbf3f9f9fe9ddca$export$a47f90b6064508f9; }, function (v) { return $cfbf3f9f9fe9ddca$export$a47f90b6064508f9 = v; });
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * Handles a subexpression that's used to define a transform argument's value.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$bf99ae2731a267af;
/**
 * Handles new array literals by adding them as a new node in the AST,
 * initialized with an empty array.
 */ var $cfbf3f9f9fe9ddca$export$dbbb5fc86f066522;
/**
 * Handles a subexpression representing an element of an array literal.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$56baa95599a4a114;
/**
 * Handles tokens of type 'binaryOp', indicating an operation that has two
 * inputs: a left side and a right side.
 * @param {{type: <string>}} token A token object
 */ var $cfbf3f9f9fe9ddca$export$bf7110d4c5a71b17;
/**
 * Handles successive nodes in an identifier chain.  More specifically, it
 * sets values that determine how the following identifier gets placed in the
 * AST.
 */ var $cfbf3f9f9fe9ddca$export$94132a0e348806d4;
/**
 * Handles a subexpression used for filtering an array returned by an
 * identifier chain.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$3dea766d36a8935f;
/**
 * Handles identifier tokens by adding them as a new node in the AST.
 * @param {{type: <string>}} token A token object
 */ var $cfbf3f9f9fe9ddca$export$c2ab62c7bf24634;
/**
 * Handles literal values, such as strings, booleans, and numerics, by adding
 * them as a new node in the AST.
 * @param {{type: <string>}} token A token object
 */ var $cfbf3f9f9fe9ddca$export$c8ec6e1ec9fefcb0;
/**
 * Queues a new object literal key to be written once a value is collected.
 * @param {{type: <string>}} token A token object
 */ var $cfbf3f9f9fe9ddca$export$a7e3a597b5fb619;
/**
 * Handles new object literals by adding them as a new node in the AST,
 * initialized with an empty object.
 */ var $cfbf3f9f9fe9ddca$export$ae43e9a7db1a053e;
/**
 * Handles an object value by adding its AST to the queued key on the object
 * literal node currently at the cursor.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$316663dec3b13f08;
/**
 * Handles traditional subexpressions, delineated with the groupStart and
 * groupEnd elements.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$64f55baf472b5db;
/**
 * Handles a completed alternate subexpression of a ternary operator.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$4747a6a8ead63555;
/**
 * Handles a completed consequent subexpression of a ternary operator.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $cfbf3f9f9fe9ddca$export$b9522f35ae4fd641;
/**
 * Handles the start of a new ternary expression by encapsulating the entire
 * AST in a ConditionalExpression node, and using the existing tree as the
 * test element.
 */ var $cfbf3f9f9fe9ddca$export$193e5ad6f5c47f1;
/**
 * Handles identifier tokens when used to indicate the name of a transform to
 * be applied.
 * @param {{type: <string>}} token A token object
 */ var $cfbf3f9f9fe9ddca$export$51186ad6e864892a;
/**
 * Handles token of type 'unaryOp', indicating that the operation has only
 * one input: a right side.
 * @param {{type: <string>}} token A token object
 */ var $cfbf3f9f9fe9ddca$export$a47f90b6064508f9;
$cfbf3f9f9fe9ddca$export$bf99ae2731a267af = function(ast) {
    this._cursor.args.push(ast);
};
$cfbf3f9f9fe9ddca$export$dbbb5fc86f066522 = function() {
    this._placeAtCursor({
        type: 'ArrayLiteral',
        value: []
    });
};
$cfbf3f9f9fe9ddca$export$56baa95599a4a114 = function(ast) {
    if (ast) this._cursor.value.push(ast);
};
$cfbf3f9f9fe9ddca$export$bf7110d4c5a71b17 = function(token) {
    var precedence = this._grammar[token.value].precedence || 0, parent = this._cursor._parent;
    while(parent && parent.operator && this._grammar[parent.operator].precedence >= precedence){
        this._cursor = parent;
        parent = parent._parent;
    }
    var node = {
        type: 'BinaryExpression',
        operator: token.value,
        left: this._cursor
    };
    this._setParent(this._cursor, node);
    this._cursor = parent;
    this._placeAtCursor(node);
};
$cfbf3f9f9fe9ddca$export$94132a0e348806d4 = function() {
    this._nextIdentEncapsulate = this._cursor && (this._cursor.type != 'BinaryExpression' || this._cursor.type == 'BinaryExpression' && this._cursor.right) && this._cursor.type != 'UnaryExpression';
    this._nextIdentRelative = !this._cursor || this._cursor && !this._nextIdentEncapsulate;
    if (this._nextIdentRelative) this._relative = true;
};
$cfbf3f9f9fe9ddca$export$3dea766d36a8935f = function(ast) {
    this._placeBeforeCursor({
        type: 'FilterExpression',
        expr: ast,
        relative: this._subParser.isRelative(),
        subject: this._cursor
    });
};
$cfbf3f9f9fe9ddca$export$c2ab62c7bf24634 = function(token) {
    var node = {
        type: 'Identifier',
        value: token.value
    };
    if (this._nextIdentEncapsulate) {
        node.from = this._cursor;
        this._placeBeforeCursor(node);
        this._nextIdentEncapsulate = false;
    } else {
        if (this._nextIdentRelative) node.relative = true;
        this._placeAtCursor(node);
    }
};
$cfbf3f9f9fe9ddca$export$c8ec6e1ec9fefcb0 = function(token) {
    this._placeAtCursor({
        type: 'Literal',
        value: token.value
    });
};
$cfbf3f9f9fe9ddca$export$a7e3a597b5fb619 = function(token) {
    this._curObjKey = token.value;
};
$cfbf3f9f9fe9ddca$export$ae43e9a7db1a053e = function() {
    this._placeAtCursor({
        type: 'ObjectLiteral',
        value: {}
    });
};
$cfbf3f9f9fe9ddca$export$316663dec3b13f08 = function(ast) {
    this._cursor.value[this._curObjKey] = ast;
};
$cfbf3f9f9fe9ddca$export$64f55baf472b5db = function(ast) {
    this._placeAtCursor(ast);
};
$cfbf3f9f9fe9ddca$export$4747a6a8ead63555 = function(ast) {
    this._cursor.alternate = ast;
};
$cfbf3f9f9fe9ddca$export$b9522f35ae4fd641 = function(ast) {
    this._cursor.consequent = ast;
};
$cfbf3f9f9fe9ddca$export$193e5ad6f5c47f1 = function() {
    this._tree = {
        type: 'ConditionalExpression',
        test: this._tree
    };
    this._cursor = this._tree;
};
$cfbf3f9f9fe9ddca$export$51186ad6e864892a = function(token) {
    this._placeBeforeCursor({
        type: 'Transform',
        name: token.value,
        args: [],
        subject: this._cursor
    });
};
$cfbf3f9f9fe9ddca$export$a47f90b6064508f9 = function(token) {
    this._placeAtCursor({
        type: 'UnaryExpression',
        operator: token.value
    });
};


/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * A mapping of all states in the finite state machine to a set of instructions
 * for handling or transitioning into other states. Each state can be handled
 * in one of two schemes: a tokenType map, or a subHandler.
 *
 * Standard expression elements are handled through the tokenType object. This
 * is an object map of all legal token types to encounter in this state (and
 * any unexpected token types will generate a thrown error) to an options
 * object that defines how they're handled.  The available options are:
 *
 *      {string} toState: The name of the state to which to transition
 *          immediately after handling this token
 *      {string} handler: The handler function to call when this token type is
 *          encountered in this state.  If omitted, the default handler
 *          matching the token's "type" property will be called. If the handler
 *          function does not exist, no call will be made and no error will be
 *          generated.  This is useful for tokens whose sole purpose is to
 *          transition to other states.
 *
 * States that consume a subexpression should define a subHandler, the
 * function to be called with an expression tree argument when the
 * subexpression is complete. Completeness is determined through the
 * endStates object, which maps tokens on which an expression should end to the
 * state to which to transition once the subHandler function has been called.
 *
 * Additionally, any state in which it is legal to mark the AST as completed
 * should have a 'completable' property set to boolean true.  Attempting to
 * call {@link Parser#complete} in any state without this property will result
 * in a thrown Error.
 *
 * @type {{}}
 */ var $18c3806c6645489a$export$b782dad1d219cf26;

$18c3806c6645489a$export$b782dad1d219cf26 = {
    expectOperand: {
        tokenTypes: {
            literal: {
                toState: 'expectBinOp'
            },
            identifier: {
                toState: 'identifier'
            },
            unaryOp: {},
            openParen: {
                toState: 'subExpression'
            },
            openCurl: {
                toState: 'expectObjKey',
                handler: $cfbf3f9f9fe9ddca$export$ae43e9a7db1a053e
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'arrayVal',
                handler: $cfbf3f9f9fe9ddca$export$dbbb5fc86f066522
            }
        }
    },
    expectBinOp: {
        tokenTypes: {
            binaryOp: {
                toState: 'expectOperand'
            },
            pipe: {
                toState: 'expectTransform'
            },
            dot: {
                toState: 'traverse'
            },
            question: {
                toState: 'ternaryMid',
                handler: $cfbf3f9f9fe9ddca$export$193e5ad6f5c47f1
            }
        },
        completable: true
    },
    expectTransform: {
        tokenTypes: {
            identifier: {
                toState: 'postTransform',
                handler: $cfbf3f9f9fe9ddca$export$51186ad6e864892a
            }
        }
    },
    expectObjKey: {
        tokenTypes: {
            identifier: {
                toState: 'expectKeyValSep',
                handler: $cfbf3f9f9fe9ddca$export$a7e3a597b5fb619
            },
            closeCurl: {
                toState: 'expectBinOp'
            }
        }
    },
    expectKeyValSep: {
        tokenTypes: {
            colon: {
                toState: 'objVal'
            }
        }
    },
    postTransform: {
        tokenTypes: {
            openParen: {
                toState: 'argVal'
            },
            binaryOp: {
                toState: 'expectOperand'
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'filter'
            },
            pipe: {
                toState: 'expectTransform'
            }
        },
        completable: true
    },
    postTransformArgs: {
        tokenTypes: {
            binaryOp: {
                toState: 'expectOperand'
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'filter'
            },
            pipe: {
                toState: 'expectTransform'
            }
        },
        completable: true
    },
    identifier: {
        tokenTypes: {
            binaryOp: {
                toState: 'expectOperand'
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'filter'
            },
            pipe: {
                toState: 'expectTransform'
            },
            question: {
                toState: 'ternaryMid',
                handler: $cfbf3f9f9fe9ddca$export$193e5ad6f5c47f1
            }
        },
        completable: true
    },
    traverse: {
        tokenTypes: {
            'identifier': {
                toState: 'identifier'
            }
        }
    },
    filter: {
        subHandler: $cfbf3f9f9fe9ddca$export$3dea766d36a8935f,
        endStates: {
            closeBracket: 'identifier'
        }
    },
    subExpression: {
        subHandler: $cfbf3f9f9fe9ddca$export$64f55baf472b5db,
        endStates: {
            closeParen: 'expectBinOp'
        }
    },
    argVal: {
        subHandler: $cfbf3f9f9fe9ddca$export$bf99ae2731a267af,
        endStates: {
            comma: 'argVal',
            closeParen: 'postTransformArgs'
        }
    },
    objVal: {
        subHandler: $cfbf3f9f9fe9ddca$export$316663dec3b13f08,
        endStates: {
            comma: 'expectObjKey',
            closeCurl: 'expectBinOp'
        }
    },
    arrayVal: {
        subHandler: $cfbf3f9f9fe9ddca$export$56baa95599a4a114,
        endStates: {
            comma: 'arrayVal',
            closeBracket: 'expectBinOp'
        }
    },
    ternaryMid: {
        subHandler: $cfbf3f9f9fe9ddca$export$b9522f35ae4fd641,
        endStates: {
            colon: 'ternaryEnd'
        }
    },
    ternaryEnd: {
        subHandler: $cfbf3f9f9fe9ddca$export$4747a6a8ead63555,
        completable: true
    }
};


var $eee396428c4f8002$require$states = $18c3806c6645489a$export$b782dad1d219cf26;
/**
 * The Parser is a state machine that converts tokens from the {@link Lexer}
 * into an Abstract Syntax Tree (AST), capable of being evaluated in any
 * context by the {@link Evaluator}.  The Parser expects that all tokens
 * provided to it are legal and typed properly according to the grammar, but
 * accepts that the tokens may still be in an invalid order or in some other
 * unparsable configuration that requires it to throw an Error.
 * @param {{}} grammar The grammar map to use to parse Jexl strings
 * @param {string} [prefix] A string prefix to prepend to the expression string
 *      for error messaging purposes.  This is useful for when a new Parser is
 *      instantiated to parse an subexpression, as the parent Parser's
 *      expression string thus far can be passed for a more user-friendly
 *      error message.
 * @param {{}} [stopMap] A mapping of token types to any truthy value. When the
 *      token type is encountered, the parser will return the mapped value
 *      instead of boolean false.
 * @constructor
 */ function $eee396428c4f8002$var$Parser(grammar, prefix, stopMap) {
    this._grammar = grammar;
    this._state = 'expectOperand';
    this._tree = null;
    this._exprStr = prefix || '';
    this._relative = false;
    this._stopMap = stopMap || {};
}
/**
 * Processes a new token into the AST and manages the transitions of the state
 * machine.
 * @param {{type: <string>}} token A token object, as provided by the
 *      {@link Lexer#tokenize} function.
 * @throws {Error} if a token is added when the Parser has been marked as
 *      complete by {@link #complete}, or if an unexpected token type is added.
 * @returns {boolean|*} the stopState value if this parser encountered a token
 *      in the stopState mapb; false if tokens can continue.
 */ $eee396428c4f8002$var$Parser.prototype.addToken = function(token) {
    if (this._state == 'complete') throw new Error('Cannot add a new token to a completed Parser');
    var state = $eee396428c4f8002$require$states[this._state], startExpr = this._exprStr;
    this._exprStr += token.raw;
    if (state.subHandler) {
        if (!this._subParser) this._startSubExpression(startExpr);
        var stopState = this._subParser.addToken(token);
        if (stopState) {
            this._endSubExpression();
            if (this._parentStop) return stopState;
            this._state = stopState;
        }
    } else if (state.tokenTypes[token.type]) {
        var typeOpts = state.tokenTypes[token.type], handleFunc = $cfbf3f9f9fe9ddca$exports[token.type];
        if (typeOpts.handler) handleFunc = typeOpts.handler;
        if (handleFunc) handleFunc.call(this, token);
        if (typeOpts.toState) this._state = typeOpts.toState;
    } else if (this._stopMap[token.type]) return this._stopMap[token.type];
    else throw new Error('Token ' + token.raw + ' (' + token.type + ') unexpected in expression: ' + this._exprStr);
    return false;
};
/**
 * Processes an array of tokens iteratively through the {@link #addToken}
 * function.
 * @param {Array<{type: <string>}>} tokens An array of tokens, as provided by
 *      the {@link Lexer#tokenize} function.
 */ $eee396428c4f8002$var$Parser.prototype.addTokens = function(tokens) {
    tokens.forEach(this.addToken, this);
};
/**
 * Marks this Parser instance as completed and retrieves the full AST.
 * @returns {{}|null} a full expression tree, ready for evaluation by the
 *      {@link Evaluator#eval} function, or null if no tokens were passed to
 *      the parser before complete was called
 * @throws {Error} if the parser is not in a state where it's legal to end
 *      the expression, indicating that the expression is incomplete
 */ $eee396428c4f8002$var$Parser.prototype.complete = function() {
    if (this._cursor && !$eee396428c4f8002$require$states[this._state].completable) throw new Error('Unexpected end of expression: ' + this._exprStr);
    if (this._subParser) this._endSubExpression();
    this._state = 'complete';
    return this._cursor ? this._tree : null;
};
/**
 * Indicates whether the expression tree contains a relative path identifier.
 * @returns {boolean} true if a relative identifier exists; false otherwise.
 */ $eee396428c4f8002$var$Parser.prototype.isRelative = function() {
    return this._relative;
};
/**
 * Ends a subexpression by completing the subParser and passing its result
 * to the subHandler configured in the current state.
 * @private
 */ $eee396428c4f8002$var$Parser.prototype._endSubExpression = function() {
    $eee396428c4f8002$require$states[this._state].subHandler.call(this, this._subParser.complete());
    this._subParser = null;
};
/**
 * Places a new tree node at the current position of the cursor (to the 'right'
 * property) and then advances the cursor to the new node. This function also
 * handles setting the parent of the new node.
 * @param {{type: <string>}} node A node to be added to the AST
 * @private
 */ $eee396428c4f8002$var$Parser.prototype._placeAtCursor = function(node) {
    if (!this._cursor) this._tree = node;
    else {
        this._cursor.right = node;
        this._setParent(node, this._cursor);
    }
    this._cursor = node;
};
/**
 * Places a tree node before the current position of the cursor, replacing
 * the node that the cursor currently points to. This should only be called in
 * cases where the cursor is known to exist, and the provided node already
 * contains a pointer to what's at the cursor currently.
 * @param {{type: <string>}} node A node to be added to the AST
 * @private
 */ $eee396428c4f8002$var$Parser.prototype._placeBeforeCursor = function(node) {
    this._cursor = this._cursor._parent;
    this._placeAtCursor(node);
};
/**
 * Sets the parent of a node by creating a non-enumerable _parent property
 * that points to the supplied parent argument.
 * @param {{type: <string>}} node A node of the AST on which to set a new
 *      parent
 * @param {{type: <string>}} parent An existing node of the AST to serve as the
 *      parent of the new node
 * @private
 */ $eee396428c4f8002$var$Parser.prototype._setParent = function(node, parent) {
    Object.defineProperty(node, '_parent', {
        value: parent,
        writable: true
    });
};
/**
 * Prepares the Parser to accept a subexpression by (re)instantiating the
 * subParser.
 * @param {string} [exprStr] The expression string to prefix to the new Parser
 * @private
 */ $eee396428c4f8002$var$Parser.prototype._startSubExpression = function(exprStr) {
    var endStates = $eee396428c4f8002$require$states[this._state].endStates;
    if (!endStates) {
        this._parentStop = true;
        endStates = this._stopMap;
    }
    this._subParser = new $eee396428c4f8002$var$Parser(this._grammar, exprStr, endStates);
};
$eee396428c4f8002$exports = $eee396428c4f8002$var$Parser;


/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * A map of all expression elements to their properties. Note that changes
 * here may require changes in the Lexer or Parser.
 * @type {{}}
 */ var $a53a83e9daf614b8$export$7a5d735b2ab6389d;
$a53a83e9daf614b8$export$7a5d735b2ab6389d = {
    '.': {
        type: 'dot'
    },
    '[': {
        type: 'openBracket'
    },
    ']': {
        type: 'closeBracket'
    },
    '|': {
        type: 'pipe'
    },
    '{': {
        type: 'openCurl'
    },
    '}': {
        type: 'closeCurl'
    },
    ':': {
        type: 'colon'
    },
    ',': {
        type: 'comma'
    },
    '(': {
        type: 'openParen'
    },
    ')': {
        type: 'closeParen'
    },
    '?': {
        type: 'question'
    },
    '+': {
        type: 'binaryOp',
        precedence: 30,
        eval: function _eval(left, right) {
            return left + right;
        }
    },
    '-': {
        type: 'binaryOp',
        precedence: 30,
        eval: function _eval(left, right) {
            return left - right;
        }
    },
    '*': {
        type: 'binaryOp',
        precedence: 40,
        eval: function _eval(left, right) {
            return left * right;
        }
    },
    '/': {
        type: 'binaryOp',
        precedence: 40,
        eval: function _eval(left, right) {
            return left / right;
        }
    },
    '//': {
        type: 'binaryOp',
        precedence: 40,
        eval: function _eval(left, right) {
            return Math.floor(left / right);
        }
    },
    '%': {
        type: 'binaryOp',
        precedence: 50,
        eval: function _eval(left, right) {
            return left % right;
        }
    },
    '^': {
        type: 'binaryOp',
        precedence: 50,
        eval: function _eval(left, right) {
            return Math.pow(left, right);
        }
    },
    '==': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            return left == right;
        }
    },
    '!=': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            return left != right;
        }
    },
    '>': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            return left > right;
        }
    },
    '>=': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            return left >= right;
        }
    },
    '<': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            return left < right;
        }
    },
    '<=': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            return left <= right;
        }
    },
    '&&': {
        type: 'binaryOp',
        precedence: 10,
        eval: function _eval(left, right) {
            return left && right;
        }
    },
    '||': {
        type: 'binaryOp',
        precedence: 10,
        eval: function _eval(left, right) {
            return left || right;
        }
    },
    'in': {
        type: 'binaryOp',
        precedence: 20,
        eval: function _eval(left, right) {
            if (typeof right === 'string') return right.indexOf(left) !== -1;
            if (Array.isArray(right)) return right.some(function(elem) {
                return elem == left;
            });
            return false;
        }
    },
    '!': {
        type: 'unaryOp',
        precedence: Infinity,
        eval: function _eval(right) {
            return !right;
        }
    }
};


var $5dac4bdd26a2c0cd$require$defaultGrammar = $a53a83e9daf614b8$export$7a5d735b2ab6389d;
/**
 * Jexl is the Javascript Expression Language, capable of parsing and
 * evaluating basic to complex expression strings, combined with advanced
 * xpath-like drilldown into native Javascript objects.
 * @constructor
 */ function $5dac4bdd26a2c0cd$var$Jexl() {
    this._customGrammar = null;
    this._lexer = null;
    this._transforms = {};
}
/**
 * Adds a binary operator to Jexl at the specified precedence. The higher the
 * precedence, the earlier the operator is applied in the order of operations.
 * For example, * has a higher precedence than +, because multiplication comes
 * before division.
 *
 * Please see grammar.js for a listing of all default operators and their
 * precedence values in order to choose the appropriate precedence for the
 * new operator.
 * @param {string} operator The operator string to be added
 * @param {number} precedence The operator's precedence
 * @param {function} fn A function to run to calculate the result. The function
 *      will be called with two arguments: left and right, denoting the values
 *      on either side of the operator. It should return either the resulting
 *      value, or a Promise that resolves with the resulting value.
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.addBinaryOp = function(operator, precedence, fn) {
    this._addGrammarElement(operator, {
        type: 'binaryOp',
        precedence: precedence,
        eval: fn
    });
};
/**
 * Adds a unary operator to Jexl. Unary operators are currently only supported
 * on the left side of the value on which it will operate.
 * @param {string} operator The operator string to be added
 * @param {function} fn A function to run to calculate the result. The function
 *      will be called with one argument: the literal value to the right of the
 *      operator. It should return either the resulting value, or a Promise
 *      that resolves with the resulting value.
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.addUnaryOp = function(operator, fn) {
    this._addGrammarElement(operator, {
        type: 'unaryOp',
        weight: Infinity,
        eval: fn
    });
};
/**
 * Adds or replaces a transform function in this Jexl instance.
 * @param {string} name The name of the transform function, as it will be used
 *      within Jexl expressions
 * @param {function} fn The function to be executed when this transform is
 *      invoked.  It will be provided with two arguments:
 *          - {*} value: The value to be transformed
 *          - {{}} args: The arguments for this transform
 *          - {function} cb: A callback function to be called with an error
 *            if the transform fails, or a null first argument and the
 *            transformed value as the second argument on success.
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.addTransform = function(name, fn) {
    this._transforms[name] = fn;
};
/**
 * Syntactic sugar for calling {@link #addTransform} repeatedly.  This function
 * accepts a map of one or more transform names to their transform function.
 * @param {{}} map A map of transform names to transform functions
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.addTransforms = function(map) {
    for(var key in map)if (map.hasOwnProperty(key)) this._transforms[key] = map[key];
};
/**
 * Retrieves a previously set transform function.
 * @param {string} name The name of the transform function
 * @returns {function} The transform function
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.getTransform = function(name) {
    return this._transforms[name];
};
/**
 * Evaluates a Jexl string within an optional context.
 * @param {string} expression The Jexl expression to be evaluated
 * @param {Object} [context] A mapping of variables to values, which will be
 *      made accessible to the Jexl expression when evaluating it
 * @param {function} [cb] An optional callback function to be executed when
 *      evaluation is complete.  It will be supplied with two arguments:
 *          - {Error|null} err: Present if an error occurred
 *          - {*} result: The result of the evaluation
 * @returns {Promise<*>} resolves with the result of the evaluation.  Note that
 *      if a callback is supplied, the returned promise will already have
 *      a '.catch' attached to it in order to pass the error to the callback.
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.eval = function(expression, context, cb) {
    if (typeof context === 'function') {
        cb = context;
        context = {};
    } else if (!context) context = {};
    var valPromise = this._eval(expression, context);
    if (cb) {
        // setTimeout is used for the callback to break out of the Promise's
        // try/catch in case the callback throws.
        var called = false;
        return valPromise.then(function(val) {
            called = true;
            setTimeout(cb.bind(null, null, val), 0);
        }).catch(function(err) {
            if (!called) setTimeout(cb.bind(null, err), 0);
        });
    }
    return valPromise;
};
/**
 * Removes a binary or unary operator from the Jexl grammar.
 * @param {string} operator The operator string to be removed
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype.removeOp = function(operator) {
    var grammar = this._getCustomGrammar();
    if (grammar[operator] && (grammar[operator].type == 'binaryOp' || grammar[operator].type == 'unaryOp')) {
        delete grammar[operator];
        this._lexer = null;
    }
};
/**
 * Adds an element to the grammar map used by this Jexl instance, cloning
 * the default grammar first if necessary.
 * @param {string} str The key string to be added
 * @param {{type: <string>}} obj A map of configuration options for this
 *      grammar element
 * @private
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype._addGrammarElement = function(str, obj) {
    var grammar = this._getCustomGrammar();
    grammar[str] = obj;
    this._lexer = null;
};
/**
 * Evaluates a Jexl string in the given context.
 * @param {string} exp The Jexl expression to be evaluated
 * @param {Object} [context] A mapping of variables to values, which will be
 *      made accessible to the Jexl expression when evaluating it
 * @returns {Promise<*>} resolves with the result of the evaluation.
 * @private
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype._eval = function(exp, context) {
    var self = this, grammar = this._getGrammar(), parser = new $eee396428c4f8002$exports(grammar), evaluator = new $c5e7aed4dc4d8616$exports(grammar, this._transforms, context);
    return Promise.resolve().then(function() {
        parser.addTokens(self._getLexer().tokenize(exp));
        return evaluator.eval(parser.complete());
    });
};
/**
 * Gets the custom grammar object, creating it first if necessary. New custom
 * grammars are created by executing a shallow clone of the default grammar
 * map. The returned map is available to be changed.
 * @returns {{}} a customizable grammar map.
 * @private
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype._getCustomGrammar = function() {
    if (!this._customGrammar) {
        this._customGrammar = {};
        for(var key in $5dac4bdd26a2c0cd$require$defaultGrammar)if ($5dac4bdd26a2c0cd$require$defaultGrammar.hasOwnProperty(key)) this._customGrammar[key] = $5dac4bdd26a2c0cd$require$defaultGrammar[key];
    }
    return this._customGrammar;
};
/**
 * Gets the grammar map currently being used by Jexl; either the default map,
 * or a locally customized version. The returned map should never be changed
 * in any way.
 * @returns {{}} the grammar map currently in use.
 * @private
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype._getGrammar = function() {
    return this._customGrammar || $5dac4bdd26a2c0cd$require$defaultGrammar;
};
/**
 * Gets a Lexer instance as a singleton in reference to this Jexl instance.
 * @returns {Lexer} an instance of Lexer, initialized with a grammar
 *      appropriate to this Jexl instance.
 * @private
 */ $5dac4bdd26a2c0cd$var$Jexl.prototype._getLexer = function() {
    if (!this._lexer) this._lexer = new $a23c9611874f207f$exports(this._getGrammar());
    return this._lexer;
};
$5dac4bdd26a2c0cd$exports = new $5dac4bdd26a2c0cd$var$Jexl();
$5dac4bdd26a2c0cd$exports.Jexl = $5dac4bdd26a2c0cd$var$Jexl;


var $3bcc809cc836538c$var$forms = [];
document.querySelectorAll('form').forEach(function(form) {
    var getFormValues = function getFormValues() {
        var regex = /^tx_form_formframework\[.*?]\[(.*?)]/;
        var formData = new FormData(form);
        var formValues = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = formData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $iFZdg._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                var matched = regex.exec(key);
                if (!matched) continue;
                formValues[matched[1]] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return formValues;
    };
    var checkConditions = function checkConditions() {
        var context = {
            formValues: getFormValues()
        };
        conditions.forEach(function(el) {
            var condition = el.dataset.showCondition;
            (0, (/*@__PURE__*/$parcel$interopDefault($5dac4bdd26a2c0cd$exports))).eval(condition, context).then(function(result) {
                if (result) {
                    // el.style.height = el.scrollHeight + 'px';
                    el.style.display = '';
                    // add all required-attributes to childrens
                    el.querySelectorAll('[data-required]').forEach(function(child) {
                        child.required = true;
                        delete child.dataset.required;
                    });
                } else {
                    el.style.display = 'none';
                    // el.style.height = '0px';
                    // remove all required-attributes from childrens
                    el.querySelectorAll('[required]').forEach(function(child) {
                        child.required = false;
                        child.dataset.required = 'true';
                    });
                }
            });
        });
    };
    // only add event listeners and check conditions if form has conditions
    var conditions = form.querySelectorAll('[data-show-condition]');
    if (conditions.length === 0) return;
    form.addEventListener('change', function() {
        checkConditions();
    });
    checkConditions();
});


var $cebce4497d6d3992$exports = {};

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $9HFeY = parcelRequire("9HFeY");

var $4udDG = parcelRequire("4udDG");

var $iFZdg = parcelRequire("iFZdg");

var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");
!function(e, t) {
    $cebce4497d6d3992$exports = t();
}(undefined, function() {
    return function() {
        "use strict";
        var e = {
            d: function d(t, i) {
                for(var s in i)e.o(i, s) && !e.o(t, s) && Object.defineProperty(t, s, {
                    enumerable: !0,
                    get: i[s]
                });
            },
            o: function o(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
        }, t = {};
        e.d(t, {
            default: function _default() {
                return R;
            }
        });
        var i = {
            days: "days",
            months: "months",
            years: "years",
            day: "day",
            month: "month",
            year: "year",
            eventChangeViewDate: "changeViewDate",
            eventChangeCurrentView: "changeCurrentView",
            eventChangeFocusDate: "changeFocusDate",
            eventChangeSelectedDate: "changeSelectedDate",
            eventChangeTime: "changeTime",
            eventChangeLastSelectedDate: "changeLastSelectedDate",
            actionSelectDate: "selectDate",
            actionUnselectDate: "unselectDate",
            cssClassWeekend: "-weekend-"
        }, s = {
            classes: "",
            inline: !1,
            locale: {
                days: [
                    "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
                    "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
                    "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
                    "\u0421\u0440\u0435\u0434\u0430",
                    "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
                    "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
                    "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
                ],
                daysShort: [
                    "\u0412\u043E\u0441",
                    "\u041F\u043E\u043D",
                    "\u0412\u0442\u043E",
                    "\u0421\u0440\u0435",
                    "\u0427\u0435\u0442",
                    "\u041F\u044F\u0442",
                    "\u0421\u0443\u0431"
                ],
                daysMin: [
                    "\u0412\u0441",
                    "\u041F\u043D",
                    "\u0412\u0442",
                    "\u0421\u0440",
                    "\u0427\u0442",
                    "\u041F\u0442",
                    "\u0421\u0431"
                ],
                months: [
                    "\u042F\u043D\u0432\u0430\u0440\u044C",
                    "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
                    "\u041C\u0430\u0440\u0442",
                    "\u0410\u043F\u0440\u0435\u043B\u044C",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D\u044C",
                    "\u0418\u044E\u043B\u044C",
                    "\u0410\u0432\u0433\u0443\u0441\u0442",
                    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
                    "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
                    "\u041D\u043E\u044F\u0431\u0440\u044C",
                    "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
                ],
                monthsShort: [
                    "\u042F\u043D\u0432",
                    "\u0424\u0435\u0432",
                    "\u041C\u0430\u0440",
                    "\u0410\u043F\u0440",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D",
                    "\u0418\u044E\u043B",
                    "\u0410\u0432\u0433",
                    "\u0421\u0435\u043D",
                    "\u041E\u043A\u0442",
                    "\u041D\u043E\u044F",
                    "\u0414\u0435\u043A"
                ],
                today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
                clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                dateFormat: "dd.MM.yyyy",
                timeFormat: "HH:mm",
                firstDay: 1
            },
            startDate: new Date,
            firstDay: "",
            weekends: [
                6,
                0
            ],
            dateFormat: "",
            altField: "",
            altFieldDateFormat: "T",
            toggleSelected: !0,
            keyboardNav: !0,
            selectedDates: !1,
            container: "",
            isMobile: !1,
            visible: !1,
            position: "bottom left",
            offset: 12,
            view: i.days,
            minView: i.days,
            showOtherMonths: !0,
            selectOtherMonths: !0,
            moveToOtherMonthsOnSelect: !0,
            showOtherYears: !0,
            selectOtherYears: !0,
            moveToOtherYearsOnSelect: !0,
            minDate: "",
            maxDate: "",
            disableNavWhenOutOfRange: !0,
            multipleDates: !1,
            multipleDatesSeparator: ", ",
            range: !1,
            dynamicRange: !0,
            buttons: !1,
            monthsField: "monthsShort",
            showEvent: "focus",
            autoClose: !1,
            fixedHeight: !1,
            prevHtml: '<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',
            nextHtml: '<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',
            navTitles: {
                days: "MMMM, <i>yyyy</i>",
                months: "yyyy",
                years: "yyyy1 - yyyy2"
            },
            timepicker: !1,
            onlyTimepicker: !1,
            dateTimeSeparator: " ",
            timeFormat: "",
            minHours: 0,
            maxHours: 24,
            minMinutes: 0,
            maxMinutes: 59,
            hoursStep: 1,
            minutesStep: 1,
            onSelect: !1,
            onChangeViewDate: !1,
            onChangeView: !1,
            onRenderCell: !1,
            onShow: !1,
            onHide: !1,
            onClickDayName: !1
        };
        function a(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
            return "string" == typeof e ? t.querySelector(e) : e;
        }
        function n() {
            var _n_classList;
            var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, tmp = _ref.tagName, e = tmp === void 0 ? "div" : tmp, tmp1 = _ref.className, t = tmp1 === void 0 ? "" : tmp1, tmp2 = _ref.innerHtml, i = tmp2 === void 0 ? "" : tmp2, tmp3 = _ref.id, s = tmp3 === void 0 ? "" : tmp3, tmp4 = _ref.attrs, a = tmp4 === void 0 ? {} : tmp4, n = document.createElement(e);
            return t && (_n_classList = n.classList).add.apply(_n_classList, (0, $2b6Uo._)(t.split(" "))), s && (n.id = s), i && (n.innerHTML = i), a && r(n, a), n;
        }
        function r(e, t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $iFZdg._)(_step.value, 2), i = _step_value[0], s = _step_value[1];
                    void 0 !== s && e.setAttribute(i, s);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return e;
        }
        function o(e) {
            return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
        }
        function h(e) {
            var t = e.getHours(), _l = l(t), i = _l.hours, s = _l.dayPeriod;
            return {
                year: e.getFullYear(),
                month: e.getMonth(),
                fullMonth: e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1,
                date: e.getDate(),
                fullDate: e.getDate() < 10 ? "0" + e.getDate() : e.getDate(),
                day: e.getDay(),
                hours: t,
                fullHours: d(t),
                hours12: i,
                dayPeriod: s,
                fullHours12: d(i),
                minutes: e.getMinutes(),
                fullMinutes: e.getMinutes() < 10 ? "0" + e.getMinutes() : e.getMinutes()
            };
        }
        function l(e) {
            return {
                dayPeriod: e > 11 ? "pm" : "am",
                hours: e % 12 == 0 ? 12 : e % 12
            };
        }
        function d(e) {
            return e < 10 ? "0" + e : e;
        }
        function c(e) {
            var t = 10 * Math.floor(e.getFullYear() / 10);
            return [
                t,
                t + 9
            ];
        }
        function u() {
            var e = [];
            for(var t = arguments.length, i = new Array(t), s = 0; s < t; s++)i[s] = arguments[s];
            return i.forEach(function(t) {
                if ("object" == (typeof t === "undefined" ? "undefined" : (0, $22yUM._)(t))) for(var i in t)t[i] && e.push(i);
                else t && e.push(t);
            }), e.join(" ");
        }
        function p(e, t) {
            var s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.days;
            if (!e || !t) return !1;
            var a = h(e), n = h(t);
            var _obj;
            return (_obj = {}, (0, $9HFeY._)(_obj, i.days, a.date === n.date && a.month === n.month && a.year === n.year), (0, $9HFeY._)(_obj, i.months, a.month === n.month && a.year === n.year), (0, $9HFeY._)(_obj, i.years, a.year === n.year), _obj)[s];
        }
        function m(e, t, i) {
            var s = g(e, !1).getTime(), a = g(t, !1).getTime();
            return i ? s >= a : s > a;
        }
        function v(e, t) {
            return !m(e, t, !0);
        }
        function g(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = new Date(e.getTime());
            return "boolean" != typeof t || t || function(e) {
                e.setHours(0, 0, 0, 0);
            }(i), i;
        }
        function D(e, t, i) {
            e.length ? e.forEach(function(e) {
                e.addEventListener(t, i);
            }) : e.addEventListener(t, i);
        }
        function y(e, t) {
            return !(!e || e === document || e instanceof DocumentFragment) && (e.matches(t) ? e : y(e.parentNode, t));
        }
        function f(e, t, i) {
            return e > i ? i : e < t ? t : e;
        }
        function w(e) {
            for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
            return i.filter(function(e) {
                return e;
            }).forEach(function(t) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), i = _step_value[0], s = _step_value[1];
                        if (void 0 !== s && "[object Object]" === s.toString()) {
                            var _$t = void 0 !== e[i] ? e[i].toString() : void 0, a = s.toString(), n = Array.isArray(s) ? [] : {};
                            e[i] = e[i] ? _$t !== a ? n : e[i] : n, w(e[i], s);
                        } else e[i] = s;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }), e;
        }
        function b(e) {
            var t = e;
            return e instanceof Date || ("string" == typeof e && /^\d{4}-\d{2}-\d{2}$/.test(e) && (e += "T00:00:00"), t = new Date(e)), isNaN(t.getTime()) && (console.log('Unable to convert value "'.concat(e, '" to Date object')), t = !1), t;
        }
        function k(e) {
            var t = "\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";
            return new RegExp("(^|>|" + t + ")(" + e + ")($|<|" + t + ")", "g");
        }
        function $(e, t, i) {
            return (t = function(e) {
                var _$t = function(e, t) {
                    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $22yUM._)(e)) || null === e) return e;
                    var _$i = e[Symbol.toPrimitive];
                    if (void 0 !== _$i) {
                        var s = _$i.call(e, "string");
                        if ("object" != (typeof s === "undefined" ? "undefined" : (0, $22yUM._)(s))) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $22yUM._)(_$t)) ? _$t : String(_$t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        var C = /*#__PURE__*/ function() {
            function C() {
                var _this = this;
                (0, $eCXNS._)(this, C);
                var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = _ref.type, t = _ref.date, i = _ref.dp, s = _ref.opts, a = _ref.body;
                $(this, "focus", function() {
                    _this.$cell.classList.add("-focus-"), _this.focused = !0;
                }), $(this, "removeFocus", function() {
                    _this.$cell.classList.remove("-focus-"), _this.focused = !1;
                }), $(this, "select", function() {
                    _this.$cell.classList.add("-selected-"), _this.selected = !0;
                }), $(this, "removeSelect", function() {
                    _this.$cell.classList.remove("-selected-", "-range-from-", "-range-to-"), _this.selected = !1;
                }), $(this, "onChangeSelectedDate", function() {
                    _this.isDisabled || (_this._handleSelectedStatus(), _this.opts.range && _this._handleRangeStatus());
                }), $(this, "onChangeFocusDate", function(e) {
                    if (!e) return void (_this.focused && _this.removeFocus());
                    var t = p(e, _this.date, _this.type);
                    t ? _this.focus() : !t && _this.focused && _this.removeFocus(), _this.opts.range && _this._handleRangeStatus();
                }), $(this, "render", function() {
                    return _this.$cell.innerHTML = _this._getHtml(), _this._handleClasses(), _this.$cell;
                }), this.type = e, this.singleType = this.type.slice(0, -1), this.date = t, this.dp = i, this.opts = s, this.body = a, this.customData = !1, this.init();
            }
            (0, $7M9bt._)(C, [
                {
                    key: "init",
                    value: function init() {
                        var e;
                        var _this_opts = this.opts, t = _this_opts.onRenderCell;
                        t && (this.customData = t({
                            date: this.date,
                            cellType: this.singleType,
                            datepicker: this.dp
                        })), this._createElement(), this._bindDatepickerEvents(), null !== (e = this.customData) && void 0 !== e && e.disabled && this.dp.disableDate(this.date);
                    }
                },
                {
                    key: "_bindDatepickerEvents",
                    value: function _bindDatepickerEvents() {
                        this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeFocusDate, this.onChangeFocusDate);
                    }
                },
                {
                    key: "unbindDatepickerEvents",
                    value: function unbindDatepickerEvents() {
                        this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeFocusDate, this.onChangeFocusDate);
                    }
                },
                {
                    key: "_createElement",
                    value: function _createElement() {
                        var e;
                        var _h = h(this.date), t = _h.year, i = _h.month, s = _h.date, a = (null === (e = this.customData) || void 0 === e ? void 0 : e.attrs) || {};
                        this.$cell = n({
                            attrs: (0, $4udDG._)({
                                "data-year": t,
                                "data-month": i,
                                "data-date": s
                            }, a)
                        }), this.$cell.adpCell = this;
                    }
                },
                {
                    key: "_getClassName",
                    value: function _getClassName() {
                        var e;
                        var t = new Date, _this_opts = this.opts, s = _this_opts.selectOtherMonths, a = _this_opts.selectOtherYears, _this_dp = this.dp, n = _this_dp.minDate, r = _this_dp.maxDate, o = _this_dp.isDateDisabled, _h = h(this.date), l = _h.day, d = this._isOutOfMinMaxRange(), c = o(this.date), m = u("air-datepicker-cell", "-".concat(this.singleType, "-"), {
                            "-current-": p(t, this.date, this.type),
                            "-min-date-": n && p(n, this.date, this.type),
                            "-max-date-": r && p(r, this.date, this.type)
                        }), v = "";
                        switch(this.type){
                            case i.days:
                                v = u({
                                    "-weekend-": this.dp.isWeekend(l),
                                    "-other-month-": this.isOtherMonth,
                                    "-disabled-": this.isOtherMonth && !s || d || c
                                });
                                break;
                            case i.months:
                                v = u({
                                    "-disabled-": d
                                });
                                break;
                            case i.years:
                                v = u({
                                    "-other-decade-": this.isOtherDecade,
                                    "-disabled-": d || this.isOtherDecade && !a
                                });
                        }
                        return u(m, v, null === (e = this.customData) || void 0 === e ? void 0 : e.classes).split(" ");
                    }
                },
                {
                    key: "_getHtml",
                    value: function _getHtml() {
                        var e;
                        var _h = h(this.date), t = _h.year, s = _h.month, a = _h.date, _this_opts = this.opts, n = _this_opts.showOtherMonths, r = _this_opts.showOtherYears;
                        if (null !== (e = this.customData) && void 0 !== e && e.html) return this.customData.html;
                        switch(this.type){
                            case i.days:
                                return !n && this.isOtherMonth ? "" : a;
                            case i.months:
                                return this.dp.locale[this.opts.monthsField][s];
                            case i.years:
                                return !r && this.isOtherDecade ? "" : t;
                        }
                    }
                },
                {
                    key: "_isOutOfMinMaxRange",
                    value: function _isOutOfMinMaxRange() {
                        var _this_dp = this.dp, e = _this_dp.minDate, t = _this_dp.maxDate, _this = this, s = _this.type, a = _this.date, _h = h(a), n = _h.month, r = _h.year, o = _h.date, l = s === i.days, d = s === i.years, c = !!e && new Date(r, d ? e.getMonth() : n, l ? o : e.getDate()), u = !!t && new Date(r, d ? t.getMonth() : n, l ? o : t.getDate());
                        return e && t ? v(c, e) || m(u, t) : e ? v(c, e) : t ? m(u, t) : void 0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.unbindDatepickerEvents();
                    }
                },
                {
                    key: "_handleRangeStatus",
                    value: function _handleRangeStatus() {
                        var _this_$cell_classList;
                        var _this_dp = this.dp, e = _this_dp.selectedDates, t = _this_dp.focusDate, i = _this_dp.rangeDateTo, s = _this_dp.rangeDateFrom, a = e.length;
                        if (!a) return;
                        var n = s, r = i;
                        if (1 === a && t) {
                            var i1 = m(t, e[0]);
                            n = i1 ? e[0] : t, r = i1 ? t : e[0];
                        }
                        var o = u({
                            "-in-range-": n && r && (h = this.date, l = n, d = r, m(h, l) && v(h, d)),
                            "-range-from-": n && p(this.date, n, this.type),
                            "-range-to-": r && p(this.date, r, this.type)
                        });
                        var h, l, d;
                        this.$cell.classList.remove("-range-from-", "-range-to-", "-in-range-"), o && (_this_$cell_classList = this.$cell.classList).add.apply(_this_$cell_classList, (0, $2b6Uo._)(o.split(" ")));
                    }
                },
                {
                    key: "_handleSelectedStatus",
                    value: function _handleSelectedStatus() {
                        var e = this.dp._checkIfDateIsSelected(this.date, this.type);
                        e ? this.select() : !e && this.selected && this.removeSelect();
                    }
                },
                {
                    key: "_handleInitialFocusStatus",
                    value: function _handleInitialFocusStatus() {
                        p(this.dp.focusDate, this.date, this.type) && this.focus();
                    }
                },
                {
                    key: "_handleClasses",
                    value: function _handleClasses() {
                        var _this_$cell_classList;
                        this.$cell.setAttribute("class", ""), this._handleInitialFocusStatus(), this.dp.hasSelectedDates && (this._handleSelectedStatus(), this.dp.opts.range && this._handleRangeStatus()), (_this_$cell_classList = this.$cell.classList).add.apply(_this_$cell_classList, (0, $2b6Uo._)(this._getClassName()));
                    }
                },
                {
                    key: "isDisabled",
                    get: function get() {
                        return this.$cell.matches(".-disabled-");
                    }
                },
                {
                    key: "isOtherMonth",
                    get: function get() {
                        return this.dp.isOtherMonth(this.date);
                    }
                },
                {
                    key: "isOtherDecade",
                    get: function get() {
                        return this.dp.isOtherDecade(this.date);
                    }
                }
            ]);
            return C;
        }();
        function _(e, t, i) {
            return (t = function(e) {
                var _$t = function(e, t) {
                    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $22yUM._)(e)) || null === e) return e;
                    var _$i = e[Symbol.toPrimitive];
                    if (void 0 !== _$i) {
                        var s = _$i.call(e, "string");
                        if ("object" != (typeof s === "undefined" ? "undefined" : (0, $22yUM._)(s))) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $22yUM._)(_$t)) ? _$t : String(_$t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        var _obj;
        var M = (_obj = {}, (0, $9HFeY._)(_obj, i.days, '<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -'.concat(i.days, '-"></div>')), (0, $9HFeY._)(_obj, i.months, '<div class="air-datepicker-body--cells -'.concat(i.months, '-"></div>')), (0, $9HFeY._)(_obj, i.years, '<div class="air-datepicker-body--cells -'.concat(i.years, '-"></div>')), _obj);
        var S = ".air-datepicker-cell";
        var T = /*#__PURE__*/ function() {
            function T(e) {
                var _this = this;
                (0, $eCXNS._)(this, T);
                var t = e.dp, s = e.type, a = e.opts;
                _(this, "handleClick", function(e) {
                    var t = e.target.closest(S).adpCell;
                    if (t.isDisabled) return;
                    if (!_this.dp.isMinViewReached) return void _this.dp.down();
                    var i = _this.dp._checkIfDateIsSelected(t.date, t.type);
                    i ? _this.dp._handleAlreadySelectedDates(i, t.date) : _this.dp.selectDate(t.date);
                }), _(this, "handleDayNameClick", function(e) {
                    var t = e.target.getAttribute("data-day-index");
                    _this.opts.onClickDayName({
                        dayIndex: Number(t),
                        datepicker: _this.dp
                    });
                }), _(this, "onChangeCurrentView", function(e) {
                    e !== _this.type ? _this.hide() : (_this.show(), _this.render());
                }), _(this, "onMouseOverCell", function(e) {
                    var t = y(e.target, S);
                    _this.dp.setFocusDate(!!t && t.adpCell.date);
                }), _(this, "onMouseOutCell", function() {
                    _this.dp.setFocusDate(!1);
                }), _(this, "onClickBody", function(e) {
                    var _this_opts = _this.opts, t = _this_opts.onClickDayName, i = e.target;
                    i.closest(S) && _this.handleClick(e), t && i.closest(".air-datepicker-body--day-name") && _this.handleDayNameClick(e);
                }), _(this, "onMouseDown", function(e) {
                    _this.pressed = !0;
                    var t = y(e.target, S), i = t && t.adpCell;
                    p(i.date, _this.dp.rangeDateFrom) && (_this.rangeFromFocused = !0), p(i.date, _this.dp.rangeDateTo) && (_this.rangeToFocused = !0);
                }), _(this, "onMouseMove", function(e) {
                    if (!_this.pressed || !_this.dp.isMinViewReached) return;
                    e.preventDefault();
                    var t = y(e.target, S), i = t && t.adpCell, _this_dp = _this.dp, s = _this_dp.selectedDates, a = _this_dp.rangeDateTo, n = _this_dp.rangeDateFrom;
                    if (!i || i.isDisabled) return;
                    var r = i.date;
                    if (2 === s.length) {
                        if (_this.rangeFromFocused && !m(r, a)) {
                            var _h = h(n), _$e = _h.hours, t1 = _h.minutes;
                            r.setHours(_$e), r.setMinutes(t1), _this.dp.rangeDateFrom = r, _this.dp.replaceDate(n, r);
                        }
                        if (_this.rangeToFocused && !v(r, n)) {
                            var _h1 = h(a), _$e1 = _h1.hours, t2 = _h1.minutes;
                            r.setHours(_$e1), r.setMinutes(t2), _this.dp.rangeDateTo = r, _this.dp.replaceDate(a, r);
                        }
                    }
                }), _(this, "onMouseUp", function() {
                    _this.pressed = !1, _this.rangeFromFocused = !1, _this.rangeToFocused = !1;
                }), _(this, "onChangeViewDate", function(e, t) {
                    if (!_this.isVisible) return;
                    var s = c(e), a = c(t);
                    switch(_this.dp.currentView){
                        case i.days:
                            if (p(e, t, i.months)) return;
                            break;
                        case i.months:
                            if (p(e, t, i.years)) return;
                            break;
                        case i.years:
                            if (s[0] === a[0] && s[1] === a[1]) return;
                    }
                    _this.render();
                }), _(this, "render", function() {
                    _this.destroyCells(), _this._generateCells(), _this.cells.forEach(function(e) {
                        _this.$cells.appendChild(e.render());
                    });
                }), this.dp = t, this.type = s, this.opts = a, this.cells = [], this.$el = "", this.pressed = !1, this.isVisible = !0, this.init();
            }
            (0, $7M9bt._)(T, [
                {
                    key: "init",
                    value: function init() {
                        this._buildBaseHtml(), this.type === i.days && this.renderDayNames(), this.render(), this._bindEvents(), this._bindDatepickerEvents();
                    }
                },
                {
                    key: "_bindEvents",
                    value: function _bindEvents() {
                        var _this_opts = this.opts, e = _this_opts.range, t = _this_opts.dynamicRange;
                        D(this.$el, "mouseover", this.onMouseOverCell), D(this.$el, "mouseout", this.onMouseOutCell), D(this.$el, "click", this.onClickBody), e && t && (D(this.$el, "mousedown", this.onMouseDown), D(this.$el, "mousemove", this.onMouseMove), D(window.document, "mouseup", this.onMouseUp));
                    }
                },
                {
                    key: "_bindDatepickerEvents",
                    value: function _bindDatepickerEvents() {
                        this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView);
                    }
                },
                {
                    key: "_buildBaseHtml",
                    value: function _buildBaseHtml() {
                        this.$el = n({
                            className: "air-datepicker-body -".concat(this.type, "-"),
                            innerHtml: M[this.type]
                        }), this.$names = a(".air-datepicker-body--day-names", this.$el), this.$cells = a(".air-datepicker-body--cells", this.$el);
                    }
                },
                {
                    key: "_getDayNamesHtml",
                    value: function _getDayNamesHtml() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.dp.locale.firstDay, t = "", s = this.dp.isWeekend, _this_opts = this.opts, a = _this_opts.onClickDayName, n = e, r = 0;
                        for(; r < 7;){
                            var e1 = n % 7;
                            var _obj;
                            t += '<div class="'.concat(u("air-datepicker-body--day-name", (_obj = {}, (0, $9HFeY._)(_obj, i.cssClassWeekend, s(e1)), (0, $9HFeY._)(_obj, "-clickable-", !!a), _obj)), "\" data-day-index='").concat(e1, "'>").concat(this.dp.locale.daysMin[e1], "</div>"), r++, n++;
                        }
                        return t;
                    }
                },
                {
                    key: "renderDayNames",
                    value: function renderDayNames() {
                        this.$names.innerHTML = this._getDayNamesHtml();
                    }
                },
                {
                    key: "_generateCell",
                    value: function _generateCell(e) {
                        var _this = this, t = _this.type, i = _this.dp, s = _this.opts;
                        return new C({
                            type: t,
                            dp: i,
                            opts: s,
                            date: e,
                            body: this
                        });
                    }
                },
                {
                    key: "_generateCells",
                    value: function _generateCells() {
                        var _this = this;
                        T.getDatesFunction(this.type)(this.dp, function(e) {
                            _this.cells.push(_this._generateCell(e));
                        });
                    }
                },
                {
                    key: "show",
                    value: function show() {
                        this.isVisible = !0, this.$el.classList.remove("-hidden-");
                    }
                },
                {
                    key: "hide",
                    value: function hide() {
                        this.isVisible = !1, this.$el.classList.add("-hidden-");
                    }
                },
                {
                    key: "destroyCells",
                    value: function destroyCells() {
                        this.cells.forEach(function(e) {
                            return e.destroy();
                        }), this.cells = [], this.$cells.innerHTML = "";
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.destroyCells(), this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView);
                    }
                }
            ], [
                {
                    key: "getDaysDates",
                    value: function getDaysDates(e, t) {
                        var i = e.viewDate, _e_opts = e.opts, s = _e_opts.fixedHeight, _e_locale = e.locale, a = _e_locale.firstDay, n = o(i), _h = h(i), r = _h.year, l = _h.month, d = new Date(r, l, 1), c = new Date(r, l, n), u = d.getDay() - a, p = 6 - c.getDay() + a;
                        u = u < 0 ? u + 7 : u, p = p > 6 ? p - 7 : p;
                        var m = function(e, t) {
                            var _h = h(e), i = _h.year, s = _h.month, a = _h.date;
                            return new Date(i, s, a - t);
                        }(d, u), v = n + u + p, g = m.getDate(), _h1 = h(m), D = _h1.year, y = _h1.month, f = 0;
                        s && (v = 42);
                        var w = [];
                        for(; f < v;){
                            var _$e = new Date(D, y, g + f);
                            t && t(_$e), w.push(_$e), f++;
                        }
                        return w;
                    }
                },
                {
                    key: "getMonthsDates",
                    value: function getMonthsDates(e, t) {
                        var _e_parsedViewDate = e.parsedViewDate, i = _e_parsedViewDate.year, s = 0, a = [];
                        for(; s < 12;){
                            var _$e = new Date(i, s);
                            a.push(_$e), t && t(_$e), s++;
                        }
                        return a;
                    }
                },
                {
                    key: "getYearsDates",
                    value: function getYearsDates(e, t) {
                        var i = c(e.viewDate), s = i[0] - 1, a = i[1] + 1, n = s, r = [];
                        for(; n <= a;){
                            var _$e = new Date(n, 0);
                            r.push(_$e), t && t(_$e), n++;
                        }
                        return r;
                    }
                },
                {
                    key: "getDatesFunction",
                    value: function getDatesFunction() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                        var _obj;
                        return (_obj = {}, (0, $9HFeY._)(_obj, i.days, T.getDaysDates), (0, $9HFeY._)(_obj, i.months, T.getMonthsDates), (0, $9HFeY._)(_obj, i.years, T.getYearsDates), _obj)[e];
                    }
                }
            ]);
            return T;
        }();
        function F(e, t, i) {
            return (t = function(e) {
                var _$t = function(e, t) {
                    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $22yUM._)(e)) || null === e) return e;
                    var _$i = e[Symbol.toPrimitive];
                    if (void 0 !== _$i) {
                        var s = _$i.call(e, "string");
                        if ("object" != (typeof s === "undefined" ? "undefined" : (0, $22yUM._)(s))) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $22yUM._)(_$t)) ? _$t : String(_$t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        var V = /*#__PURE__*/ function() {
            function V(e) {
                var _this = this;
                (0, $eCXNS._)(this, V);
                var t = e.dp, i = e.opts;
                F(this, "onClickNav", function(e) {
                    var t = y(e.target, ".air-datepicker-nav--action");
                    if (!t) return;
                    var i = t.dataset.action;
                    _this.dp[i]();
                }), F(this, "onChangeViewDate", function() {
                    _this.render(), _this._resetNavStatus(), _this.handleNavStatus();
                }), F(this, "onChangeCurrentView", function() {
                    _this.render(), _this._resetNavStatus(), _this.handleNavStatus();
                }), F(this, "onClickNavTitle", function() {
                    _this.dp.isFinalView || _this.dp.up();
                }), F(this, "update", function() {
                    var _this_opts = _this.opts, _$e = _this_opts.prevHtml, t = _this_opts.nextHtml;
                    _this.$prev.innerHTML = _$e, _this.$next.innerHTML = t, _this._resetNavStatus(), _this.render(), _this.handleNavStatus();
                }), F(this, "renderDelay", function() {
                    setTimeout(_this.render);
                }), F(this, "render", function() {
                    _this.$title.innerHTML = _this._getTitle(), function(e, t) {
                        for(var i in t)t[i] ? e.classList.add(i) : e.classList.remove(i);
                    }(_this.$title, {
                        "-disabled-": _this.dp.isFinalView
                    });
                }), this.dp = t, this.opts = i, this.init();
            }
            (0, $7M9bt._)(V, [
                {
                    key: "init",
                    value: function init() {
                        this._createElement(), this._buildBaseHtml(), this._defineDOM(), this.render(), this.handleNavStatus(), this._bindEvents(), this._bindDatepickerEvents();
                    }
                },
                {
                    key: "_defineDOM",
                    value: function _defineDOM() {
                        this.$title = a(".air-datepicker-nav--title", this.$el), this.$prev = a('[data-action="prev"]', this.$el), this.$next = a('[data-action="next"]', this.$el);
                    }
                },
                {
                    key: "_bindEvents",
                    value: function _bindEvents() {
                        this.$el.addEventListener("click", this.onClickNav), this.$title.addEventListener("click", this.onClickNavTitle);
                    }
                },
                {
                    key: "_bindDatepickerEvents",
                    value: function _bindDatepickerEvents() {
                        this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.on(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.on(i.eventChangeTime, this.render));
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.off(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.off(i.eventChangeTime, this.render));
                    }
                },
                {
                    key: "_createElement",
                    value: function _createElement() {
                        this.$el = n({
                            tagName: "nav",
                            className: "air-datepicker-nav"
                        });
                    }
                },
                {
                    key: "_getTitle",
                    value: function _getTitle() {
                        var _this = this, e = _this.dp, t = _this.opts, i = t.navTitles[e.currentView];
                        return "function" == typeof i ? i(e) : e.formatDate(e.viewDate, i);
                    }
                },
                {
                    key: "handleNavStatus",
                    value: function handleNavStatus() {
                        var _this_opts = this.opts, e = _this_opts.disableNavWhenOutOfRange, _this_dp = this.dp, t = _this_dp.minDate, s = _this_dp.maxDate;
                        if (!t && !s || !e) return;
                        var _this_dp_parsedViewDate = this.dp.parsedViewDate, a = _this_dp_parsedViewDate.year, n = _this_dp_parsedViewDate.month, r = !!t && h(t), o = !!s && h(s);
                        switch(this.dp.currentView){
                            case i.days:
                                t && r.month >= n && r.year >= a && this._disableNav("prev"), s && o.month <= n && o.year <= a && this._disableNav("next");
                                break;
                            case i.months:
                                t && r.year >= a && this._disableNav("prev"), s && o.year <= a && this._disableNav("next");
                                break;
                            case i.years:
                                {
                                    var e1 = c(this.dp.viewDate);
                                    t && r.year >= e1[0] && this._disableNav("prev"), s && o.year <= e1[1] && this._disableNav("next");
                                    break;
                                }
                        }
                    }
                },
                {
                    key: "_disableNav",
                    value: function _disableNav(e) {
                        a('[data-action="' + e + '"]', this.$el).classList.add("-disabled-");
                    }
                },
                {
                    key: "_resetNavStatus",
                    value: function _resetNavStatus() {
                        !function(e) {
                            var _e_classList;
                            for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
                            e.length ? e.forEach(function(e) {
                                var _e_classList;
                                (_e_classList = e.classList).remove.apply(_e_classList, (0, $2b6Uo._)(i));
                            }) : (_e_classList = e.classList).remove.apply(_e_classList, (0, $2b6Uo._)(i));
                        }(this.$el.querySelectorAll(".air-datepicker-nav--action"), "-disabled-");
                    }
                },
                {
                    key: "_buildBaseHtml",
                    value: function _buildBaseHtml() {
                        var _this_opts = this.opts, e = _this_opts.prevHtml, t = _this_opts.nextHtml;
                        this.$el.innerHTML = '<div class="air-datepicker-nav--action" data-action="prev">'.concat(e, '</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">').concat(t, "</div>");
                    }
                },
                {
                    key: "isNavIsFunction",
                    get: function get() {
                        var _this_opts = this.opts, e = _this_opts.navTitles;
                        return Object.keys(e).find(function(t) {
                            return "function" == typeof e[t];
                        });
                    }
                }
            ]);
            return V;
        }();
        var x = {
            today: {
                content: function(e) {
                    return e.locale.today;
                },
                onClick: function(e) {
                    return e.setViewDate(new Date);
                }
            },
            clear: {
                content: function(e) {
                    return e.locale.clear;
                },
                onClick: function(e) {
                    return e.clear();
                }
            }
        };
        var H = /*#__PURE__*/ function() {
            function H(e) {
                (0, $eCXNS._)(this, H);
                var t = e.dp, i = e.opts;
                this.dp = t, this.opts = i, this.init();
            }
            (0, $7M9bt._)(H, [
                {
                    key: "init",
                    value: function init() {
                        this.createElement(), this.render();
                    }
                },
                {
                    key: "createElement",
                    value: function createElement() {
                        this.$el = n({
                            className: "air-datepicker-buttons"
                        });
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.$el.parentNode.removeChild(this.$el);
                    }
                },
                {
                    key: "clearHtml",
                    value: function clearHtml() {
                        return this.$el.innerHTML = "", this;
                    }
                },
                {
                    key: "generateButtons",
                    value: function generateButtons() {
                        var _this = this;
                        var _this_opts = this.opts, e = _this_opts.buttons;
                        Array.isArray(e) || (e = [
                            e
                        ]), e.forEach(function(e) {
                            var t = e;
                            "string" == typeof e && x[e] && (t = x[e]);
                            var i = _this.createButton(t);
                            t.onClick && _this.attachEventToButton(i, t.onClick), _this.$el.appendChild(i);
                        });
                    }
                },
                {
                    key: "attachEventToButton",
                    value: function attachEventToButton(e, t) {
                        var _this = this;
                        e.addEventListener("click", function() {
                            t(_this.dp);
                        });
                    }
                },
                {
                    key: "createButton",
                    value: function createButton(e) {
                        var t = e.content, i = e.className, tmp = e.tagName, s = tmp === void 0 ? "button" : tmp, tmp1 = e.attrs, a = tmp1 === void 0 ? {} : tmp1;
                        return n({
                            tagName: s,
                            innerHtml: "<span tabindex='-1'>".concat("function" == typeof t ? t(this.dp) : t, "</span>"),
                            className: u("air-datepicker-button", i),
                            attrs: a
                        });
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        this.generateButtons();
                    }
                }
            ]);
            return H;
        }();
        function E(e, t, i) {
            return (t = function(e) {
                var _$t = function(e, t) {
                    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $22yUM._)(e)) || null === e) return e;
                    var _$i = e[Symbol.toPrimitive];
                    if (void 0 !== _$i) {
                        var s = _$i.call(e, "string");
                        if ("object" != (typeof s === "undefined" ? "undefined" : (0, $22yUM._)(s))) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $22yUM._)(_$t)) ? _$t : String(_$t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        var L = /*#__PURE__*/ function() {
            function L() {
                var _this = this;
                (0, $eCXNS._)(this, L);
                var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = _ref.opts, t = _ref.dp;
                E(this, "toggleTimepickerIsActive", function(e) {
                    _this.dp.timepickerIsActive = e;
                }), E(this, "onChangeSelectedDate", function(e) {
                    var t = e.date, tmp = e.updateTime, i = tmp === void 0 ? !1 : tmp;
                    t && (_this.setMinMaxTime(t), _this.setCurrentTime(!!i && t), _this.addTimeToDate(t));
                }), E(this, "onChangeLastSelectedDate", function(e) {
                    e && (_this.setTime(e), _this.render());
                }), E(this, "onChangeInputRange", function(e) {
                    var t = e.target;
                    _this[t.getAttribute("name")] = t.value, _this.updateText(), _this.dp.trigger(i.eventChangeTime, {
                        hours: _this.hours,
                        minutes: _this.minutes
                    });
                }), E(this, "onMouseEnterLeave", function(e) {
                    var t = e.target.getAttribute("name"), i = _this.$minutesText;
                    "hours" === t && (i = _this.$hoursText), i.classList.toggle("-focus-");
                }), E(this, "onFocus", function() {
                    _this.toggleTimepickerIsActive(!0);
                }), E(this, "onBlur", function() {
                    _this.toggleTimepickerIsActive(!1);
                }), this.opts = e, this.dp = t;
                var _this_dp_locale = this.dp.locale, s = _this_dp_locale.timeFormat;
                s && (s.match(k("h")) || s.match(k("hh"))) && (this.ampm = !0), this.init();
            }
            (0, $7M9bt._)(L, [
                {
                    key: "init",
                    value: function init() {
                        this.setTime(this.dp.lastSelectedDate || this.dp.viewDate), this.createElement(), this.buildHtml(), this.defineDOM(), this.render(), this.bindDatepickerEvents(), this.bindDOMEvents();
                    }
                },
                {
                    key: "bindDatepickerEvents",
                    value: function bindDatepickerEvents() {
                        this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
                    }
                },
                {
                    key: "bindDOMEvents",
                    value: function bindDOMEvents() {
                        var e = "input";
                        navigator.userAgent.match(/trident/gi) && (e = "change"), D(this.$ranges, e, this.onChangeInputRange), D(this.$ranges, "mouseenter", this.onMouseEnterLeave), D(this.$ranges, "mouseleave", this.onMouseEnterLeave), D(this.$ranges, "focus", this.onFocus), D(this.$ranges, "mousedown", this.onFocus), D(this.$ranges, "blur", this.onBlur);
                    }
                },
                {
                    key: "createElement",
                    value: function createElement() {
                        this.$el = n({
                            className: u("air-datepicker-time", {
                                "-am-pm-": this.dp.ampm
                            })
                        });
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate), this.$el.parentNode.removeChild(this.$el);
                    }
                },
                {
                    key: "buildHtml",
                    value: function buildHtml() {
                        var _this = this, e = _this.ampm, t = _this.hours, i = _this.displayHours, s = _this.minutes, a = _this.minHours, n = _this.minMinutes, r = _this.maxHours, o = _this.maxMinutes, h = _this.dayPeriod, _this_opts = _this.opts, l = _this_opts.hoursStep, c = _this_opts.minutesStep;
                        this.$el.innerHTML = '<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">'.concat(d(i), '</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">').concat(d(s), "</span>   ") + (e ? "<span class='air-datepicker-time--current-ampm'>".concat(h, "</span>") : "") + '</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">' + '      <input type="range" name="hours" value="'.concat(t, '" min="').concat(a, '" max="').concat(r, '" step="').concat(l, '"/>   </div>   <div class="air-datepicker-time--row">') + '      <input type="range" name="minutes" value="'.concat(s, '" min="').concat(n, '" max="').concat(o, '" step="').concat(c, '"/>   </div></div>');
                    }
                },
                {
                    key: "defineDOM",
                    value: function defineDOM() {
                        var _this = this;
                        var e = function(e) {
                            return a(e, _this.$el);
                        };
                        this.$ranges = this.$el.querySelectorAll('[type="range"]'), this.$hours = e('[name="hours"]'), this.$minutes = e('[name="minutes"]'), this.$hoursText = e(".air-datepicker-time--current-hours"), this.$minutesText = e(".air-datepicker-time--current-minutes"), this.$ampm = e(".air-datepicker-time--current-ampm");
                    }
                },
                {
                    key: "setTime",
                    value: function setTime(e) {
                        this.setMinMaxTime(e), this.setCurrentTime(e);
                    }
                },
                {
                    key: "addTimeToDate",
                    value: function addTimeToDate(e) {
                        e && (e.setHours(this.hours), e.setMinutes(this.minutes));
                    }
                },
                {
                    key: "setMinMaxTime",
                    value: function setMinMaxTime(e) {
                        if (this.setMinMaxTimeFromOptions(), e) {
                            var _this_dp = this.dp, t = _this_dp.minDate, i = _this_dp.maxDate;
                            t && p(e, t) && this.setMinTimeFromMinDate(t), i && p(e, i) && this.setMaxTimeFromMaxDate(i);
                        }
                    }
                },
                {
                    key: "setCurrentTime",
                    value: function setCurrentTime(e) {
                        var _ref = e ? h(e) : this, t = _ref.hours, i = _ref.minutes;
                        this.hours = f(t, this.minHours, this.maxHours), this.minutes = f(i, this.minMinutes, this.maxMinutes);
                    }
                },
                {
                    key: "setMinMaxTimeFromOptions",
                    value: function setMinMaxTimeFromOptions() {
                        var _this_opts = this.opts, e = _this_opts.minHours, t = _this_opts.minMinutes, i = _this_opts.maxHours, s = _this_opts.maxMinutes;
                        this.minHours = f(e, 0, 23), this.minMinutes = f(t, 0, 59), this.maxHours = f(i, 0, 23), this.maxMinutes = f(s, 0, 59);
                    }
                },
                {
                    key: "setMinTimeFromMinDate",
                    value: function setMinTimeFromMinDate(e) {
                        var _this_dp = this.dp, t = _this_dp.lastSelectedDate;
                        this.minHours = e.getHours(), t && t.getHours() > e.getHours() ? this.minMinutes = this.opts.minMinutes : this.minMinutes = e.getMinutes();
                    }
                },
                {
                    key: "setMaxTimeFromMaxDate",
                    value: function setMaxTimeFromMaxDate(e) {
                        var _this_dp = this.dp, t = _this_dp.lastSelectedDate;
                        this.maxHours = e.getHours(), t && t.getHours() < e.getHours() ? this.maxMinutes = this.opts.maxMinutes : this.maxMinutes = e.getMinutes();
                    }
                },
                {
                    key: "updateSliders",
                    value: function updateSliders() {
                        r(this.$hours, {
                            min: this.minHours,
                            max: this.maxHours
                        }).value = this.hours, r(this.$minutes, {
                            min: this.minMinutes,
                            max: this.maxMinutes
                        }).value = this.minutes;
                    }
                },
                {
                    key: "updateText",
                    value: function updateText() {
                        this.$hoursText.innerHTML = d(this.displayHours), this.$minutesText.innerHTML = d(this.minutes), this.ampm && (this.$ampm.innerHTML = this.dayPeriod);
                    }
                },
                {
                    key: "hours",
                    get: function get() {
                        return this._hours;
                    },
                    set: function set(e) {
                        this._hours = e;
                        var _l = l(e), t = _l.hours, i = _l.dayPeriod;
                        this.displayHours = this.ampm ? t : e, this.dayPeriod = i;
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        this.updateSliders(), this.updateText();
                    }
                }
            ]);
            return L;
        }();
        function O(e, t, i) {
            return (t = function(e) {
                var _$t = function(e, t) {
                    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $22yUM._)(e)) || null === e) return e;
                    var _$i = e[Symbol.toPrimitive];
                    if (void 0 !== _$i) {
                        var s = _$i.call(e, "string");
                        if ("object" != (typeof s === "undefined" ? "undefined" : (0, $22yUM._)(s))) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $22yUM._)(_$t)) ? _$t : String(_$t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        var A = /*#__PURE__*/ function() {
            function A(e) {
                var _this = this;
                (0, $eCXNS._)(this, A);
                var t = e.dp, i = e.opts;
                O(this, "pressedKeys", new Set), O(this, "hotKeys", new Map([
                    [
                        [
                            [
                                "Control",
                                "ArrowRight"
                            ],
                            [
                                "Control",
                                "ArrowUp"
                            ]
                        ],
                        function(e) {
                            return e.month++;
                        }
                    ],
                    [
                        [
                            [
                                "Control",
                                "ArrowLeft"
                            ],
                            [
                                "Control",
                                "ArrowDown"
                            ]
                        ],
                        function(e) {
                            return e.month--;
                        }
                    ],
                    [
                        [
                            [
                                "Shift",
                                "ArrowRight"
                            ],
                            [
                                "Shift",
                                "ArrowUp"
                            ]
                        ],
                        function(e) {
                            return e.year++;
                        }
                    ],
                    [
                        [
                            [
                                "Shift",
                                "ArrowLeft"
                            ],
                            [
                                "Shift",
                                "ArrowDown"
                            ]
                        ],
                        function(e) {
                            return e.year--;
                        }
                    ],
                    [
                        [
                            [
                                "Alt",
                                "ArrowRight"
                            ],
                            [
                                "Alt",
                                "ArrowUp"
                            ]
                        ],
                        function(e) {
                            return e.year += 10;
                        }
                    ],
                    [
                        [
                            [
                                "Alt",
                                "ArrowLeft"
                            ],
                            [
                                "Alt",
                                "ArrowDown"
                            ]
                        ],
                        function(e) {
                            return e.year -= 10;
                        }
                    ],
                    [
                        [
                            "Control",
                            "Shift",
                            "ArrowUp"
                        ],
                        function(e, t) {
                            return t.up();
                        }
                    ]
                ])), O(this, "handleHotKey", function(e) {
                    var t = _this.hotKeys.get(e), i = h(_this.getInitialFocusDate());
                    t(i, _this.dp);
                    var s = i.year, a = i.month, n = i.date, r = o(new Date(s, a));
                    r < n && (n = r);
                    var l = _this.dp.getClampedDate(new Date(s, a, n));
                    _this.dp.setFocusDate(l, {
                        viewDateTransition: !0
                    });
                }), O(this, "isHotKeyPressed", function() {
                    var _$e = !1, t = _this.pressedKeys.size, i = function(e) {
                        return _this.pressedKeys.has(e);
                    };
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var _step_value = (0, $iFZdg._)(_step.value, 1), s = _step_value[0];
                            if (_$e) return "break";
                            if (Array.isArray(s[0])) s.forEach(function(a) {
                                _$e || t !== a.length || (_$e = a.every(i) && s);
                            });
                            else {
                                if (t !== s.length) return "continue";
                                _$e = s.every(i) && s;
                            }
                        };
                        for(var _iterator = _this.hotKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _ret = _loop();
                            if (_ret === "break") break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$e;
                }), O(this, "isArrow", function(e) {
                    return e >= 37 && e <= 40;
                }), O(this, "onKeyDown", function(e) {
                    var t = e.key, i = e.which, s = _this.dp, _this_dp = _this.dp, a = _this_dp.focusDate, n = _this.opts;
                    _this.registerKey(t);
                    var r = _this.isHotKeyPressed();
                    if (r) return e.preventDefault(), void _this.handleHotKey(r);
                    if (_this.isArrow(i)) return e.preventDefault(), void _this.focusNextCell(t);
                    if ("Enter" === t) {
                        if (s.currentView !== n.minView) return void s.down();
                        if (a) {
                            var _$e = s._checkIfDateIsSelected(a);
                            return void (_$e ? s._handleAlreadySelectedDates(_$e, a) : s.selectDate(a));
                        }
                    }
                    "Escape" === t && _this.dp.hide();
                }), O(this, "onKeyUp", function(e) {
                    _this.removeKey(e.key);
                }), this.dp = t, this.opts = i, this.init();
            }
            (0, $7M9bt._)(A, [
                {
                    key: "init",
                    value: function init() {
                        this.bindKeyboardEvents();
                    }
                },
                {
                    key: "bindKeyboardEvents",
                    value: function bindKeyboardEvents() {
                        var _this_dp = this.dp, e = _this_dp.$el;
                        e.addEventListener("keydown", this.onKeyDown), e.addEventListener("keyup", this.onKeyUp);
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        var _this_dp = this.dp, e = _this_dp.$el;
                        e.removeEventListener("keydown", this.onKeyDown), e.removeEventListener("keyup", this.onKeyUp), this.hotKeys = null, this.pressedKeys = null;
                    }
                },
                {
                    key: "getInitialFocusDate",
                    value: function getInitialFocusDate() {
                        var _this_dp = this.dp, e = _this_dp.focusDate, t = _this_dp.currentView, s = _this_dp.selectedDates, _this_dp_parsedViewDate = _this_dp.parsedViewDate, a = _this_dp_parsedViewDate.year, n = _this_dp_parsedViewDate.month, r = e || s[s.length - 1];
                        if (!r) switch(t){
                            case i.days:
                                r = new Date(a, n, (new Date).getDate());
                                break;
                            case i.months:
                                r = new Date(a, n, 1);
                                break;
                            case i.years:
                                r = new Date(a, 0, 1);
                        }
                        return r;
                    }
                },
                {
                    key: "focusNextCell",
                    value: function focusNextCell(e) {
                        var t = this.getInitialFocusDate(), _this_dp = this.dp, s = _this_dp.currentView, a = i.days, n = i.months, r = i.years, o = h(t), l = o.year, d = o.month, c = o.date;
                        switch(e){
                            case "ArrowLeft":
                                s === a && (c -= 1), s === n && (d -= 1), s === r && (l -= 1);
                                break;
                            case "ArrowUp":
                                s === a && (c -= 7), s === n && (d -= 3), s === r && (l -= 4);
                                break;
                            case "ArrowRight":
                                s === a && (c += 1), s === n && (d += 1), s === r && (l += 1);
                                break;
                            case "ArrowDown":
                                s === a && (c += 7), s === n && (d += 3), s === r && (l += 4);
                        }
                        var u = this.dp.getClampedDate(new Date(l, d, c));
                        this.dp.setFocusDate(u, {
                            viewDateTransition: !0
                        });
                    }
                },
                {
                    key: "registerKey",
                    value: function registerKey(e) {
                        this.pressedKeys.add(e);
                    }
                },
                {
                    key: "removeKey",
                    value: function removeKey(e) {
                        this.pressedKeys.delete(e);
                    }
                }
            ]);
            return A;
        }();
        var N = {
            on: function(e, t) {
                this.__events || (this.__events = {}), this.__events[e] ? this.__events[e].push(t) : this.__events[e] = [
                    t
                ];
            },
            off: function(e, t) {
                this.__events && this.__events[e] && (this.__events[e] = this.__events[e].filter(function(e) {
                    return e !== t;
                }));
            },
            removeAllEvents: function() {
                this.__events = {};
            },
            trigger: function(e) {
                for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
                this.__events && this.__events[e] && this.__events[e].forEach(function(e) {
                    e.apply(void 0, (0, $2b6Uo._)(i));
                });
            }
        };
        function I(e, t, i) {
            return (t = function(e) {
                var _$t = function(e, t) {
                    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $22yUM._)(e)) || null === e) return e;
                    var _$i = e[Symbol.toPrimitive];
                    if (void 0 !== _$i) {
                        var s = _$i.call(e, "string");
                        if ("object" != (typeof s === "undefined" ? "undefined" : (0, $22yUM._)(s))) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $22yUM._)(_$t)) ? _$t : String(_$t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        var P = "", j = "", B = !1;
        var R = /*#__PURE__*/ function() {
            function R(e, t) {
                var _this = this;
                (0, $eCXNS._)(this, R);
                var r = this;
                if (I(this, "viewIndexes", [
                    i.days,
                    i.months,
                    i.years
                ]), I(this, "next", function() {
                    var _this_parsedViewDate = _this.parsedViewDate, _$e = _this_parsedViewDate.year, _$t = _this_parsedViewDate.month;
                    switch(_this.currentView){
                        case i.days:
                            _this.setViewDate(new Date(_$e, _$t + 1, 1));
                            break;
                        case i.months:
                            _this.setViewDate(new Date(_$e + 1, _$t, 1));
                            break;
                        case i.years:
                            _this.setViewDate(new Date(_$e + 10, 0, 1));
                    }
                }), I(this, "prev", function() {
                    var _this_parsedViewDate = _this.parsedViewDate, _$e = _this_parsedViewDate.year, _$t = _this_parsedViewDate.month;
                    switch(_this.currentView){
                        case i.days:
                            _this.setViewDate(new Date(_$e, _$t - 1, 1));
                            break;
                        case i.months:
                            _this.setViewDate(new Date(_$e - 1, _$t, 1));
                            break;
                        case i.years:
                            _this.setViewDate(new Date(_$e - 10, 0, 1));
                    }
                }), I(this, "_finishHide", function() {
                    _this.hideAnimation = !1, _this._destroyComponents(), _this.$container.removeChild(_this.$datepicker);
                }), I(this, "setPosition", function(e) {
                    var _$t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if ("function" == typeof (e = e || r.opts.position)) return void (r.customHide = e({
                        $datepicker: r.$datepicker,
                        $target: r.$el,
                        $pointer: r.$pointer,
                        isViewChange: _$t,
                        done: r._finishHide
                    }));
                    var i, s, _r_opts = r.opts, _$a = _r_opts.isMobile, _$n = r.$el.getBoundingClientRect(), o = r.$el.getBoundingClientRect(), h = r.$datepicker.offsetParent, l = r.$el.offsetParent, d = r.$datepicker.getBoundingClientRect(), c = e.split(" "), u = window.scrollY, p = window.scrollX, m = r.opts.offset, v = c[0], g = c[1];
                    if (_$a) r.$datepicker.style.cssText = "left: 50%; top: 50%";
                    else {
                        if (h === l && h !== document.body && (o = {
                            top: r.$el.offsetTop,
                            left: r.$el.offsetLeft,
                            width: _$n.width,
                            height: r.$el.offsetHeight
                        }, u = 0, p = 0), h !== l && h !== document.body) {
                            var _$e = h.getBoundingClientRect();
                            o = {
                                top: _$n.top - _$e.top,
                                left: _$n.left - _$e.left,
                                width: _$n.width,
                                height: _$n.height
                            }, u = 0, p = 0;
                        }
                        switch(v){
                            case "top":
                                i = o.top - d.height - m;
                                break;
                            case "right":
                                s = o.left + o.width + m;
                                break;
                            case "bottom":
                                i = o.top + o.height + m;
                                break;
                            case "left":
                                s = o.left - d.width - m;
                        }
                        switch(g){
                            case "top":
                                i = o.top;
                                break;
                            case "right":
                                s = o.left + o.width - d.width;
                                break;
                            case "bottom":
                                i = o.top + o.height - d.height;
                                break;
                            case "left":
                                s = o.left;
                                break;
                            case "center":
                                /left|right/.test(v) ? i = o.top + o.height / 2 - d.height / 2 : s = o.left + o.width / 2 - d.width / 2;
                        }
                        r.$datepicker.style.cssText = "left: ".concat(s + p, "px; top: ").concat(i + u, "px");
                    }
                }), I(this, "_setInputValue", function() {
                    var _$e = _this.opts, _$t = _this.$altField, _this_locale = _this.locale, i = _this_locale.dateFormat, s = _$e.altFieldDateFormat, _$a = _$e.altField;
                    _$a && _$t && (_$t.value = _this._getInputValue(s)), _this.$el.value = _this._getInputValue(i);
                }), I(this, "_getInputValue", function(e) {
                    var _$t = _this.selectedDates, i = _this.opts, s = i.multipleDates, _$a = i.multipleDatesSeparator;
                    if (!_$t.length) return "";
                    var _$n = "function" == typeof e, r = _$n ? e(s ? _$t : _$t[0]) : _$t.map(function(t) {
                        return _this.formatDate(t, e);
                    });
                    return r = _$n ? r : r.join(_$a), r;
                }), I(this, "_checkIfDateIsSelected", function(e) {
                    var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.days, s = !1;
                    return r.selectedDates.some(function(i) {
                        var _$a = p(e, i, _$t);
                        return s = _$a && i, _$a;
                    }), s;
                }), I(this, "_scheduleCallAfterTransition", function(e) {
                    _this._cancelScheduledCall(), e && e(!1), _this._onTransitionEnd = function() {
                        e && e(!0);
                    }, _this.$datepicker.addEventListener("transitionend", _this._onTransitionEnd, {
                        once: !0
                    });
                }), I(this, "_cancelScheduledCall", function() {
                    _this.$datepicker.removeEventListener("transitionend", _this._onTransitionEnd);
                }), I(this, "setViewDate", function(e) {
                    if (!((e = b(e)) instanceof Date)) return;
                    if (p(e, _this.viewDate)) return;
                    var _$t = _this.viewDate;
                    _this.viewDate = e;
                    var _this_opts = _this.opts, s = _this_opts.onChangeViewDate;
                    if (s) {
                        var _this_parsedViewDate = _this.parsedViewDate, _$e = _this_parsedViewDate.month, _$t1 = _this_parsedViewDate.year;
                        s({
                            month: _$e,
                            year: _$t1,
                            decade: _this.curDecade
                        });
                    }
                    _this.trigger(i.eventChangeViewDate, e, _$t);
                }), I(this, "setFocusDate", function(e) {
                    var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (!e || (e = b(e)) instanceof Date) && (r.focusDate = e, r.trigger(i.eventChangeFocusDate, e, _$t));
                }), I(this, "setCurrentView", function(e) {
                    var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (r.viewIndexes.includes(e)) {
                        if (r.currentView = e, r.elIsInput && r.visible && r.setPosition(void 0, !0), r.trigger(i.eventChangeCurrentView, e), !r.views[e]) {
                            var _$t1 = r.views[e] = new T({
                                dp: r,
                                opts: r.opts,
                                type: e
                            });
                            r.shouldUpdateDOM && r.$content.appendChild(_$t1.$el);
                        }
                        r.opts.onChangeView && !_$t.silent && r.opts.onChangeView(e);
                    }
                }), I(this, "_updateLastSelectedDate", function(e) {
                    _this.lastSelectedDate = e, _this.trigger(i.eventChangeLastSelectedDate, e);
                }), I(this, "destroy", function() {
                    if (_this.isDestroyed) return;
                    var _this_opts = _this.opts, _$e = _this_opts.showEvent, _$t = _this_opts.isMobile, i = _this.$datepicker.parentNode;
                    i && i.removeChild(_this.$datepicker), _this.$el.removeEventListener(_$e, _this._onFocus), _this.$el.removeEventListener("blur", _this._onBlur), window.removeEventListener("resize", _this._onResize), _$t && _this._removeMobileAttributes(), _this.keyboardNav && _this.keyboardNav.destroy(), _this.views = null, _this.nav = null, _this.$datepicker = null, _this.opts = {}, _this.$customContainer = null, _this.viewDate = null, _this.focusDate = null, _this.selectedDates = [], _this.rangeDateFrom = null, _this.rangeDateTo = null, _this.isDestroyed = !0;
                }), I(this, "update", function() {
                    var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, s = w({}, r.opts), _$a = _$t.silent;
                    w(r.opts, _$e);
                    var _r_opts = r.opts, _$n = _r_opts.timepicker, o = _r_opts.buttons, h = _r_opts.range, l = _r_opts.selectedDates, d = _r_opts.isMobile, c = r.visible || r.treatAsInline;
                    r._createMinMaxDates(), r._limitViewDateByMaxMinDates(), r._handleLocale(), l && (r.selectedDates = [], r.selectDate(l, {
                        silent: _$a
                    })), _$e.view && r.setCurrentView(_$e.view, {
                        silent: _$a
                    }), r._setInputValue(), s.range && !h ? (r.rangeDateTo = !1, r.rangeDateFrom = !1) : !s.range && h && r.selectedDates.length && (r.rangeDateFrom = r.selectedDates[0], r.rangeDateTo = r.selectedDates[1]), s.timepicker && !_$n ? (c && r.timepicker.destroy(), r.timepicker = !1, r.$timepicker.parentNode.removeChild(r.$timepicker)) : !s.timepicker && _$n && r._addTimepicker(), !s.buttons && o ? r._addButtons() : s.buttons && !o ? (r.buttons.destroy(), r.$buttons.parentNode.removeChild(r.$buttons)) : c && s.buttons && o && r.buttons.clearHtml().render(), !s.isMobile && d ? (r.treatAsInline || j || r._createMobileOverlay(), r._addMobileAttributes(), r.visible && r._showMobileOverlay()) : s.isMobile && !d && (r._removeMobileAttributes(), r.visible && (j.classList.remove("-active-"), "function" != typeof r.opts.position && r.setPosition())), c && (r.nav.update(), r.views[r.currentView].render(), r.currentView === i.days && r.views[r.currentView].renderDayNames());
                }), I(this, "disableDate", function(e, t) {
                    (Array.isArray(e) ? e : [
                        e
                    ]).forEach(function(e) {
                        var i = b(e);
                        if (!i) return;
                        var s = t ? "delete" : "add";
                        _this.disabledDates[s](_this.formatDate(i, "yyyy-MM-dd"));
                        var _$a = _this.getCell(i, _this.currentViewSingular);
                        _$a && _$a.adpCell.render();
                    }, []);
                }), I(this, "enableDate", function(e) {
                    _this.disableDate(e, !0);
                }), I(this, "isDateDisabled", function(e) {
                    var _$t = b(e);
                    return _this.disabledDates.has(_this.formatDate(_$t, "yyyy-MM-dd"));
                }), I(this, "isOtherMonth", function(e) {
                    var _h = h(e), _$t = _h.month;
                    return _$t !== _this.parsedViewDate.month;
                }), I(this, "isOtherYear", function(e) {
                    var _h = h(e), _$t = _h.year;
                    return _$t !== _this.parsedViewDate.year;
                }), I(this, "isOtherDecade", function(e) {
                    var _h = h(e), _$t = _h.year, _c = (0, $iFZdg._)(c(_this.viewDate), 2), i = _c[0], s = _c[1];
                    return _$t < i || _$t > s;
                }), I(this, "_onChangeSelectedDate", function(e) {
                    var _$t = e.silent;
                    setTimeout(function() {
                        _this._setInputValue(), _this.opts.onSelect && !_$t && _this._triggerOnSelect();
                    });
                }), I(this, "_onChangeFocusedDate", function(e) {
                    var _ref = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _$t = _ref.viewDateTransition;
                    if (!e) return;
                    var i = !1;
                    _$t && (i = r.isOtherMonth(e) || r.isOtherYear(e) || r.isOtherDecade(e)), i && r.setViewDate(e), r.opts.onFocus && r.opts.onFocus({
                        datepicker: r,
                        date: e
                    });
                }), I(this, "_onChangeTime", function(e) {
                    var _$t = e.hours, i = e.minutes, s = new Date, _$a = _this.lastSelectedDate, _this_opts = _this.opts, _$n = _this_opts.onSelect, r = _$a;
                    _$a || (r = s);
                    var o = _this.getCell(r, _this.currentViewSingular), h = o && o.adpCell;
                    h && h.isDisabled || (r.setHours(_$t), r.setMinutes(i), _$a ? (_this._setInputValue(), _$n && _this._triggerOnSelect()) : _this.selectDate(r));
                }), I(this, "_onFocus", function(e) {
                    _this.visible || _this.show();
                }), I(this, "_onBlur", function(e) {
                    _this.inFocus || !_this.visible || _this.opts.isMobile || _this.hide();
                }), I(this, "_onMouseDown", function(e) {
                    _this.inFocus = !0;
                }), I(this, "_onMouseUp", function(e) {
                    _this.inFocus = !1, _this.$el.focus();
                }), I(this, "_onResize", function() {
                    _this.visible && "function" != typeof _this.opts.position && _this.setPosition();
                }), I(this, "_onClickOverlay", function() {
                    _this.visible && _this.hide();
                }), I(this, "getViewDates", function() {
                    var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                    return T.getDatesFunction(_$e)(r);
                }), I(this, "isWeekend", function(e) {
                    return _this.opts.weekends.includes(e);
                }), I(this, "getClampedDate", function(e) {
                    var _$t = _this.minDate, i = _this.maxDate, s = e;
                    return i && m(e, i) ? s = i : _$t && v(e, _$t) && (s = _$t), s;
                }), this.$el = a(e), !this.$el) return;
                this.$datepicker = n({
                    className: "air-datepicker"
                }), this.opts = w({}, s, t), this.$customContainer = !!this.opts.container && a(this.opts.container), this.$altField = a(this.opts.altField || !1);
                var _this_opts = this.opts, o = _this_opts.view, l = _this_opts.startDate;
                l || (this.opts.startDate = new Date), "INPUT" === this.$el.nodeName && (this.elIsInput = !0), this.inited = !1, this.visible = !1, this.viewDate = b(this.opts.startDate), this.focusDate = !1, this.initialReadonly = this.$el.getAttribute("readonly"), this.customHide = !1, this.currentView = o, this.selectedDates = [], this.disabledDates = new Set, this.isDestroyed = !1, this.views = {}, this.keys = [], this.rangeDateFrom = "", this.rangeDateTo = "", this.timepickerIsActive = !1, this.treatAsInline = this.opts.inline || !this.elIsInput, this.init();
            }
            (0, $7M9bt._)(R, [
                {
                    key: "init",
                    value: function init() {
                        var _this = this, e = _this.opts, t = _this.treatAsInline, _this_opts = _this.opts, i = _this_opts.inline, s = _this_opts.isMobile, n = _this_opts.selectedDates, r = _this_opts.keyboardNav, o = _this_opts.onlyTimepicker, h = a("body");
                        (!B || B && P && !h.contains(P)) && !i && this.elIsInput && !this.$customContainer && R.buildGlobalContainer(R.defaultGlobalContainerId), !s || j || t || this._createMobileOverlay(), this._handleLocale(), this._bindSubEvents(), this._createMinMaxDates(), this._limitViewDateByMaxMinDates(), this.elIsInput && (i || this._bindEvents(), r && !o && (this.keyboardNav = new A({
                            dp: this,
                            opts: e
                        }))), n && this.selectDate(n, {
                            silent: !0
                        }), this.opts.visible && !t && this.show(), s && !t && this.$el.setAttribute("readonly", !0), t && this._createComponents();
                    }
                },
                {
                    key: "_createMobileOverlay",
                    value: function _createMobileOverlay() {
                        j = n({
                            className: "air-datepicker-overlay"
                        }), P.appendChild(j);
                    }
                },
                {
                    key: "_createComponents",
                    value: function _createComponents() {
                        var _this_$datepicker_classList;
                        var _this = this, e = _this.opts, t = _this.treatAsInline, _this_opts = _this.opts, i = _this_opts.inline, s = _this_opts.buttons, a = _this_opts.timepicker, n = _this_opts.position, r = _this_opts.classes, o = _this_opts.onlyTimepicker, h = _this_opts.isMobile;
                        this._buildBaseHtml(), this.elIsInput && (i || this._setPositionClasses(n)), !i && this.elIsInput || this.$datepicker.classList.add("-inline-"), r && (_this_$datepicker_classList = this.$datepicker.classList).add.apply(_this_$datepicker_classList, (0, $2b6Uo._)(r.split(" "))), o && this.$datepicker.classList.add("-only-timepicker-"), h && !t && this._addMobileAttributes(), this.views[this.currentView] = new T({
                            dp: this,
                            type: this.currentView,
                            opts: e
                        }), this.nav = new V({
                            dp: this,
                            opts: e
                        }), a && this._addTimepicker(), s && this._addButtons(), this.$content.appendChild(this.views[this.currentView].$el), this.$nav.appendChild(this.nav.$el);
                    }
                },
                {
                    key: "_destroyComponents",
                    value: function _destroyComponents() {
                        for(var e in this.views)this.views[e].destroy();
                        this.views = {}, this.nav.destroy(), this.timepicker && this.timepicker.destroy();
                    }
                },
                {
                    key: "_addMobileAttributes",
                    value: function _addMobileAttributes() {
                        j.addEventListener("click", this._onClickOverlay), this.$datepicker.classList.add("-is-mobile-"), this.$el.setAttribute("readonly", !0);
                    }
                },
                {
                    key: "_removeMobileAttributes",
                    value: function _removeMobileAttributes() {
                        j.removeEventListener("click", this._onClickOverlay), this.$datepicker.classList.remove("-is-mobile-"), this.initialReadonly || "" === this.initialReadonly || this.$el.removeAttribute("readonly");
                    }
                },
                {
                    key: "_createMinMaxDates",
                    value: function _createMinMaxDates() {
                        var _this_opts = this.opts, e = _this_opts.minDate, t = _this_opts.maxDate;
                        this.minDate = !!e && b(e), this.maxDate = !!t && b(t);
                    }
                },
                {
                    key: "_addTimepicker",
                    value: function _addTimepicker() {
                        this.$timepicker = n({
                            className: "air-datepicker--time"
                        }), this.$datepicker.appendChild(this.$timepicker), this.timepicker = new L({
                            dp: this,
                            opts: this.opts
                        }), this.$timepicker.appendChild(this.timepicker.$el);
                    }
                },
                {
                    key: "_addButtons",
                    value: function _addButtons() {
                        this.$buttons = n({
                            className: "air-datepicker--buttons"
                        }), this.$datepicker.appendChild(this.$buttons), this.buttons = new H({
                            dp: this,
                            opts: this.opts
                        }), this.$buttons.appendChild(this.buttons.$el);
                    }
                },
                {
                    key: "_bindSubEvents",
                    value: function _bindSubEvents() {
                        this.on(i.eventChangeSelectedDate, this._onChangeSelectedDate), this.on(i.eventChangeFocusDate, this._onChangeFocusedDate), this.on(i.eventChangeTime, this._onChangeTime);
                    }
                },
                {
                    key: "_buildBaseHtml",
                    value: function _buildBaseHtml() {
                        var _this_opts = this.opts, e = _this_opts.inline;
                        var t, i;
                        this.elIsInput ? e ? (t = this.$datepicker, (i = this.$el).parentNode.insertBefore(t, i.nextSibling)) : this.$container.appendChild(this.$datepicker) : this.$el.appendChild(this.$datepicker), this.$datepicker.innerHTML = '<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>', this.$content = a(".air-datepicker--content", this.$datepicker), this.$pointer = a(".air-datepicker--pointer", this.$datepicker), this.$nav = a(".air-datepicker--navigation", this.$datepicker);
                    }
                },
                {
                    key: "_handleLocale",
                    value: function _handleLocale() {
                        var _this_opts = this.opts, e = _this_opts.locale, t = _this_opts.dateFormat, i = _this_opts.firstDay, s = _this_opts.timepicker, a = _this_opts.onlyTimepicker, n = _this_opts.timeFormat, r = _this_opts.dateTimeSeparator;
                        var o;
                        this.locale = (o = e, JSON.parse(JSON.stringify(o))), t && (this.locale.dateFormat = t), void 0 !== n && "" !== n && (this.locale.timeFormat = n);
                        var _this_locale = this.locale, h = _this_locale.timeFormat;
                        if ("" !== i && (this.locale.firstDay = i), s && "function" != typeof t) {
                            var e1 = h ? r : "";
                            this.locale.dateFormat = [
                                this.locale.dateFormat,
                                h || ""
                            ].join(e1);
                        }
                        a && "function" != typeof t && (this.locale.dateFormat = this.locale.timeFormat);
                    }
                },
                {
                    key: "_setPositionClasses",
                    value: function _setPositionClasses(e) {
                        var _this_$datepicker_classList;
                        if ("function" == typeof e) return void this.$datepicker.classList.add("-custom-position-");
                        var t = (e = e.split(" "))[0], i = "air-datepicker -".concat(t, "-").concat(e[1], "- -from-").concat(t, "-");
                        (_this_$datepicker_classList = this.$datepicker.classList).add.apply(_this_$datepicker_classList, (0, $2b6Uo._)(i.split(" ")));
                    }
                },
                {
                    key: "_bindEvents",
                    value: function _bindEvents() {
                        this.$el.addEventListener(this.opts.showEvent, this._onFocus), this.$el.addEventListener("blur", this._onBlur), this.$datepicker.addEventListener("mousedown", this._onMouseDown), this.$datepicker.addEventListener("mouseup", this._onMouseUp), window.addEventListener("resize", this._onResize);
                    }
                },
                {
                    key: "_limitViewDateByMaxMinDates",
                    value: function _limitViewDateByMaxMinDates() {
                        var _this = this, e = _this.viewDate, t = _this.minDate, i = _this.maxDate;
                        i && m(e, i) && this.setViewDate(i), t && v(e, t) && this.setViewDate(t);
                    }
                },
                {
                    key: "formatDate",
                    value: function formatDate() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.viewDate, t = arguments.length > 1 ? arguments[1] : void 0;
                        if (e = b(e), !(e instanceof Date)) return;
                        var i = t, s = this.locale, a = h(e), n = a.dayPeriod, r = c(e), o = R.replacer, l = {
                            T: e.getTime(),
                            m: a.minutes,
                            mm: a.fullMinutes,
                            h: a.hours12,
                            hh: a.fullHours12,
                            H: a.hours,
                            HH: a.fullHours,
                            aa: n,
                            AA: n.toUpperCase(),
                            E: s.daysShort[a.day],
                            EEEE: s.days[a.day],
                            d: a.date,
                            dd: a.fullDate,
                            M: a.month + 1,
                            MM: a.fullMonth,
                            MMM: s.monthsShort[a.month],
                            MMMM: s.months[a.month],
                            yy: a.year.toString().slice(-2),
                            yyyy: a.year,
                            yyyy1: r[0],
                            yyyy2: r[1]
                        };
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries(l)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $iFZdg._)(_step.value, 2), e1 = _step_value[0], t1 = _step_value[1];
                                i = o(i, k(e1), t1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return i;
                    }
                },
                {
                    key: "down",
                    value: function down(e) {
                        this._handleUpDownActions(e, "down");
                    }
                },
                {
                    key: "up",
                    value: function up(e) {
                        this._handleUpDownActions(e, "up");
                    }
                },
                {
                    key: "selectDate",
                    value: function selectDate(e) {
                        var _this = this;
                        var t, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _this1 = this, a = _this1.currentView, n = _this1.parsedViewDate, r = _this1.selectedDates, o = s.updateTime, _this_opts = this.opts, h = _this_opts.moveToOtherMonthsOnSelect, l = _this_opts.moveToOtherYearsOnSelect, d = _this_opts.multipleDates, c = _this_opts.range, u = _this_opts.autoClose, p = _this_opts.onBeforeSelect, v = r.length;
                        if (Array.isArray(e)) return e.forEach(function(e) {
                            _this.selectDate(e, s);
                        }), new Promise(function(e) {
                            setTimeout(e);
                        });
                        if ((e = b(e)) instanceof Date) {
                            if (p && !p({
                                date: e,
                                datepicker: this
                            })) return Promise.resolve();
                            if (a === i.days && e.getMonth() !== n.month && h && (t = new Date(e.getFullYear(), e.getMonth(), 1)), a === i.years && e.getFullYear() !== n.year && l && (t = new Date(e.getFullYear(), 0, 1)), t && this.setViewDate(t), d && !c) {
                                if (v === d) return;
                                this._checkIfDateIsSelected(e) || r.push(e);
                            } else if (c) switch(v){
                                case 1:
                                    r.push(e), this.rangeDateTo || (this.rangeDateTo = e), m(this.rangeDateFrom, this.rangeDateTo) && (this.rangeDateTo = this.rangeDateFrom, this.rangeDateFrom = e), this.selectedDates = [
                                        this.rangeDateFrom,
                                        this.rangeDateTo
                                    ];
                                    break;
                                case 2:
                                    this.selectedDates = [
                                        e
                                    ], this.rangeDateFrom = e, this.rangeDateTo = "";
                                    break;
                                default:
                                    this.selectedDates = [
                                        e
                                    ], this.rangeDateFrom = e;
                            }
                            else this.selectedDates = [
                                e
                            ];
                            return this.trigger(i.eventChangeSelectedDate, {
                                action: i.actionSelectDate,
                                silent: null == s ? void 0 : s.silent,
                                date: e,
                                updateTime: o
                            }), this._updateLastSelectedDate(e), u && !this.timepickerIsActive && this.visible && (d || c ? c && 1 === v && this.hide() : this.hide()), new Promise(function(e) {
                                setTimeout(e);
                            });
                        }
                    }
                },
                {
                    key: "unselectDate",
                    value: function unselectDate(e) {
                        var _this = this;
                        var t = this.selectedDates, s = this;
                        if ((e = b(e)) instanceof Date) return t.some(function(a, n) {
                            if (p(a, e)) return t.splice(n, 1), s.selectedDates.length ? (s.rangeDateTo = "", s.rangeDateFrom = t[0], s._updateLastSelectedDate(s.selectedDates[s.selectedDates.length - 1])) : (s.rangeDateFrom = "", s.rangeDateTo = "", s._updateLastSelectedDate(!1)), _this.trigger(i.eventChangeSelectedDate, {
                                action: i.actionUnselectDate,
                                date: e
                            }), !0;
                        });
                    }
                },
                {
                    key: "replaceDate",
                    value: function replaceDate(e, t) {
                        var _this = this;
                        var s = this.selectedDates.find(function(t) {
                            return p(t, e, _this.currentView);
                        }), a = this.selectedDates.indexOf(s);
                        a < 0 || p(this.selectedDates[a], t, this.currentView) || (this.selectedDates[a] = t, this.trigger(i.eventChangeSelectedDate, {
                            action: i.actionSelectDate,
                            date: t,
                            updateTime: !0
                        }), this._updateLastSelectedDate(t));
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return this.selectedDates = [], this.rangeDateFrom = !1, this.rangeDateTo = !1, this.lastSelectedDate = !1, this.trigger(i.eventChangeSelectedDate, {
                            action: i.actionUnselectDate,
                            silent: e.silent
                        }), new Promise(function(e) {
                            setTimeout(e);
                        });
                    }
                },
                {
                    key: "show",
                    value: function show() {
                        var _this_opts = this.opts, e = _this_opts.onShow, t = _this_opts.isMobile;
                        this._cancelScheduledCall(), this.visible || this.hideAnimation || this._createComponents(), this.setPosition(this.opts.position), this.$datepicker.classList.add("-active-"), this.visible = !0, e && this._scheduleCallAfterTransition(e), t && this._showMobileOverlay();
                    }
                },
                {
                    key: "hide",
                    value: function hide() {
                        var _this = this;
                        var _this_opts = this.opts, e = _this_opts.onHide, t = _this_opts.isMobile, i = this._hasTransition();
                        this.visible = !1, this.hideAnimation = !0, this.$datepicker.classList.remove("-active-"), this.customHide && this.customHide(), this.elIsInput && this.$el.blur(), this._scheduleCallAfterTransition(function(t) {
                            !_this.customHide && (t && i || !t && !i) && _this._finishHide(), e && e(t);
                        }), t && j.classList.remove("-active-");
                    }
                },
                {
                    key: "_triggerOnSelect",
                    value: function _triggerOnSelect() {
                        var _this = this;
                        var e = [], t = [], _this1 = this, i = _this1.selectedDates, s = _this1.locale, _this_opts = _this1.opts, a = _this_opts.onSelect, n = _this_opts.multipleDates, r = _this_opts.range, o = n || r, h = "function" == typeof s.dateFormat;
                        i.length && (e = i.map(g), t = h ? n ? s.dateFormat(e) : e.map(function(e) {
                            return s.dateFormat(e);
                        }) : e.map(function(e) {
                            return _this.formatDate(e, s.dateFormat);
                        })), a({
                            date: o ? e : e[0],
                            formattedDate: o ? t : t[0],
                            datepicker: this
                        });
                    }
                },
                {
                    key: "_handleAlreadySelectedDates",
                    value: function _handleAlreadySelectedDates(e, t) {
                        var _this = this, i = _this.selectedDates, s = _this.rangeDateFrom, a = _this.rangeDateTo, _this_opts = this.opts, n = _this_opts.range, r = _this_opts.toggleSelected, o = i.length, h = "function" == typeof r ? r({
                            datepicker: this,
                            date: t
                        }) : r, l = Boolean(n && 1 === o && e), d = l ? g(t) : t;
                        n && !h && (2 !== o && this.selectDate(d), 2 === o && p(s, a)) || (h ? this.unselectDate(d) : this._updateLastSelectedDate(l ? d : e));
                    }
                },
                {
                    key: "_handleUpDownActions",
                    value: function _handleUpDownActions(e, t) {
                        if (!((e = b(e || this.focusDate || this.viewDate)) instanceof Date)) return;
                        var i = "up" === t ? this.viewIndex + 1 : this.viewIndex - 1;
                        i > 2 && (i = 2), i < 0 && (i = 0), this.setViewDate(new Date(e.getFullYear(), e.getMonth(), 1)), this.setCurrentView(this.viewIndexes[i]);
                    }
                },
                {
                    key: "getCell",
                    value: function getCell(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.day;
                        if (!((e = b(e)) instanceof Date)) return;
                        var _obj;
                        var _h = h(e), s = _h.year, a = _h.month, n = _h.date, r = '[data-year="'.concat(s, '"]'), o = '[data-month="'.concat(a, '"]'), l = (_obj = {}, (0, $9HFeY._)(_obj, i.day, "".concat(r).concat(o, '[data-date="').concat(n, '"]')), (0, $9HFeY._)(_obj, i.month, "".concat(r).concat(o)), (0, $9HFeY._)(_obj, i.year, "".concat(r)), _obj);
                        return this.views[this.currentView] ? this.views[this.currentView].$el.querySelector(l[t]) : void 0;
                    }
                },
                {
                    key: "_showMobileOverlay",
                    value: function _showMobileOverlay() {
                        j.classList.add("-active-");
                    }
                },
                {
                    key: "_hasTransition",
                    value: function _hasTransition() {
                        return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce(function(e, t) {
                            return parseFloat(t) + e;
                        }, 0) > 0;
                    }
                },
                {
                    key: "shouldUpdateDOM",
                    get: function get() {
                        return this.visible || this.treatAsInline;
                    }
                },
                {
                    key: "parsedViewDate",
                    get: function get() {
                        return h(this.viewDate);
                    }
                },
                {
                    key: "currentViewSingular",
                    get: function get() {
                        return this.currentView.slice(0, -1);
                    }
                },
                {
                    key: "curDecade",
                    get: function get() {
                        return c(this.viewDate);
                    }
                },
                {
                    key: "viewIndex",
                    get: function get() {
                        return this.viewIndexes.indexOf(this.currentView);
                    }
                },
                {
                    key: "isFinalView",
                    get: function get() {
                        return this.currentView === i.years;
                    }
                },
                {
                    key: "hasSelectedDates",
                    get: function get() {
                        return this.selectedDates.length > 0;
                    }
                },
                {
                    key: "isMinViewReached",
                    get: function get() {
                        return this.currentView === this.opts.minView || this.currentView === i.days;
                    }
                },
                {
                    key: "$container",
                    get: function get() {
                        return this.$customContainer || P;
                    }
                }
            ], [
                {
                    key: "buildGlobalContainer",
                    value: function buildGlobalContainer(e) {
                        B = !0, P = n({
                            className: e,
                            id: e
                        }), a("body").appendChild(P);
                    }
                },
                {
                    key: "replacer",
                    value: function replacer(e, t, i) {
                        return e.replace(t, function(e, t, s, a) {
                            return t + i + a;
                        });
                    }
                }
            ]);
            return R;
        }();
        var K;
        return I(R, "defaults", s), I(R, "version", "3.5.3"), I(R, "defaultGlobalContainerId", "air-datepicker-global-container"), K = R.prototype, Object.assign(K, N), t.default;
    }();
});


var $2e7aed713c3af4d2$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cebce4497d6d3992$exports)));


var $ae0a936efac55537$exports = {};
"use strict";
Object.defineProperty($ae0a936efac55537$exports, "__esModule", {
    value: true
});
$ae0a936efac55537$exports.default = void 0;
var $ae0a936efac55537$var$_default = {
    days: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ],
    daysShort: [
        'Son',
        'Mon',
        'Die',
        'Mit',
        'Don',
        'Fre',
        'Sam'
    ],
    daysMin: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    months: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ],
    monthsShort: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    today: 'Heute',
    clear: "L\xf6schen",
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
};
$ae0a936efac55537$exports.default = $ae0a936efac55537$var$_default;


document.querySelectorAll('[data-element-type="DatePicker"]').forEach(function(el) {
    console.debug('initialising datepicker with format', el.dataset.elementDatepickerDateFormat);
    new (0, $2e7aed713c3af4d2$export$2e2bcd8739ae039)(el, {
        locale: (0, (/*@__PURE__*/$parcel$interopDefault($ae0a936efac55537$exports))),
        dateFormat: el.dataset.elementDatepickerDateFormat,
        minDate: el.dataset.future === '1' ? new Date() : ''
    });
});


 // import "../node_modules/flickity/dist/flickity.pkgd";

})();
//# sourceMappingURL=modules.js.map
